/**
 * Drawer Builder Legacy (extracted from drawerFunction.liquid)
 *
 * Notes:
 * - Requires jQuery + jQuery UI + touch-punch (loaded on the drawer-builder page)
 * - Debug logs are gated via window.MD_DEBUG_BUILDER === true
 */
(function (start) {
  if (window.MD_CATALOGUE_READY) window.MD_CATALOGUE_READY.then(start);
  else start();
})(function () {
  'use strict';

  function mdT(key, variables) {
    return (window.FoxTheme && window.FoxTheme.i18n && window.FoxTheme.i18n.t)
      ? window.FoxTheme.i18n.t(key, variables)
      : key;
  }

  function mdFormatMoney(cents) {
    return (window.FoxTheme && window.FoxTheme.i18n && window.FoxTheme.i18n.formatMoney)
      ? window.FoxTheme.i18n.formatMoney(cents)
      : (Number(cents || 0) / 100).toFixed(2);
  }

  function mdRoot(path) {
    var root = (window.FoxTheme && window.FoxTheme.i18n && window.FoxTheme.i18n.rootUrl) || '/';
    return root.replace(/\/$/, '') + '/' + String(path || '').replace(/^\//, '');
  }

  // Builder geometry/breakpoint constants — sourced from window.MD_CONST
  // (assets/drawer-builder-constants.js, loaded first) with literal fallbacks
  // so a load-order miss can never change placement math. Keep each fallback
  // EQUAL to the constant (999/1000 sheet-band boundary): a stale fallback
  // would flip the 641-999px band to desktop behaviour in JS while the CSS
  // keeps the sheet layout. Pinned by tests/builder-resize-contract.test.js.
  var GRID_UNIT_MM = (window.MD_CONST && window.MD_CONST.GRID_UNIT_MM) || 29.5;
  var MOBILE_BREAKPOINT = (window.MD_CONST && window.MD_CONST.MOBILE_BREAKPOINT) || 999;
  var TTS_FEATURE = (window.MD_FEATURES && window.MD_FEATURES.true_to_size) || {};
  var TTS_SPEC = TTS_FEATURE.spec || 'tts-v2-c1.0';
  var TTS_CLEARANCE_MM = Number(TTS_FEATURE.clearanceMM) || 1;
  var TTS_GAP_THRESHOLD_MM = Number(TTS_FEATURE.gapThresholdMM) || 2;
  var TTS_MAX_DIMENSION_MM = (window.MD_CONST && window.MD_CONST.TTS_MAX_DIMENSION_MM) || 1416;
  var TTS_PANEL_MAX_CELLS = (window.MD_CONST && window.MD_CONST.TTS_PANEL_MAX_CELLS) || 7;
  var TTS_MAX_PANELS = (window.MD_CONST && window.MD_CONST.TTS_MAX_PANELS) || 30;

  function mdTtsExtensionMm(leftover) {
    if (!Number.isFinite(leftover) || leftover <= TTS_GAP_THRESHOLD_MM) return 0;
    return Math.max(0, leftover - TTS_CLEARANCE_MM);
  }

  function mdTtsEligibilityForDrawer(length, width) {
    if (typeof window.mdTtsEligibility === 'function') {
      return window.mdTtsEligibility(length, width, TTS_GAP_THRESHOLD_MM);
    }
    if (!Number.isFinite(length) || !Number.isFinite(width) || length < GRID_UNIT_MM || width < GRID_UNIT_MM) {
      return { eligible: false, reason: 'minimum_grid' };
    }
    if (length > TTS_MAX_DIMENSION_MM || width > TTS_MAX_DIMENSION_MM) {
      return { eligible: false, reason: 'max_dimension' };
    }
    var rows = Math.floor(length / GRID_UNIT_MM);
    var cols = Math.floor(width / GRID_UNIT_MM);
    if (Math.ceil(rows / TTS_PANEL_MAX_CELLS) * Math.ceil(cols / TTS_PANEL_MAX_CELLS) > TTS_MAX_PANELS) {
      return { eligible: false, reason: 'max_panels' };
    }
    var gapLength = length - rows * GRID_UNIT_MM;
    var gapWidth = width - cols * GRID_UNIT_MM;
    var eligible = Math.max(gapLength, gapWidth) > TTS_GAP_THRESHOLD_MM;
    return {
      eligible: eligible,
      reason: eligible ? null : 'gap_threshold'
    };
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    if (!document.body || !document.body.classList.contains('drawer-builder')) return;
    if (!window.jQuery) return;

    var $ = window.jQuery;

    // Keep the preferred fit separately from its availability at the current
    // dimensions. A temporary exact-grid size must not erase an explicit choice.
    function mdSetFitPreference(fit, source) {
      $('body').attr('data-fit-preference', fit)
        .attr('data-fit-preference-source', source);
    }
    function mdSyncFitPreference(eligible) {
      var available = eligible && $('#db-true-to-size').length > 0 &&
        $('body').attr('data-ikea-maximera') !== 'yes';
      var fitted = available && $('body').attr('data-fit-preference') === 'true-to-size';
      $('#db-true-to-size').prop('checked', Boolean(fitted));
      $('body').attr('data-true-to-size', fitted ? 'yes' : 'no')
        .attr('data-fit-choice-source', available
          ? $('body').attr('data-fit-preference-source') : 'unavailable');
    }
    // Old hashes without tts=1 mean Standard, including size-only bookmarks.
    // Read this before the initial grid refresh or any URL rewrite can run.
    var initialFitHash = (window.location.hash || '').replace(/^#/, '');
    var restoresFit = /^\d+(?:\.\d+)?x\d+(?:\.\d+)?(?:&|$)/.test(initialFitHash);
    mdSetFitPreference(restoresFit
      ? (initialFitHash.split('&').indexOf('tts=1') !== -1 ? 'true-to-size' : 'standard')
      : 'true-to-size', restoresFit ? 'restored' : 'default');
    window.MD_setFitPreference = mdSetFitPreference;

    var MD_DEBUG_BUILDER = window.MD_DEBUG_BUILDER === true;
    var log = MD_DEBUG_BUILDER && window.console && console.log ? console.log.bind(console) : function () {};
    var warn = MD_DEBUG_BUILDER && window.console && console.warn ? console.warn.bind(console) : function () {};
    var debug = MD_DEBUG_BUILDER && window.console && console.debug ? console.debug.bind(console) : function () {};

    function setDimensionErrors(lengthInvalid, widthInvalid) {
      $('#length-error').toggleClass('is-visible', lengthInvalid);
      $('#width-error').toggleClass('is-visible', widthInvalid);
      $('input[name="length"]').attr('aria-invalid', lengthInvalid ? 'true' : 'false');
      $('input[name="width"]').attr('aria-invalid', widthInvalid ? 'true' : 'false');
    }

  let count = 0; // Ensure count starts at 0
    var productImageTracker = {};
    var defaultLength = 413;
    var defaultWidth = 400; // load 413x400 by default

    // ---- Build UUID (record identity, additive) ----
    // A `?bid=<uuid>` query param on the builder URL identifies the saved
    // build this session started from (saved-build links in md-favourites.js
    // carry it). At add-to-cart the uuid is stamped onto the cart as the
    // private attribute __drawer_build_uuid_<buildId> so the order carries
    // the identity through to internal-tools. It NEVER rides inside the
    // #hash (the hash grammar has no metadata slot) and NEVER becomes a
    // line property (properties are the _build_id merge surface).
    function newBuildUuid() {
      try {
        if (window.crypto && typeof window.crypto.randomUUID === 'function') {
          return window.crypto.randomUUID();
        }
      } catch (_) { /* fall through to the polyfill */ }
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0;
        var v = c === 'x' ? r : ((r & 0x3) | 0x8);
        return v.toString(16);
      });
    }
    var UUID_V4_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    var sourceBuildUuid = (function () {
      try {
        var m = /(?:^|[?&])bid=([0-9a-fA-F-]{36})/.exec(window.location.search);
        if (m && UUID_V4_RE.test(m[1])) return m[1].toLowerCase();
      } catch (_) { /* no usable query param */ }
      return null;
    })();

    // ---- AI Layout run (record identity, additive) ----
    // The AI Layout Creator opens the builder with `?ai=<requestUuid>`, the
    // run whose layout this is. At add-to-cart it is stamped on the cart as
    // the private attribute __drawer_ai_request_<buildId>, so internal-tools
    // can tie the order to the run and its eval case: what the AI proposed
    // next to what the customer paid for. Like ?bid it stays in the query
    // string (createURL keeps it across reloads), never in the #hash and
    // never as a line property; share links drop it (MD_SHARE_STRIP_PARAM).
    // md-ai-request-start
    var MD_AI_REQUEST_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
    function mdAiRequestFromSearch(search) {
      var m = /(?:^|[?&])ai=([^&#]*)/.exec(search || '');
      if (!m) return null;
      var value;
      try { value = decodeURIComponent(m[1]).trim().toLowerCase(); } catch (e) { return null; }
      return MD_AI_REQUEST_RE.test(value) ? value : null;
    }
    function mdAiOptionFromSearch(search) {
      var set = /(?:^|[?&])ai_set=([^&#]*)/.exec(search || '');
      var option = /(?:^|[?&])ai_option=(essentialist|maximiser|use-case)(?:&|$)/.exec(search || '');
      if (!mdAiRequestFromSearch(search) || !set || !option || !MD_AI_REQUEST_RE.test(set[1])) return null;
      return set[1] + ':' + option[1];
    }
    // md-ai-request-end
    var sourceAiOption = mdAiOptionFromSearch(window.location.search);
    var sourceAiRequest = (function () {
      try { return mdAiRequestFromSearch(window.location.search); } catch (_) { return null; }
    })();

  $('input[name="length"]').attr('data-original', defaultLength);
  $('input[name="width"]').attr('data-original', defaultWidth);
  
    $('input[name="length"]').val(defaultLength);
    $('input[name="width"]').val(defaultWidth);

  // Ensure drawerBundle sizing attrs exist before the first product click.
  // Without this, drawerWidth/drawerLength can be NaN and placement will always fail.
  setTimeout(function () {
    try { updateGridInfo(); } catch (e) { warn('initial updateGridInfo failed', e); }
  }, 0);

  // =========================================================================
  // WINDOW RESIZE HANDLING
  // =========================================================================
  // When the window resizes, the canvas width changes but items remain at
  // stale pixel positions. This causes items to overflow, misalign with the
  // grid, or appear in wrong positions. We debounce the resize to avoid
  // excessive recalculations during drag.
  // =========================================================================

  var resizeDebounceTimer = null;
  var lastKnownCellSize = 0;
  // Last innerWidth seen while in the sheet-layout band (<= MOBILE_BREAKPOINT).
  // null whenever we are in the desktop band, so crossing desktop -> sheet
  // (tablet rotation to portrait) always counts as a width change. Seeded at
  // parse time so the first height-only resize (URL bar) stays inert.
  var lastMobileLayoutWidth = window.innerWidth <= MOBILE_BREAKPOINT ? window.innerWidth : null;

  /**
   * Get the current cell size from the drawerBundle attribute.
   * This is the source of truth set by updateGridInfo().
   */
  function getCurrentCellSize() {
    return parseInt($('.drawerBundle').attr('width')) || 0;
  }

  /**
   * Rescale and reposition all items on the canvas when the window resizes.
   * This is similar to rescaleAndRepositionItems in the Apply handler,
   * but specifically for window resize scenarios.
   */
  function rescaleItemsOnResize(oldCellSize, newCellSize) {
    if (!oldCellSize || !newCellSize || oldCellSize === newCellSize) {
      return;
    }

    var $droppable = $('.droppable-area1');
    if (!$droppable.length) return;

    // Get grid bounds (in blocks) for clamping
    var gridWidthBlocks = parseInt($('body').attr('grid-width')) || 0;
    var gridLengthBlocks = parseInt($('body').attr('grid-length')) || 0;

    log('[DrawerBuilder] Rescaling items on resize:', {
      oldCellSize: oldCellSize,
      newCellSize: newCellSize,
      gridW: gridWidthBlocks,
      gridH: gridLengthBlocks
    });

    $droppable.find('.draggable-item').each(function() {
      var $item = $(this);

      // Get current pixel positions
      var topPx = parseInt($item.css('top')) || 0;
      var leftPx = parseInt($item.css('left')) || 0;

      // Convert to block positions using the OLD cell size
      var topBlocks = Math.round(topPx / oldCellSize);
      var leftBlocks = Math.round(leftPx / oldCellSize);

      // Preserve the LIVE oriented footprint. `pro-length` / `pro-width`
      // describe the catalogue product orientation and therefore need a
      // rotation swap for manually placed items. Older share URLs, however,
      // restored those attrs from already-oriented h/w values, so applying the
      // swap again could turn a restored 4x2 into 2x4 on the next resize.
      // Pixel footprint / oldCell is unambiguous for both origins.
      var itemWidthBlocks = Math.max(1, Math.round((parseFloat($item.css('width')) || oldCellSize) / oldCellSize));
      var itemHeightBlocks = Math.max(1, Math.round((parseFloat($item.css('height')) || oldCellSize) / oldCellSize));
      var isRotated = $item.hasClass('rotated');

      // Clamp position to keep item within grid bounds
      // (prevents items from going outside the canvas after resize)
      if (gridWidthBlocks > 0 && gridLengthBlocks > 0) {
        var maxLeftBlocks = Math.max(0, gridWidthBlocks - itemWidthBlocks);
        var maxTopBlocks = Math.max(0, gridLengthBlocks - itemHeightBlocks);
        leftBlocks = Math.max(0, Math.min(leftBlocks, maxLeftBlocks));
        topBlocks = Math.max(0, Math.min(topBlocks, maxTopBlocks));
      }

      // Calculate new pixel values using the NEW cell size
      var newWidth = itemWidthBlocks * newCellSize;
      var newHeight = itemHeightBlocks * newCellSize;
      var newLeft = leftBlocks * newCellSize;
      var newTop = topBlocks * newCellSize;

      // Apply new dimensions and positions
      $item.css({
        width: newWidth,
        height: newHeight,
        left: newLeft,
        top: newTop
      });

      // Resize inner image div to match rotation logic from addItem()
      // - `.rotated` uses CSS rotate(-90deg) on the inner div
      // - therefore the inner div must have swapped dimensions so that AFTER rotation it fits the li
      var $inner = $item.children('div').first();
      if ($inner && $inner.length) {
        var innerW = isRotated ? newHeight : newWidth;
        var innerH = isRotated ? newWidth : newHeight;
        $inner.css({
          width: innerW,
          height: innerH,
          'background-size': '100% 100%',  // Force fill both dimensions
          'background-position': 'center center',
          'background-repeat': 'no-repeat'
        });
      }
    });
  }

  /**
   * Force recalculate grid dimensions based on current viewport.
   * This bypasses the input-change logic in updateGridInfo() and directly
   * recalculates based on available space.
   */
  function forceRecalculateGrid() {
    var $canvasWrapper = $('.fs-canvas__space .canvas-wrapper');
    var $droppable = $('.droppable-area1');
    var $drawerBundle = $('.drawerBundle');
    
    if (!$canvasWrapper.length || !$droppable.length || !$drawerBundle.length) {
      return null;
    }

    // Get current grid dimensions in blocks (from body attributes set by updateGridInfo)
    var gridWidthBlocks = parseInt($('body').attr('grid-width')) || 0;
    var gridLengthBlocks = parseInt($('body').attr('grid-length')) || 0;
    
    if (!gridWidthBlocks || !gridLengthBlocks) {
      return null;
    }

    // Measure available space
    var totalWidth = $canvasWrapper.width();
    var isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
    if (isMobile) {
      // Same stable-ancestor derivation as updateGridInfo(): in the sheet
      // band the canvas-wrapper's width follows its own content, so a
      // recalc would re-derive the previous cell.
      var $bundleW = $('.drawer-parent-wrapper > .grid-wrapper .drawerBundle');
      var $spaceW = $('.drawerBundle .fs-canvas__space');
      var sidePads = $spaceW.length
        ? (parseFloat($spaceW.css('padding-left')) || 0) + (parseFloat($spaceW.css('padding-right')) || 0)
        : 0;
      var bundleAvail = ($bundleW.length ? ($bundleW[0].clientWidth || 0) : 0) - sidePads;
      if (bundleAvail > 0) {
        totalWidth = bundleAvail;
      }
    }
    var horizontalCell = totalWidth / gridWidthBlocks;

    // Both axes contribute (Phase 2): mobile uses proportional cap,
    // desktop measures bundle height. See updateGridInfo() for
    // detailed rationale.
    var verticalCell = 32; // fallback

    if (!isMobile) {
      var $bundle = $('.drawer-parent-wrapper > .grid-wrapper .drawerBundle');
      var $space = $('.drawerBundle .fs-canvas__space');
      var bundleHeight = ($bundle && $bundle.length) ? ($bundle.height() || 0) : 0;
      var bottomPad = ($space && $space.length) ? (parseFloat($space.css('padding-bottom')) || 0) : 0;
      var usableHeight = Math.max(0, bundleHeight - bottomPad - 8);
      if (gridLengthBlocks > 0 && usableHeight > 0) {
        verticalCell = usableHeight / gridLengthBlocks;
      }
    } else {
      // Phase 2 mobile: proportional cap = (defaultBlocks × hCell) / lengthBlocks.
      // Mirrors updateGridInfo() so both code paths agree.
      var DEFAULT_LENGTH_BLOCKS = Math.floor(defaultLength / GRID_UNIT_MM) || 14;
      if (gridLengthBlocks > 0 && horizontalCell > 0) {
        verticalCell = (DEFAULT_LENGTH_BLOCKS * horizontalCell) / gridLengthBlocks;
      } else {
        verticalCell = horizontalCell;
      }
    }

    // Phase 2: always Math.min both axes (no mobile ternary).
    var newCellSize = Math.min(horizontalCell, verticalCell);
    newCellSize = Math.max(6, Math.floor(newCellSize));

    // Update drawerBundle attributes
    $drawerBundle.attr('width', newCellSize);
    $drawerBundle.attr('length', newCellSize);

    // Update droppable area dimensions
    var totalHorizontalSpace = newCellSize * gridWidthBlocks;
    var totalVerticalSpace = newCellSize * gridLengthBlocks;
    
    $droppable.css({
      width: totalHorizontalSpace,
      height: totalVerticalSpace
    });

    // Update grid background
    $('.fs-canvas__canvas').css({
      'background-size': newCellSize + 'px ' + newCellSize + 'px'
    });

    // Update bottom board width
    var $space = $('.drawerBundle .fs-canvas__space');
    if ($space.length && totalHorizontalSpace > 0) {
      var bottomHeight = parseFloat($space.css('padding-bottom')) || 68;
      $space.css('background-size', totalHorizontalSpace + 'px ' + bottomHeight + 'px');
    }

    log('[DrawerBuilder] forceRecalculateGrid:', {
      gridW: gridWidthBlocks,
      gridH: gridLengthBlocks,
      cellSize: newCellSize,
      totalW: totalHorizontalSpace,
      totalH: totalVerticalSpace
    });

    return newCellSize;
  }

  /**
   * Handle window resize by recalculating grid and repositioning items.
   * This is debounced to avoid excessive recalculations during resize drag.
   */
  function handleWindowResize() {
    if (window.innerWidth <= MOBILE_BREAKPOINT) {
      // Sheet-layout band. HEIGHT-only resizes (URL bar / scroll chrome /
      // keyboard) must stay inert — re-running sizing on them is the
      // #59-#67 feedback class. But a real WIDTH change (tablet rotation,
      // split view, a desktop window dragged across the 999px boundary)
      // must re-run the discrete sizing path, or the canvas keeps the
      // previous band's pixel sizes until the user presses Apply.
      var mobileWidth = window.innerWidth;
      if (mobileWidth === lastMobileLayoutWidth) {
        return;
      }
      lastMobileLayoutWidth = mobileWidth;
      var oldMobileCell = getCurrentCellSize();
      try { updateGridInfo(); } catch (e) { warn('mobile width-resize updateGridInfo failed', e); }
      var newMobileCell = getCurrentCellSize();
      if (oldMobileCell && newMobileCell && newMobileCell !== oldMobileCell) {
        rescaleItemsOnResize(oldMobileCell, newMobileCell);
      }
      if (typeof window.MD_updateMobileSheetPeek === 'function') {
        window.MD_updateMobileSheetPeek();
      }
      return;
    }
    // Desktop band: clear the sheet-band width memory so rotating back into
    // the sheet layout is treated as a width change.
    lastMobileLayoutWidth = null;

    // Capture the OLD cell size before recalculating
    var oldCellSize = getCurrentCellSize();
    if (!oldCellSize) {
      // Grid not yet initialized, just update and return
      try { updateGridInfo(); } catch (e) { warn('resize updateGridInfo failed', e); }
      return;
    }

    // Store for comparison
    lastKnownCellSize = oldCellSize;

    // Force recalculate grid dimensions based on new viewport
    var newCellSize = forceRecalculateGrid();
    
    if (!newCellSize) {
      // Fallback to updateGridInfo if forceRecalculate fails
      try { updateGridInfo(); } catch (e) { warn('resize updateGridInfo failed', e); }
      newCellSize = getCurrentCellSize();
    }

    // Rescale items if cell size changed
    if (newCellSize && newCellSize !== oldCellSize) {
      rescaleItemsOnResize(oldCellSize, newCellSize);
      log('[DrawerBuilder] Window resize handled:', { oldCellSize: oldCellSize, newCellSize: newCellSize });

      // Update the URL with new positions (debounced to avoid rapid URL updates)
      // This ensures sharing the layout after resize captures the correct state
      try {
        if (typeof createURL === 'function') {
          setTimeout(function() { createURL(); }, 100);
        }
      } catch (e) {
        // createURL may not be defined yet during early initialization
      }
    }
  }

  /**
   * Debounced resize handler to avoid excessive recalculations.
   */
  function debouncedResizeHandler() {
    if (resizeDebounceTimer) {
      clearTimeout(resizeDebounceTimer);
    }
    resizeDebounceTimer = setTimeout(function() {
      resizeDebounceTimer = null;
      handleWindowResize();
    }, 150); // 150ms debounce - fast enough to feel responsive, slow enough to avoid jitter
  }

  // Attach resize listener
  window.addEventListener('resize', debouncedResizeHandler);

  // Also handle orientation change for tablets/mobile in landscape
  window.addEventListener('orientationchange', function() {
    // Orientation change needs a longer delay as the viewport takes time to settle
    setTimeout(debouncedResizeHandler, 300);
  });

  // Expose for debugging
  if (MD_DEBUG_BUILDER) {
    window.MD_BUILDER_RESIZE = {
      handleWindowResize: handleWindowResize,
      rescaleItemsOnResize: rescaleItemsOnResize,
      getCurrentCellSize: getCurrentCellSize,
      forceRecalculateGrid: forceRecalculateGrid
    };
  }

  // // // Working code 24-3-25
    function updateGridInfo() {
      // Get user inputs
      var inputLength = $('input[name="length"]').val(); // Vertical control
      var inputWidth = $('input[name="width"]').val(); // Horizontal control

      var currentScrollPosition = window.scrollY;

      var currentLength = parseInt($('input[name="length"]').attr('data-original')) || defaultLength;
      var currentWidth = parseInt($('input[name="width"]').attr('data-original')) || defaultWidth;
      var newLength = parseInt($('input[name="length"]').val()) || 0;
      var newWidth = parseInt($('input[name="width"]').val()) || 0;
      
      // Correctly assign grid dimensions
      var gridLength = inputLength / GRID_UNIT_MM; // Vertical distance controlled by 'length'
      var gridWidth = inputWidth / GRID_UNIT_MM; // Horizontal distance controlled by 'width'

      // Clamp to >= 1 whole block. A blank/0/sub-block input otherwise
      // makes gridWidth 0, and `totalWidth / parseInt(0)` is Infinity
      // (or NaN) -> poisons boxSize / totalHorizontalSpace /
      // totalVerticalSpace and collapses the canvas to 0x0. The float
      // gridLength/gridWidth are still used verbatim below for the mm
      // display labels, so the shown dimensions are unchanged.
      var lenBlocks = Math.max(1, Math.floor(gridLength) || 0);
      var widBlocks = Math.max(1, Math.floor(gridWidth) || 0);

      // Only write the body grid-* attrs when the block count actually
      // changed. They are observed by drawer-builder.js (getGridState +
      // a MutationObserver that re-runs the layout filter), so a no-op
      // resize should not trigger needless filter work.
      if (parseInt($('body').attr('grid-length'), 10) !== lenBlocks) {
        $('body').attr("grid-length", lenBlocks);
      }
      if (parseInt($('body').attr('grid-width'), 10) !== widBlocks) {
        $('body').attr("grid-width", widBlocks);
      }

      // True-to-size gating: require a meaningful wall gap and keep the build
      // inside the shared per-axis / panel-count fulfilment budget. Otherwise
      // hide the toggle and force the choice off so a resize cannot leave a
      // stale "yes" that the geometry planner cannot dispatch.
      // Gate on the CONFIRMED dims (data-original) — the same source the
      // add-to-cart capture uses — not .val(): a typed-but-unapplied size
      // reaching here via window resize must not reveal a fit that won't be
      // ordered. Every Apply branch persists data-original before calling
      // updateGridInfo(), so the gate is never one apply behind.
      var confirmedL = parseFloat($('input[name="length"]').attr('data-original')) || parseFloat(inputLength) || 0;
      var confirmedW = parseFloat($('input[name="width"]').attr('data-original')) || parseFloat(inputWidth) || 0;
      var $ttsWrap = $('.db-true-to-size');
      var ttsEligibility = mdTtsEligibilityForDrawer(confirmedL, confirmedW);
      if (ttsEligibility.eligible) {
        $ttsWrap.prop('hidden', false);
      } else {
        $ttsWrap.prop('hidden', true);
      }
      mdSyncFitPreference(ttsEligibility.eligible);

      // Refresh the converted-size caption (footprint + leftover wall gap).
      updateConvertedReadout();
      updateSizeHint();
      if (typeof updateIkeaReadout === 'function') { updateIkeaReadout(); }
      if (window.innerWidth <= MOBILE_BREAKPOINT && typeof window.MD_updateMobileSheetPeek === 'function') {
        window.MD_updateMobileSheetPeek();
      }

      var totalWidth = $('.fs-canvas__space .canvas-wrapper').width();
      var isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
      if (isMobile) {
        // Sheet band: .canvas-wrapper's measured width follows its own
        // CONTENT (the already-sized droppable), so re-measuring it after
        // first paint just re-derives the previous cell — a width-resize or
        // rotation recalc would be a silent no-op. Derive the available
        // width from the stable ancestor instead: the drawerBundle's
        // client width minus the fs-canvas__space side paddings (the ruler
        // gutters). Deterministic and viewport-driven on every call.
        var $bundleW = $('.drawer-parent-wrapper > .grid-wrapper .drawerBundle');
        var $spaceW = $('.drawerBundle .fs-canvas__space');
        var sidePads = $spaceW.length
          ? (parseFloat($spaceW.css('padding-left')) || 0) + (parseFloat($spaceW.css('padding-right')) || 0)
          : 0;
        var bundleAvail = ($bundleW.length ? ($bundleW[0].clientWidth || 0) : 0) - sidePads;
        if (bundleAvail > 0) {
          totalWidth = bundleAvail;
        }
      }
      // Horizontal fit (existing logic)
      var horizontalCell = parseFloat(totalWidth / widBlocks) || 0;
      // Desktop: fit the grid to the *actual available* canvas container height.
      // This is critical now that the grid area is capped (so actions stay visible).
      var VERT_DEFAULT_CELL = 32; // fallback when measurement is unavailable
      var verticalCell = VERT_DEFAULT_CELL;
      if (!isMobile) {
        var lengthBlocks = Math.floor(gridLength) || 0;
        var $space = $('.drawerBundle .fs-canvas__space');
        // Prefer measuring the capped canvas container height (not the space itself),
        // otherwise the bottom frame (padding-bottom) can drift when the space is stretched.
        var $bundle = $('.drawer-parent-wrapper > .grid-wrapper .drawerBundle');
        var bundleHeight = ($bundle && $bundle.length) ? ($bundle.height() || 0) : 0;
        var bottomPad = ($space && $space.length) ? (parseFloat($space.css('padding-bottom')) || 0) : 0;
        // Fallback if bundle isn't measurable for any reason
        var spaceHeight = ($space && $space.length) ? ($space.height() || 0) : 0;
        var availableHeight = (bundleHeight > 0 ? (bundleHeight - bottomPad) : spaceHeight);
        var VERT_PADDING_PX = 8; // safety margin to avoid edge clipping
        var usableHeight = Math.max(0, availableHeight - VERT_PADDING_PX);
        if (lengthBlocks > 0 && usableHeight > 0) {
          verticalCell = usableHeight / lengthBlocks;
        }
      } else {
        // Mobile (Phase 2): cap drawer canvas at the DEFAULT drawer
        // height so the vertical pixel space stays constant as the
        // user changes L. Cells shrink for L > default; drawer height
        // stays equal to default-L × horizontalCell on whatever phone
        // is rendering.
        //
        // verticalCell = (defaultBlocks × hCell) / lengthBlocks
        //
        // Why proportional (defaultBlocks × hCell) and NOT a fixed
        // pixel constant: different phones have different
        // canvas-wrapper widths, so horizontalCell varies per phone.
        // A fixed-px cap would either not bind or bind unwanted on
        // wider/narrower phones. Proportional cap = exactly the
        // Phase 1 default-drawer height on every phone.
        //
        // FIXED-input formula (no viewport math) — deliberate.
        // Phase 2 reads ONLY horizontalCell. PRs #59-#67 broke
        // because they read window.innerHeight (visual viewport,
        // shrinks with URL bar), --db-sheet-peek-h (dynamically
        // mutated by updateMobileSheetPeek, feedback loop), or
        // .db-topbar.getBoundingClientRect (returns 0 at first
        // paint). Phase 2 has none of those inputs.
        var lengthBlocksMobile = Math.floor(gridLength) || 0;
        // Derive default lengthBlocks from `defaultLength` (line 33)
        // so the cap follows automatically if default L is changed.
        var DEFAULT_LENGTH_BLOCKS = Math.floor(defaultLength / GRID_UNIT_MM) || 14;
        if (lengthBlocksMobile > 0 && horizontalCell > 0) {
          verticalCell = (DEFAULT_LENGTH_BLOCKS * horizontalCell) / lengthBlocksMobile;

          // Fit-to-height cap: also bound the cell so the WHOLE drawer
          // fits in the band ABOVE the products sheet — no scroll. This
          // REPLACES the removed PR #202 .grid-wrapper scroll cap (a
          // div-grid canvas can't be CSS-shrunk, only its cell px).
          //
          // Loop-safety (the #59-#67 regression class): this reads
          // viewport vars, which is safe ONLY because on mobile
          // handleWindowResize() ignores height-only resizes (URL bar /
          // scroll chrome), so updateGridInfo() is NOT re-run on them —
          // only on discrete actions (initial load / Apply) and on real
          // WIDTH changes (rotation / split view), which do not
          // oscillate the way the URL bar does. It must
          // NEVER read --db-sheet-peek-h (mutated every gesture by
          // updateMobileSheetPeek -> that is the actual feedback loop).
          // Reserve a STATIC bottom-chrome budget: collapsed sheet peek
          // (grabber + colour row, ~MIN_PEEK 94) + the in-flow
          // selection-actions row (~44) + a gap, so the canvas never
          // reaches the sheet and Rotate/Remove stay uncovered.
          try {
            var rootCS = getComputedStyle(document.documentElement);
            var bodyCS = getComputedStyle(document.body);
            // Plain-px custom props ONLY. --db-top-offset is a
            // calc(var()+env()) custom property: getPropertyValue()
            // returns the literal "calc(...)" string, parseFloat -> NaN
            // -> 0 (the bug: top chrome never subtracted). It also omits
            // the L/W toolbar. --db-viewport-h / --db-cartbar-h ARE
            // plain px (set as "<n>px").
            var readPxVar = function (name) {
              return parseFloat(bodyCS.getPropertyValue(name))
                  || parseFloat(rootCS.getPropertyValue(name)) || 0;
            };
            var vpH = readPxVar('--db-viewport-h') || window.innerHeight || 0;
            // Top chrome (announcement banner + header + L/W toolbar):
            // read the EXISTING plain-px published var --db-topbar-bottom
            // (set by setMobileViewportVars() in drawer-builder-legacy.js
            // from the real .db-topbar getBoundingClientRect().bottom).
            // This is the SAME primitive the products-expanded panel
            // height already uses in CSS (search --db-topbar-bottom in
            // drawer-builder.css). Why this and NOT a measurement here:
            //  • --db-top-offset is a calc(var()+env()) custom property
            //    -> parseFloat = NaN -> 0 (the original bug), and it
            //    omits the L/W toolbar entirely.
            //  • Measuring an element's rect here is scroll-corrupted:
            //    the canvas/grid-wrapper region scrolls (overflow:auto
            //    safety-net), so a child's rect.top goes negative once
            //    the user scrolls the too-tall canvas — exactly the bug
            //    state — which silently skipped the cap before.
            // --db-topbar-bottom is published off the FIXED toolbar
            // (above the scroll container) so it is scroll-immune, and
            // it already includes banner+header+toolbar. Loop-safe: it
            // is set on load/viewport-change, never driven by boxSize,
            // and updateGridInfo() runs only on mobile load/Apply.
            var topChrome = readPxVar('--db-topbar-bottom');
            var cartH = readPxVar('--db-cartbar-h') || 56;
            // Reserve only the MINIMUM peek (grabber + colour row) so the canvas
            // is maximised; the peek itself dynamically fills whatever vertical
            // space the canvas leaves (see updateMobileSheetPeek + mdPeekMax).
            // Static MIN constant → loop-safe (never reads --db-sheet-peek-h).
            var RESERVED_SHEET_PX = (window.MD_CONST && window.MD_CONST.SHEET_PEEK_MIN_PX) || 94; // collapsed peek: grabber + colour row
            var SELECTION_ROW_PX  = 52; // in-flow Rotate/Remove/Size row (~36px buttons + padding + slack)
            var FIT_GAP_PX        = 22; // keep canvas clear of row/sheet (matches GAP_PX in updateMobileSheetPeek)
            // Apply only when the published geometry is plausible
            // (--db-topbar-bottom is set by setMobileViewportVars on
            // load, before the user can tap Apply). If not yet set the
            // proportional cap stands and self-corrects on next Apply.
            if (vpH > 200 && topChrome > 40) {
              window.__mdCapRetries = 0; // geometry available — reset retry budget
              var availH = vpH - topChrome - cartH
                         - (RESERVED_SHEET_PX + SELECTION_ROW_PX + FIT_GAP_PX);
              if (availH > 80) {
                var maxVerticalCell = availH / lengthBlocksMobile;
                if (maxVerticalCell > 0) {
                  verticalCell = Math.min(verticalCell, maxVerticalCell);
                }
              }
            } else if (vpH > 200 && topChrome <= 40) {
              // --db-topbar-bottom not published yet. This happens on
              // saved-layout / #hash loads, where updateGridInfo() runs before
              // setMobileViewportVars() (drawer-builder-legacy.js) measures the
              // topbar. Without the cap the drawer stays full-height and the
              // selection-actions row overlaps the products sheet. Re-run
              // shortly (bounded) so the cap lands once the var is published,
              // then nudge the sheet to re-anchor below the resized canvas.
              // Loop-safe: bounded by a counter, and the branch stops firing the
              // moment topChrome is set (then the success branch above resets it).
              if (typeof window.__mdCapRetries !== 'number') window.__mdCapRetries = 0;
              if (window.__mdCapRetries < 8) {
                window.__mdCapRetries += 1;
                setTimeout(function () {
                  try { updateGridInfo(); } catch (e) {}
                  try { if (window.MD_updateMobileSheetPeek) window.MD_updateMobileSheetPeek(); } catch (e) {}
                }, 80);
              }
            }
          } catch (e) { warn('fit-to-height cap skipped', e); }
        } else {
          // Degenerate first-paint state: collapse min() to hCell
          // instead of falling back to VERT_DEFAULT_CELL=32 which
          // would render too small on wider phones.
          verticalCell = horizontalCell;
        }
      }

      // Phase 2: both branches contribute a real verticalCell, so
      // drop the mobile ternary and always Math.min both axes.
      var boxSize = Math.min(horizontalCell, verticalCell);
      // Ensure integer px and avoid 0px cells in extreme cases.
      boxSize = Math.max(6, Math.floor(boxSize));

      $('.drawerBundle').attr('width', parseInt(boxSize));
      $('.drawerBundle').attr('length', parseInt(boxSize));

      // Use the clamped block counts (identical to parseInt(grid*) for
      // every valid input; >=1 instead of 0 for degenerate ones) so the
      // canvas pixel space can never collapse to 0.
      var totalHorizontalSpace = parseInt(parseInt(boxSize) * widBlocks);
      var totalVerticalSpace = parseInt(lenBlocks * parseInt(boxSize));

      

      // Ensure bottom board image (drawer_04.png) width tracks grid width
      function updateBottomBoardWidth() {
        var $space = $('.drawerBundle .fs-canvas__space');
        if ($space.length === 0) return;
        // Respect responsive bottom height set via CSS padding-bottom
        var bottomHeight = parseFloat($space.css('padding-bottom')) || 68;
        if (totalHorizontalSpace && totalHorizontalSpace > 0) {
          $space.css('background-size', totalHorizontalSpace + 'px ' + bottomHeight + 'px');
        }
      }

      var lengthTooLarge = inputLength > 2000;
      var widthTooLarge = inputWidth > 2000;
      if (lengthTooLarge || widthTooLarge) {
        setDimensionErrors(lengthTooLarge, widthTooLarge);
        $('.fs-canvas__space .canvas-wrapper').css('visibility', 'visible');
        return;
      } else {
          setDimensionErrors(false, false);
      }

      
      // Adjust droppable area height and width
      if (newLength < currentLength || newWidth < currentWidth ) {
        // $('.gridInfoValue').html(Math.floor(parseInt(inputLength) / GRID_UNIT_MM) * GRID_UNIT_MM + ' x ' + Math.floor(parseInt(inputWidth) / GRID_UNIT_MM) * GRID_UNIT_MM + " x 45mm");
        $('.gridInfoValue').html(
            (Math.floor(parseFloat(inputLength) / GRID_UNIT_MM) * GRID_UNIT_MM).toFixed(1) + 
            ' x ' + 
            (Math.floor(parseFloat(inputWidth) / GRID_UNIT_MM) * GRID_UNIT_MM).toFixed(1) + 
            " x " + selectedModuleHeightMm() + "mm"
        );

        // Contract bottom board image as width/length decreases
        updateBottomBoardWidth();

        $('.fs-canvas__space .canvas-wrapper').css('visibility', 'visible');
        return
      } else {
        // Update grid info on the page
        $('.gridInfoValue').html(
            (Math.floor(parseFloat(inputLength) / GRID_UNIT_MM) * GRID_UNIT_MM).toFixed(1) + 
            ' x ' + 
            (Math.floor(parseFloat(inputWidth) / GRID_UNIT_MM) * GRID_UNIT_MM).toFixed(1) + 
            " x " + selectedModuleHeightMm() + "mm"
        );

        $('.droppable-area1').css({
          height: totalVerticalSpace,
          width: totalHorizontalSpace
        });

        // Expand bottom board image as width increases
        updateBottomBoardWidth();
      }

      // 
      

      
      // (Removed: dead `.canvas-drawer-wrapper` / `.canvas-image-wrapper`
      //  .css() block. Those elements do not exist in the rendered DOM
      //  — only `.canvas-image-wrapper-{left,right,bottom}` exist and
      //  they are commented out in drawer-image.liquid. The block also
      //  used never-assigned `var adjustment; var canvasImageHeight;`,
      //  writing `height: NaN` / `bottom: "NaNpx"` to a zero-length
      //  jQuery set. Pure dead code; grep-verified no other references.)

      // Ensure the background size fits the grid cells
      $('.fs-canvas__canvas').css({
        'background-size': `${parseInt(boxSize)}px ${parseInt(boxSize)}px`,
        display: 'block'
      });

      // reveal canvas wrapper now that sizes are calculated
      $('.fs-canvas__space .canvas-wrapper').css('visibility', 'visible');

      // (Removed: a mobile `setTimeout(() => $(window).scrollTop(200))`.
      //  The page body is `overflow: hidden` (drawer-builder.css) so the
      //  window cannot scroll — the call was an inert no-op and is
      //  implicated in the empty-state resize "freeze". Canvas scroll is
      //  now handled by the bounded `.grid-wrapper` overflow container.)
    }
  // Converted-size readout (topbar caption next to the L/W inputs).
  // The builder rounds the entered drawer DOWN to whole GRID_UNIT_MM blocks, so
  // a standard build fills slightly less than the drawer and leaves a wall gap.
  // Show the converted module footprint always, plus the leftover gap when it
  // exceeds the fit threshold; when true-to-size is on, show the manufactured
  // footprint after the deliberate 1mm far-wall clearance is applied.
  // Called from updateGridInfo() (size changes) and the true-to-size toggle.
  function updateConvertedReadout() {
    var $wrap = $('[data-db-converted]');
    if (!$wrap.length) return;
    var GRID = (window.MD_CONST && window.MD_CONST.GRID_UNIT_MM) || 29.5;
    // Read the CONFIRMED dims (data-original, the applied canvas state) like
    // the add-to-cart capture — .val() may hold a typed-but-unapplied size
    // that would show a footprint/gap the order won't actually carry.
    var $len = $('input[name="length"]');
    var $wid = $('input[name="width"]');
    var L = parseFloat($len.attr('data-original')) || parseFloat($len.val());
    var W = parseFloat($wid.attr('data-original')) || parseFloat($wid.val());
    if (!isFinite(L) || L <= 0 || !isFinite(W) || W <= 0) {
      $wrap.prop('hidden', true);
      return;
    }
    var convL = Math.floor(L / GRID) * GRID;
    var convW = Math.floor(W / GRID) * GRID;
    var gapL = window.mdLeftoverMm ? window.mdLeftoverMm(L) : (L - convL);
    var gapW = window.mdLeftoverMm ? window.mdLeftoverMm(W) : (W - convW);
    var hasGap = Math.max(gapL, gapW) > TTS_GAP_THRESHOLD_MM;
    var fitted = hasGap && $('body').attr('data-true-to-size') === 'yes';
    $('[data-db-converted-label]').text(mdT(fitted
      ? 'modu.builder.fitted_finished_size'
      : 'modu.builder.standard_finished_size'));
    // Trim a trailing ".0" so whole-mm values read cleanly (525 not 525.0).
    var fmt = function (n) {
      var r = Math.round(n * 10) / 10;
      return (r % 1 === 0) ? String(r) : r.toFixed(1);
    };
    var $gap = $('[data-db-converted-gap]');
    if (fitted) {
      var fittedL = convL + mdTtsExtensionMm(gapL);
      var fittedW = convW + mdTtsExtensionMm(gapW);
      $('[data-db-converted-value]').text(fmt(fittedL) + ' × ' + fmt(fittedW) + ' mm');
      $gap.text(mdT('modu.builder.clearance')).attr('data-fitted', 'true').prop('hidden', false);
    } else {
      $('[data-db-converted-value]').text(fmt(convL) + ' × ' + fmt(convW) + ' mm');
      if (hasGap) {
        $gap.text(mdT('modu.builder.gap_to_wall', { dimensions: fmt(gapL) + ' × ' + fmt(gapW) })).removeAttr('data-fitted').prop('hidden', false);
      } else {
        $gap.prop('hidden', true).removeAttr('data-fitted');
      }
    }
    $wrap.prop('hidden', false);
  }

  // Size hint (popover under the L/W fields). The fields are millimetres and
  // take any number, so a size typed in centimetres (47 × 50 for a 470 × 500 mm
  // drawer) is accepted as a 1 × 1 grid that no module fits. When length and
  // width are both under 100 mm the hint offers the millimetre value, and one
  // tap writes it into the fields and applies it; a size that is too small in
  // any unit gets a note without a button. The rule is shared with the AI
  // Layout Creator (window.mdSizeUnits, assets/md-size-units.js) and is absent
  // only when that file did not load, in which case there is no hint.
  // Only length and width are passed: H is the MODULE height here, so it is
  // never converted and never commented on.
  // The hint never blocks Apply. Closing it keeps it closed for that size (a
  // drawer can really be that small); another size brings it back.
  // Called from updateGridInfo() (load, shared links, Apply, the onboarding
  // hand-off) and while typing.
  var sizeHintClosedFor = null;
  function readSizeHint() {
    var units = window.mdSizeUnits;
    if (!units) return null;
    var L = units.parse($('input[name="length"]').val());
    var W = units.parse($('input[name="width"]').val());
    var found = units.check({ L: L, W: W });
    return found ? { units: units, found: found, key: L + 'x' + W } : null;
  }
  function updateSizeHint() {
    var wrap = document.querySelector('[data-db-size-hint]');
    if (!wrap) return;
    var text = wrap.querySelector('[data-db-size-hint-text]');
    var apply = wrap.querySelector('[data-db-size-hint-apply]');
    var hint = readSizeHint();
    if (!hint) sizeHintClosedFor = null;
    if (!hint || !text || !apply || hint.key === sizeHintClosedFor) {
      wrap.hidden = true;
      return;
    }
    var message = mdT('modu.builder_js.size_hint_small');
    var action = '';
    if (hint.found.kind === 'cm') {
      var size = hint.units.label(hint.found.size);
      message = hint.units.noBreak(mdT('modu.builder_js.size_hint_cm', { size: size }));
      action = hint.units.noBreak(mdT('modu.builder_js.size_hint_cm_apply', { size: size }));
    }
    wrap.hidden = false;
    // Written only when it changed: the text is a live region, and
    // updateGridInfo() runs again on every resize.
    if (text.textContent !== message) text.textContent = message;
    if (apply.textContent !== action) apply.textContent = action;
    apply.hidden = !action;
  }
  // The hint's buttons go away with the hint. With a mouse or a keyboard the
  // focus goes back to the length field; on a touch screen that would open the
  // keypad over the palette, so the focus is let go.
  function leaveSizeHint() {
    var finePointer = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
    var lengthField = document.getElementById('length');
    if (finePointer && lengthField) {
      lengthField.focus();
    } else if (document.activeElement && typeof document.activeElement.blur === 'function') {
      document.activeElement.blur();
    }
  }
  $(document).on('input', 'input[name="length"], input[name="width"]', updateSizeHint);
  $(document).on('click', '[data-db-size-hint-apply]', function () {
    // Read again at the tap, so the fields get what the hint shows right now.
    var hint = readSizeHint();
    if (hint && hint.found.kind === 'cm') {
      $('input[name="length"]').val(hint.found.size.L);
      $('input[name="width"]').val(hint.found.size.W);
    }
    updateSizeHint();
    leaveSizeHint();
    // Same seam as the onboarding funnel: the Apply handler validates, resizes
    // the grid and records the size.
    var applyButton = document.getElementById('changeDimension');
    if (hint && hint.found.kind === 'cm' && applyButton) applyButton.click();
  });
  $(document).on('click', '[data-db-size-hint-close]', function () {
    var hint = readSizeHint();
    sizeHintClosedFor = hint ? hint.key : null;
    updateSizeHint();
    leaveSizeHint();
  });

  // IKEA MAXIMERA: count wall-adjacent ("converted") modules. A module is
  // wall-adjacent when it touches any outer grid edge; those are the pieces
  // reshaped to the angled IKEA drawer wall and the basis for the per-module
  // surcharge. Reads the on-canvas modules + grid (same block math as the
  // add-to-cart layout capture).
  function countWallAdjacentModules() {
    var gridW = parseInt($('body').attr('grid-width'), 10) || 0;
    var gridH = parseInt($('body').attr('grid-length'), 10) || 0;
    var cellSize = parseInt($('.drawerBundle').attr('width')) || 0;
    var $items = $('.droppable-area1 .list-view-item.draggable-item');
    var total = $items.length;
    var converted = 0;
    if (cellSize > 0 && gridW > 0 && gridH > 0) {
      $items.each(function () {
        var $it = $(this);
        var t = Math.round((parseInt($it.css('top')) || 0) / cellSize);
        var l = Math.round((parseInt($it.css('left')) || 0) / cellSize);
        var h = Math.max(1, Math.round((parseInt($it.css('height')) || 0) / cellSize));
        var w = Math.max(1, Math.round((parseInt($it.css('width')) || 0) / cellSize));
        if (t <= 0 || l <= 0 || (t + h) >= gridH || (l + w) >= gridW) {
          converted++;
        }
      });
    }
    return { converted: converted, total: total };
  }

  // IKEA MAXIMERA: live "N of M modules adjusted · +€X" readout. Hidden unless
  // the option is selected. The €X estimate uses the display-only per-module
  // fee from the section settings; the actual charge is the fee variant's
  // price × converted count, applied as a cart line at add-to-cart.
  function updateIkeaReadout() {
    var $wrap = $('.db-ikea-maximera');
    if (!$wrap.length) return;
    var $readout = $('[data-db-ikea-readout]');
    if (!$('#db-ikea-maximera').prop('checked')) {
      $readout.prop('hidden', true).text('');
      return;
    }
    var feat = (window.MD_FEATURES && window.MD_FEATURES.ikea_maximera) || {};
    var counts = countWallAdjacentModules();
    var per = parseFloat(feat.perModule) || 0;
    var txt = mdT('modu.builder.modules_adjusted', { converted: counts.converted, total: counts.total });
    if (per > 0 && counts.converted > 0) {
      txt += ' · +' + mdFormatMoney(Math.round(per * counts.converted * 100));
    }
    $readout.prop('hidden', false).text(txt);
  }

  var allProductData = window.allProductData || [];
  function slipFloor(num){
    let f = Math.floor(num);
    if(num-f < 0.5){
      return f;
    }
    return f+0.5;
  }
  
  $('.whiteImage').removeClass('hide');

  // Canonical image selection helpers
  function normalizeColorToken(raw) {
      var input = (raw || '').toString().trim();
      if (!input) {
          return '';
      }

      if (window.MD_COLOR && typeof window.MD_COLOR.resolve === 'function') {
          var resolved = window.MD_COLOR.resolve(input);
          if (resolved && (resolved.imageToken || resolved.token)) {
              return String(resolved.imageToken || resolved.token).toLowerCase();
          }
      }

      var normalized = input.toLowerCase().replace(/[^a-z0-9]/g, '');
      switch (normalized) {
          case 'black':
              return 'charcoalblack';
          case 'white':
              return 'cottonwhite';
          case 'blue':
              return 'armyblue';
          case 'olive':
          case 'armygreen':
              return 'olivegreen';
          default:
              return normalized;
      }
  }

  var STANDARD_MODULE_HEIGHT_MM = 45;
  var CUSTOM_MODULE_HEIGHT_MIN_MM = 20;
  var CUSTOM_MODULE_HEIGHT_MAX_MM = 150;

  // Saved builds retain colour-specific Shopify variant ids. Keep retired
  // catalogue ids readable so consolidating a duplicate product cannot make
  // an existing share link or device-saved design lose a module.
  var BUILDER_VARIANT_ALIASES = {
    '54171243053383': '54171243086151', // Charcoal Black
    '55121052729671': '55121796399431', // Cotton White
    '55121052762439': '55121796432199', // Army Blue
    '55121052795207': '55121796464967'  // Olive Green
  };

  // A hash names each module by its 45 mm (or colour-only) variant. A height
  // band variant id, from AI Layout, the solver gap filler or a link made
  // with the retired height selector, is read as the 45 mm variant of the
  // same colour (window.MD_BAND_INDEX, built in sections/drawer-image.liquid).
  // Ids are compared as strings.
  function canonicalBuilderVariantId(variantId, bandIndex) {
    var key = String(variantId == null ? '' : variantId);
    key = BUILDER_VARIANT_ALIASES[key] || key;
    var index = bandIndex && typeof bandIndex === 'object'
      ? bandIndex
      : (typeof window !== 'undefined' && window.MD_BAND_INDEX) || null;
    var band = index && Object.prototype.hasOwnProperty.call(index, key) ? index[key] : null;
    return band && band.sourceId ? String(band.sourceId) : key;
  }

  function customHeightInputEnabled() {
    return $('[data-db-module-height]').attr('data-custom-height-input') === 'true';
  }

  function customHeightPurchasesEnabled() {
    return $('[data-db-custom-height-available]').attr('data-db-custom-height-available') === 'true';
  }

  function pausedCustomHeightRequest(heightMm) {
    if (customHeightPurchasesEnabled()) return false;
    var custom = heightMm !== STANDARD_MODULE_HEIGHT_MM ||
      Boolean(window.MD_HeightControls && window.MD_HeightControls.customRequested());
    $('.droppable-area1 .list-view-item.draggable-item').each(function () {
      var $item = $(this);
      var authored = Number(variantPricing($item.attr('data-id')).heightMm) || STANDARD_MODULE_HEIGHT_MM;
      var actual = Number($item.attr('data-height-mm')) || authored;
      if (actual !== authored || $item.attr('data-height-basis') === 'finished-v1') custom = true;
    });
    return custom;
  }

  function requestedModuleHeight() {
    if (window.MD_HeightControls && !window.MD_HeightControls.customRequested()) {
      return { ok: true, value: STANDARD_MODULE_HEIGHT_MM };
    }
    var raw = String($('#db-module-height').val() == null ? '' : $('#db-module-height').val()).trim();
    var value = Number(raw);
    var ok = /^\d+$/.test(raw) && Number.isSafeInteger(value) &&
      value >= CUSTOM_MODULE_HEIGHT_MIN_MM && value <= CUSTOM_MODULE_HEIGHT_MAX_MM;
    return { ok: ok, value: ok ? value : null };
  }

  // The confirmed module height. Without the custom height input every module
  // is sold at 45 mm: the fixed 30–90 mm selector is retired.
  function selectedModuleHeightMm() {
    if (!customHeightInputEnabled()) return STANDARD_MODULE_HEIGHT_MM;
    var confirmed = Number($('#db-module-height').attr('data-confirmed-height'));
    if (Number.isSafeInteger(confirmed)) return confirmed;
    var requested = requestedModuleHeight();
    return requested.ok ? requested.value : STANDARD_MODULE_HEIGHT_MM;
  }

  // md-height-bands-start (tests/builder-height-bands.test.js evaluates this block)
  // Height band pricing, the pure part; docs/height-band-pricing.md is the
  // contract. A tile model is plain data read from a palette tile for one
  // colour:
  //   { banded, minMm, authored: { id, price, heightMm } | null,
  //     source: { id, price } | null, bands: { <band mm>: { id, price } } }
  // A placement is what one canvas module is sold as:
  //   { id, checkoutId, price, heightMm, bandMm, banded }
  // id feeds the hash, the images and the colour: the 45 mm source variant of
  // a banded tile, the authored variant of any other. checkoutId is what the
  // cart line buys: the band variant, or the source itself in band 45.
  var HEIGHT_BAND_PRICING_POLICY = 'finished-volume-band-v1';
  var HEIGHT_BAND_STANDARD_MM = 45;
  var HEIGHT_BAND_MIN_MM = 20;
  var HEIGHT_BAND_MAX_MM = 150;
  var HEIGHT_BANDS_MM = [45, 60, 75, 90, 105, 120, 135, 150];

  // The band list ascending, without repeats; the contract's list when none
  // is given.
  function normaliseHeightBands(bandsMm) {
    var list = (Array.isArray(bandsMm) ? bandsMm : [])
      .map(Number)
      .filter(function (band) { return Number.isFinite(band) && band > 0; });
    if (!list.length) list = HEIGHT_BANDS_MM.slice();
    return list
      .filter(function (band, index) { return list.indexOf(band) === index; })
      .sort(function (a, b) { return a - b; });
  }

  // band(h): 45 for 20–45 mm, else the smallest band at or above h. Null
  // below 20 mm, above 150 mm and above the last band.
  function heightBandForMm(heightMm, bandsMm) {
    var h = Number(heightMm);
    if (!Number.isFinite(h) || h < HEIGHT_BAND_MIN_MM || h > HEIGHT_BAND_MAX_MM) return null;
    if (h <= HEIGHT_BAND_STANDARD_MM) return HEIGHT_BAND_STANDARD_MM;
    var bands = normaliseHeightBands(bandsMm);
    for (var i = 0; i < bands.length; i += 1) {
      if (bands[i] >= h) return bands[i];
    }
    return null;
  }

  // A tile sells by height band only in "banded" mode, with the custom height
  // input on, when its product has the band flag and band variants. In "off"
  // mode no product flag is honoured.
  function bandedTileState(state) {
    if (!state || state.mode !== 'banded') return false;
    return state.customHeight === true && state.flag === true && state.hasBands === true;
  }

  function usableHeightVariant(variant) {
    return Boolean(variant) && variant.id != null && String(variant.id) !== '' &&
      Number.isFinite(Number(variant.price));
  }

  // custom.height_band_min_mm, never below 20 mm.
  function bandedMinHeightMm(model) {
    var min = Number(model && model.minMm);
    return Number.isFinite(min) && min > HEIGHT_BAND_MIN_MM ? min : HEIGHT_BAND_MIN_MM;
  }

  // The placement of a tile at height h, or null when the tile does not come
  // at that height. A banded tile takes whole millimetres from its minimum and
  // needs its 45 mm source and, above 45 mm, the band variant of exactly that
  // band in that colour: a missing band is unavailable, never rounded up to
  // the next one, so the largest band present is the tallest height. Any
  // other tile is sold at its authored height, offered while that is at or
  // below h.
  function resolveTileHeight(model, heightMm, bandsMm) {
    if (!model) return null;
    var h = Number(heightMm);
    if (!Number.isFinite(h)) return null;
    if (model.banded) {
      var source = model.source;
      if (!usableHeightVariant(source) || !Number.isSafeInteger(h) || h < bandedMinHeightMm(model)) return null;
      var band = heightBandForMm(h, bandsMm);
      if (band === null) return null;
      var paid = model.bands && model.bands[band];
      if (!usableHeightVariant(paid)) return null;
      var contract = paid.contract;
      if (!contract || contract.policy !== HEIGHT_BAND_PRICING_POLICY || contract.basis !== 'finished-v1' ||
          String(contract.sourceVariantId) !== String(source.id) || String(paid.id) === String(source.id) ||
          contract.bandMm !== band || !/^[a-f0-9]{64}$/.test(contract.revision || '') || !contract.recipeId ||
          !Number.isSafeInteger(contract.minMm) || !Number.isSafeInteger(contract.maxMm) ||
          h < contract.minMm || h > contract.maxMm) return null;
      return {
        id: String(source.id),
        checkoutId: String(paid.id),
        price: Number(paid.price),
        heightMm: h,
        heightBasis: 'finished-v1',
        heightContract: String(contract.revision),
        bandMm: band,
        banded: true
      };
    }
    var authored = model.authored;
    var authoredHeight = Number(authored && authored.heightMm);
    if (!usableHeightVariant(authored) || !Number.isFinite(authoredHeight) || authoredHeight <= 0) {
      return null;
    }
    return {
      id: String(authored.id),
      checkoutId: String(authored.id),
      price: Number(authored.price),
      heightMm: authoredHeight,
      bandMm: null,
      banded: false
    };
  }

  // Resolve a new purchase. Unsupported custom combinations return null;
  // fixed modules retain their authored heights. Restoration is handled
  // separately by placementForItem so it cannot rewrite recorded intent.
  function resolvePlacementHeight(model, requestedHeightMm, bandsMm) {
    if (!model) return null;
    if (model.banded) {
      return resolveTileHeight(model, requestedHeightMm, bandsMm);
    }
    return model.authored ? resolveTileHeight(model, Number(model.authored.heightMm), bandsMm) : null;
  }

  // Why a tile does not come at height h: { kind: 'too_short' } below its
  // authored height or its minimum, or without a variant in that colour;
  // { kind: 'too_tall', maxMm } when a banded tile comes no higher than maxMm
  // below h. Null when it comes at h.
  function tileHeightProblem(model, heightMm, bandsMm) {
    if (resolveTileHeight(model, heightMm, bandsMm)) return null;
    var h = Number(heightMm);
    if (!model || !model.banded || !usableHeightVariant(model.source) || !(h >= bandedMinHeightMm(model))) {
      return { kind: 'too_short' };
    }
    var bands = normaliseHeightBands(bandsMm);
    var maxMm = null;
    for (var i = 0; i < bands.length && bands[i] < h; i += 1) {
      if (resolveTileHeight(model, bands[i], bandsMm)) maxMm = bands[i];
    }
    return maxMm === null ? { kind: 'too_short' } : { kind: 'too_tall', maxMm: maxMm };
  }

  // A line property without a value is left out: it carries nothing, and
  // TapForage takes at most 20 properties per line (docs/forage-bridge.md).
  function withoutBlankProperties(properties) {
    var result = {};
    Object.keys(properties || {}).forEach(function (key) {
      var value = properties[key];
      if (value === undefined || value === null || String(value).trim() === '') return;
      result[key] = value;
    });
    return result;
  }

  // The properties of one module line: the build's, the module height and,
  // on a banded line, the pricing policy and the band paid for.
  function moduleLineProperties(buildProperties, group) {
    var properties = Object.assign({}, buildProperties, {
      '_module_height_mm': String(group.heightMm),
      '_height_basis': 'authored',
      'Module height': group.heightMm + ' mm'
    });
    if (group.banded) {
      properties['_height_pricing_policy'] = HEIGHT_BAND_PRICING_POLICY;
      properties['_height_band_mm'] = String(group.bandMm);
      properties['_height_basis'] = 'finished-v1';
      properties['_height_contract'] = group.heightContract;
    }
    return withoutBlankProperties(properties);
  }

  function placementHeightSuffix(heightMm, basis, revision) {
    if (basis !== undefined && basis !== 'authored' && basis !== 'finished-v1') throw new Error('Unsupported height basis');
    var finished = basis === 'finished-v1';
    if (finished && (!Number.isSafeInteger(heightMm) || heightMm < 20 || heightMm > 150)) throw new Error('Invalid finished height');
    if (finished && !/^[a-f0-9]{64}$/.test(revision || '')) throw new Error('Finished height requires a pinned recipe revision');
    return (heightMm !== 45 || finished ? '-hz=' + heightMm : '') + (finished ? '-hb=f1-hr=' + revision : '');
  }

  function restoredHeightIdentity(explicitHeight, encodedBasis, revision, authoredHeight) {
    if (encodedBasis !== undefined && encodedBasis !== 'f1') throw new Error('Unsupported height basis');
    var basis = encodedBasis === 'f1' ? 'finished-v1' : 'authored';
    var height = explicitHeight === undefined ? Number(authoredHeight || 45) : Number(explicitHeight);
    if (!Number.isFinite(height) || height <= 0) throw new Error('Invalid recorded height');
    if (basis === 'finished-v1') placementHeightSuffix(height, basis, revision);
    else if (revision !== undefined) throw new Error('Recipe requires finished basis');
    return { heightMm: height, basis: basis, revision: revision };
  }
  // md-height-bands-end

  function heightPricingFeature() {
    return (window.MD_FEATURES && window.MD_FEATURES.height_pricing) || {};
  }

  function heightPricingMode() {
    return heightPricingFeature().mode === 'banded' ? 'banded' : 'off';
  }

  function heightBandsMm() {
    return normaliseHeightBands(heightPricingFeature().bandsMm);
  }

  // The rule of bandedTileState() on a palette tile's raw attributes, set by
  // the palette builder in sections/drawer-image.liquid.
  function isBandedTile($tile, customChoice) {
    if (customChoice === undefined) customChoice = Boolean(window.MD_HeightControls && window.MD_HeightControls.customConfirmed());
    return Boolean($tile && $tile.length) && bandedTileState({
      mode: heightPricingMode(),
      customHeight: customHeightInputEnabled() && customChoice,
      flag: $tile.attr('data-height-band-flag') === 'true',
      hasBands: $tile.attr('data-height-bands') === 'true'
    });
  }

  function catalogueTileFor(productId) {
    return $('.mineProList[product-id="' + String(productId == null ? '' : productId) + '"]').first();
  }

  // The tile model (see md-height-bands above) of one palette tile in one
  // colour, or null without a tile.
  function tileHeightModel($tile, colorToken, customChoice) {
    if (!$tile || !$tile.length) return null;
    var prefix = 'data-' + normalizeColorToken(colorToken);
    var variant = function (id, price, heightMm) {
      return id ? { id: String(id), price: Number(price), heightMm: heightMm } : null;
    };
    var model = {
      banded: isBandedTile($tile, customChoice),
      minMm: Number($tile.attr('data-height-band-min-mm')) || null,
      authored: variant(
        $tile.attr(prefix + '-authored-id'),
        $tile.attr(prefix + '-authored-price'),
        Number($tile.attr(prefix + '-authored-height'))
      ),
      source: variant($tile.attr(prefix + '-id'), $tile.attr(prefix + '-price'), STANDARD_MODULE_HEIGHT_MM),
      bands: {}
    };
    if (model.banded) {
      heightBandsMm().forEach(function (band) {
        var id = $tile.attr(prefix + '-band' + band + '-id');
        var contract = null;
        try { contract = JSON.parse($tile.attr(prefix + '-band' + band + '-contract') || 'null'); } catch (error) { /* unavailable */ }
        if (id) model.bands[band] = { id: String(id), price: Number($tile.attr(prefix + '-band' + band + '-price')), contract: contract };
      });
    }
    return model;
  }

  // What a palette tile sells at height h in one colour (a placement), or
  // null. The one path for the palette, Apply, validation and add to cart.
  function heightVariantForTile($tile, colorToken, heightMm, customChoice) {
    return resolveTileHeight(tileHeightModel($tile, colorToken, customChoice), heightMm, heightBandsMm());
  }

  function tileSupportsHeight($tile, heightMm, colorToken) {
    var colors = colorToken
      ? [colorToken]
      : ['charcoalblack', 'cottonwhite', 'armyblue', 'olivegreen'];
    return colors.some(function (color) {
      return Boolean(heightVariantForTile($tile, color, heightMm));
    });
  }

  function variantPricing(variantId) {
    return (window.MD_VARIANT_PRICING && window.MD_VARIANT_PRICING[String(variantId)]) || {};
  }

  // New palette placements require an available catalogue variant. Restored
  // placements keep their recorded variant, height, basis and recipe even
  // when unavailable for a new purchase.
  function placementForItem(productId, colorToken, requestedHeightMm, fallbackVariantId, fallbackPrice, restoredBasis, restoredRevision) {
    var model = tileHeightModel(catalogueTileFor(productId), colorToken);
    var placement = resolvePlacementHeight(
      model,
      requestedHeightMm == null ? selectedModuleHeightMm() : requestedHeightMm,
      heightBandsMm()
    );
    if (restoredBasis === undefined) return placement;
    // Restoration describes geometry already requested, independent of today's
    // catalogue availability. Keep that intent, but do not make it purchasable
    // by falling back to a current standard variant.
    if (placement && (String(placement.id) === String(fallbackVariantId) || String(placement.checkoutId) === String(fallbackVariantId)) &&
        placement.heightMm === requestedHeightMm &&
        (placement.heightBasis || 'authored') === restoredBasis &&
        (placement.heightContract || '') === (restoredRevision || '')) return placement;
    var id = String(fallbackVariantId == null ? '' : fallbackVariantId);
    return {
      id: id,
      checkoutId: id,
      price: Number(fallbackPrice),
      heightMm: requestedHeightMm,
      heightBasis: restoredBasis,
      heightContract: restoredRevision,
      unavailable: true,
      bandMm: null,
      banded: false
    };
  }

  // The canvas attributes of a placement. data-height-band-mm and the policy
  // exist on banded modules only.
  function placementAttributes(placement) {
    return {
      'data-id': placement.id,
      'data-checkout-id': placement.checkoutId,
      'price': placement.price,
      'data-height-mm': placement.heightMm,
      'data-height-basis': placement.heightBasis || 'authored',
      'data-height-contract': placement.heightContract || null,
      'data-height-unavailable': placement.unavailable ? 'true' : null,
      'data-height-band-mm': placement.banded ? placement.bandMm : null,
      'data-variable-height': placement.banded ? 'true' : 'false',
      'data-height-pricing-policy': placement.banded ? HEIGHT_BAND_PRICING_POLICY : null
    };
  }

  function placementMatchesItem($item, placement) {
    var checkoutId = $item.attr('data-checkout-id') || $item.attr('data-id');
    return String($item.attr('data-id')) === String(placement.id) &&
      String(checkoutId) === String(placement.checkoutId) &&
      Number($item.attr('data-height-mm')) === Number(placement.heightMm) &&
      ($item.attr('data-height-basis') || 'authored') === (placement.heightBasis || 'authored') &&
      ($item.attr('data-height-contract') || '') === (placement.heightContract || '') &&
      Number($item.attr('price')) === Number(placement.price) &&
      ($item.attr('data-height-pricing-policy') || '') === (placement.banded ? HEIGHT_BAND_PRICING_POLICY : '') &&
      (!placement.banded || Number($item.attr('data-height-band-mm')) === Number(placement.bandMm));
  }

  // One message for the modules a height does not suit, in the customer's
  // language (t() returns text: shown with .text()).
  function heightProblemMessage(tooShort, tooTall, tooTallMaxMm) {
    var unique = function (values) {
      return values.filter(function (value, index) { return values.indexOf(value) === index; });
    };
    var parts = [];
    if (tooShort.length) {
      parts.push(mdT('modu.builder_js.height_too_short_for', { items: unique(tooShort).join(', ') }));
    }
    if (tooTall.length) {
      parts.push(mdT('modu.builder_js.height_too_tall_for', { items: unique(tooTall).join(', '), max: tooTallMaxMm }));
    }
    return parts.join(' ');
  }

  // Why a palette tile cannot be placed at height h.
  function paletteHeightMessage($tile, colorToken, heightMm) {
    var model = tileHeightModel($tile, colorToken);
    if (!model || (!model.authored && !model.source)) return mdT('modu.builder_js.colour_unavailable');
    var problem = tileHeightProblem(model, heightMm, heightBandsMm());
    var title = $tile.attr('data-title') || '';
    if (problem && problem.kind === 'too_tall') {
      return mdT('modu.builder_js.height_too_tall_for', { items: title, max: problem.maxMm });
    }
    if (model.banded) return mdT('modu.builder_js.height_too_short_for', { items: title });
    return mdT('modu.builder_js.specialty_taller_than_height');
  }

  function showBuilderHeightMessage(message) {
    var $target = $('.fs-canvas__space .canvas-wrapper');
    if (!$target.length) return;
    $target.find('.db-height-message').remove();
    var $message = $('<div class="error-message db-canvas-msg db-height-message" role="status"></div>').text(message);
    $target.append($message);
    $message.fadeIn(250).delay(3500).fadeOut(300, function () { $(this).remove(); });
  }

  function recalculateBuilderTotal() {
    var cents = 0;
    $('.droppable-area1 .list-view-item.draggable-item').each(function () {
      cents += Number($(this).attr('price')) || 0;
    });
    $('.totalPrice').attr('pricemine', cents);
    $('.totalPrice').html(mdFormatMoney(cents));
  }

  // Apply at a new height: every module is re-sold through its tile at that
  // height (a banded module moves to the new band, any other keeps its
  // authored height). Nothing changes when one module does not come at it.
  function remapPlacedItemsToHeight(heightMm) {
    var replacements = [];
    var unsupported = [];
    $('.droppable-area1 .list-view-item.draggable-item').each(function () {
      var $item = $(this);
      var productId = $item.attr('product-id');
      var color = normalizeColorToken($item.attr('data-color') || '');
      var $tile = catalogueTileFor(productId);
      var replacement = heightVariantForTile($tile, color, heightMm, Boolean(window.MD_HeightControls && window.MD_HeightControls.customRequested()));
      if (!replacement) {
        unsupported.push($tile.attr('data-title') || productId);
        return;
      }
      replacements.push({ $item: $item, replacement: replacement });
    });
    if (unsupported.length) return { ok: false, unsupported: unsupported };

    replacements.forEach(function (entry) {
      entry.$item.attr(placementAttributes(entry.replacement));
    });
    recalculateBuilderTotal();
    return { ok: true, unsupported: [] };
  }

  // Before an add to cart, every module must be sold as its tile says at its
  // own height (a restored module can sit below the build's target height).
  // Attributes that drifted are rewritten from the tile; a module that does
  // not come at its height stops the add with the message Apply would show.
  function revalidatePlacedItems() {
    var repaired = 0;
    var tooShort = [];
    var tooTall = [];
    var tooTallMaxMm = null;
    $('.droppable-area1 .list-view-item.draggable-item').each(function () {
      var $item = $(this);
      var productId = $item.attr('product-id');
      var $tile = catalogueTileFor(productId);
      var model = tileHeightModel($tile, normalizeColorToken($item.attr('data-color') || ''));
      var heightMm = Number($item.attr('data-height-mm')) || STANDARD_MODULE_HEIGHT_MM;
      if (!model) {
        // Without a palette tile a module can only be the plain variant a link
        // named, and it stays as it is; a banded one cannot be checked.
        tooShort.push(productId);
        return;
      }
      var expected = model.banded
        ? resolveTileHeight(model, heightMm, heightBandsMm())
        : resolvePlacementHeight(model, heightMm, heightBandsMm());
      if (!expected) {
        var problem = tileHeightProblem(model, heightMm, heightBandsMm());
        var title = $tile.attr('data-title') || productId;
        if (problem && problem.kind === 'too_tall') {
          tooTall.push(title);
          tooTallMaxMm = tooTallMaxMm === null ? problem.maxMm : Math.min(tooTallMaxMm, problem.maxMm);
        } else {
          tooShort.push(title);
        }
        return;
      }
      if (!placementMatchesItem($item, expected)) {
        // Apply is the only place that can change accepted height and price.
        // A stale or unavailable restored request must never silently resize.
        tooShort.push($tile.attr('data-title') || productId);
      }
    });
    if (repaired) recalculateBuilderTotal();
    if (tooShort.length || tooTall.length) {
      showBuilderHeightMessage(heightProblemMessage(tooShort, tooTall, tooTallMaxMm));
      return { ok: false, repaired: repaired };
    }
    return { ok: true, repaired: repaired };
  }

  function applyHeightAvailability(heightMm) {
    $('.mineProList').each(function () {
      var $tile = $(this);
      $tile.toggleClass('db-height-unavailable', !tileSupportsHeight($tile, heightMm));
      // Authored height still drives availability and manufacturing metadata,
      // but product cards do not show per-module height captions.
      $tile.find('[data-db-fixed-height]').remove();
    });
    if (typeof applyFiltersAndPaginate === 'function') applyFiltersAndPaginate();
  }

  function initialiseModuleHeight() {
    var shouldShow = customHeightInputEnabled();
    if (window.MD_HeightControls) window.MD_HeightControls.refresh();
    else $('[data-db-module-height]').prop('hidden', !shouldShow || !customHeightPurchasesEnabled());
    if (!shouldShow) return;
    $('#db-module-height').attr('data-confirmed-height', selectedModuleHeightMm());
    applyHeightAvailability(selectedModuleHeightMm());
  }

  window.addEventListener('db:products-rendered', initialiseModuleHeight);

  $(document).on('input', '#db-module-height', function () {
    if (!customHeightInputEnabled()) return;
    $(this).attr('aria-invalid', 'false');
    $('#db-module-height-error').removeClass('is-visible');
  });

  // Whether every placed module comes at the requested height, with one
  // message naming the modules it is too short or too tall for.
  function validateRequestedModuleHeight(heightMmOverride) {
    // Shared Apply/cart guard: a hidden control alone cannot prevent a restored
    // custom layout from buying the standard variant at its old price.
    var confirmedHeight = Number($('#db-module-height').attr('data-confirmed-height')) || STANDARD_MODULE_HEIGHT_MM;
    var checkedHeight = Number(heightMmOverride) || confirmedHeight;
    if (pausedCustomHeightRequest(checkedHeight)) {
      var pausedMessage = mdT('modu.builder_js.custom_height_paused');
      if (window.MD_HeightControls) window.MD_HeightControls.error(pausedMessage);
      else alert(pausedMessage);
      return { ok: false, value: checkedHeight, unsupported: [] };
    }
    if (!customHeightInputEnabled()) return { ok: true, value: selectedModuleHeightMm() };
    var override = Number(heightMmOverride);
    var requested = Number.isSafeInteger(override) &&
      override >= CUSTOM_MODULE_HEIGHT_MIN_MM &&
      override <= CUSTOM_MODULE_HEIGHT_MAX_MM
      ? { ok: true, value: override }
      : requestedModuleHeight();
    if (!requested.ok) {
      $('#db-module-height').attr('aria-invalid', 'true');
      $('#db-module-height-error').addClass('is-visible');
      if (window.MD_HeightControls) window.MD_HeightControls.error(mdT('modu.builder.module_height_error'));
      return { ok: false, value: null, unsupported: [] };
    }
    // The opt-in is not permission to sell the fixed 45 mm catalogue as custom.
    // Until custom-height products are published, retain the entered draft and
    // explain why it cannot be committed. Specialty inserts remain placeable.
    if (window.MD_HeightControls && window.MD_HeightControls.customRequested()) {
      var failureKey = !$('.mineProList[data-variable-height="true"]').length
        ? 'modu.builder_js.custom_height_unavailable'
        : window.MD_HeightControls.fitRequested()
          ? 'modu.builder_js.custom_height_fit_unavailable' : '';
      if (failureKey) {
        window.MD_HeightControls.error(mdT(failureKey));
        return { ok: false, value: requested.value, unsupported: [] };
      }
    }
    var tooShort = [];
    var tooTall = [];
    var tooTallMaxMm = null;
    $('.droppable-area1 .list-view-item.draggable-item').each(function () {
      var $item = $(this);
      var productId = $item.attr('product-id');
      var color = normalizeColorToken($item.attr('data-color') || '');
      var $tile = catalogueTileFor(productId);
      var problem = tileHeightProblem(tileHeightModel($tile, color, Boolean(window.MD_HeightControls && window.MD_HeightControls.customRequested())), requested.value, heightBandsMm());
      if (!problem) return;
      var title = $tile.attr('data-title') || productId;
      if (problem.kind === 'too_tall') {
        tooTall.push(title);
        tooTallMaxMm = tooTallMaxMm === null ? problem.maxMm : Math.min(tooTallMaxMm, problem.maxMm);
      } else {
        tooShort.push(title);
      }
    });
    if (tooShort.length || tooTall.length) {
      showBuilderHeightMessage(heightProblemMessage(tooShort, tooTall, tooTallMaxMm));
      return { ok: false, value: requested.value, unsupported: tooShort.concat(tooTall) };
    }
    return { ok: true, value: requested.value, unsupported: [] };
  }

  function commitRequestedModuleHeight(heightMm) {
    var result = remapPlacedItemsToHeight(heightMm);
    if (!result.ok) return result;
    $('#db-module-height')
      .val(String(heightMm))
      .attr('data-confirmed-height', heightMm)
      .attr('aria-invalid', 'false');
    $('#db-module-height-error').removeClass('is-visible');
    applyHeightAvailability(heightMm);
    $('.canvas-hoverd-item-btn-size').remove();
    return result;
  }

  // Filename stem (no directory, query string or extension) of a media URL.
  function mediaFileStem(url) {
      var file = String(url || '').split('#')[0].split('?')[0].split('/').pop() || '';
      return file.replace(/\.[a-z0-9]+$/i, '');
  }

  function buildImageManifest(product) {
      var manifest = {};
      if (!product || !product.images) return manifest;
      (product.images || []).forEach(function(img){
          var src = (typeof img === 'string' ? img : (img && img.src) || '');
          if (!src) return;
          // Classify on the filename stem. The Product Render Studio publisher
          // stamps an `_mdr_<operation id>` provenance segment between the
          // colour and the terminal `_hidden` / `_show[_a-i]` token (see
          // internal-tools/docs/contracts.md); strip it so those files classify
          // exactly like the hand-named legacy tiles. Left in place, the hex id
          // breaks the `_drawerbuilder_<colour>_<state>` match and can trip the
          // numbered-thumbnail exclusion below.
          var lower = mediaFileStem(src).toLowerCase().replace(/_mdr_[0-9a-f]+/g, '');
          var mColor = lower.match(/_drawerbuilder_([a-z0-9\-]+)/i);
          if (!mColor) return;
          var color = normalizeColorToken(mColor[1]);
          if (!color) return;
          if (!manifest[color]) manifest[color] = { show: {}, hidden: null };
          // Numbered thumbnails (`…_DrawerBuilder_<Colour>_1.png`) are never
          // canvas tiles. Only the part AFTER the colour is tested: a product
          // name such as "Knife Holder 2 12x3" puts `_2_` in the prefix and
          // must not disqualify its tiles.
          var tail = lower.slice(mColor.index + mColor[0].length);
          var isNumberedThumb = /_(?:01|1|02|2)(?!\d)/i.test(tail);
          if (isNumberedThumb) return; // never canvas
          var isHidden = /_drawerbuilder_[a-z]+_hidden(?![a-z])/i.test(lower);
          var mShowSuf = lower.match(/_drawerbuilder_[a-z]+_show(?:_([a-i]))?(?![a-z])/i);
          if (isHidden) {
              if (!manifest[color].hidden) manifest[color].hidden = src;
              return;
          }
          if (mShowSuf) {
              var suf = (mShowSuf[1] || '').toLowerCase(); // '' or a..i
              manifest[color].show[suf || '_base'] = src;
          }
      });
      return manifest;
  }

  function asObject(value) {
      if (!value) return null;
      if (typeof value === 'object') return value;
      try { return JSON.parse(String(value)); } catch (_) { return null; }
  }

  function semanticRenderPresets(product) {
      var feature = window.MD_FEATURES && window.MD_FEATURES.utensil_render_presets;
      if (!feature || feature.enabled !== true || !product) return [];
      var fields = product.metaFields || product.metafields || product;
      var manifest = asObject(fields.render_media_manifest);
      var fitMap = asObject(fields.utensil_fit_map) || {};
      var source = manifest && manifest.arrangementPresets;
      if (!source || typeof source !== 'object') return [];
      return Object.keys(source).map(function(suffix) {
          var preset = source[suffix] || {};
          var fit = fitMap[preset.taxonomyId];
          if (!/^[a-i]$/.test(suffix) || !preset.presetId || !preset.label || !fit) return null;
          var quantity = Number(preset.quantity);
          var maxUnits = Number(fit.maxUnits);
          if (!Number.isFinite(quantity) || quantity < 1 || !Number.isFinite(maxUnits) || quantity > maxUnits) return null;
          return {
              presetId: String(preset.presetId),
              taxonomyId: String(preset.taxonomyId),
              label: String(preset.label),
              suffix: suffix,
              isDefault: preset.isDefault === true,
              quantity: quantity
          };
      }).filter(Boolean).sort(function(a, b) { return a.suffix.localeCompare(b.suffix); }).slice(0, 9);
  }

  function presetQueryKey(productId) {
      return 'utensil_' + String(productId || '').replace(/[^0-9]/g, '');
  }

  function requestedPresetId(productId) {
      window.MD_RENDER_PRESET_SELECTION = window.MD_RENDER_PRESET_SELECTION || {};
      var selected = window.MD_RENDER_PRESET_SELECTION[String(productId)];
      if (selected) return selected;
      try { return new URLSearchParams(window.location.search).get(presetQueryKey(productId)); }
      catch (_) { return null; }
  }

  function selectSemanticPreset(productId, presetId, updateUrl) {
      var product = (window.allProductData || []).find(function(item) { return String(item.id) === String(productId); }) ||
          (window.products || []).find(function(item) { return String(item.id) === String(productId); });
      var presets = semanticRenderPresets(product);
      var selected = presets.find(function(item) { return item.presetId === presetId; });
      if (!selected) return false;
      window.MD_RENDER_PRESET_SELECTION = window.MD_RENDER_PRESET_SELECTION || {};
      window.MD_RENDER_PRESET_SELECTION[String(productId)] = selected.presetId;
      if (updateUrl !== false && window.history && window.history.replaceState) {
          try {
              var url = new URL(window.location.href);
              url.searchParams.set(presetQueryKey(productId), selected.presetId);
              window.history.replaceState(window.history.state, '', url.toString());
          } catch (_) {}
      }
      var imageManifest = buildImageManifest(product);
      $('.drawerBundle .draggable-item[product-id="' + String(productId) + '"]').each(function() {
          var $item = $(this);
          var colour = normalizeColorToken($item.attr('data-color') || '');
          var pair = pickShowHidden(imageManifest, colour, { productId: productId, product: product, path: 'selector' });
          if (!pair.showUrl) return;
          var previous = $item.attr('data-exist') || '';
          var background = $item.find('div').css('background-image') || '';
          $item.attr('data-exist', pair.showUrl);
          if (!previous || background.indexOf(previous) !== -1) {
              $item.find('div').css('background-image', 'url(' + pair.showUrl + ')');
          }
      });
      return true;
  }

  window.MD_RENDER_PRESETS = {
      list: semanticRenderPresets,
      select: selectSemanticPreset,
      selectedId: requestedPresetId
  };
  try { window.dispatchEvent(new CustomEvent('db:render-presets-ready')); } catch (_) {}

  // Semantic manifests use explicit selection. Products without one retain the
  // legacy round-robin click behaviour byte-for-byte.
  function pickShowHidden(manifest, color, meta) {
      var node = manifest[color] || { show: {}, hidden: null };
      var showOrder = ['a','b','c','d','e','f','g','h','i','_base'];
      var availableKeys = showOrder.filter(function(k){ return !!node.show[k]; });
      var showUrl = null;
      var product = meta && meta.product;
      var semantic = semanticRenderPresets(product).filter(function(preset) { return !!node.show[preset.suffix]; });
      if (availableKeys.length > 0) {
        if (semantic.length > 0 && meta && meta.productId) {
          var requested = requestedPresetId(meta.productId);
          var preset = semantic.find(function(item) { return item.presetId === requested; }) ||
              semantic.find(function(item) { return item.isDefault; }) || semantic[0];
          window.MD_RENDER_PRESET_SELECTION = window.MD_RENDER_PRESET_SELECTION || {};
          window.MD_RENDER_PRESET_SELECTION[String(meta.productId)] = preset.presetId;
          showUrl = node.show[preset.suffix];
        } else if (meta && meta.path === 'click' && meta.productId) {
          window.MD_PICK_INDEX = window.MD_PICK_INDEX || {};
          var idx = window.MD_PICK_INDEX[meta.productId] || 0;
          var key = availableKeys[idx % availableKeys.length];
          showUrl = node.show[key];
          window.MD_PICK_INDEX[meta.productId] = (idx + 1) % availableKeys.length;
        } else {
          // deep-link or default: first in priority
          showUrl = node.show[availableKeys[0]];
        }
      }
      var hiddenUrl = node.hidden || null;
      if (!hiddenUrl && showUrl) {
        hiddenUrl = showUrl.replace(/_show(_[a-i])?/i, '_hidden');
      }
      // Hidden-only fallback. A colour that ships its empty
      // `_DrawerBuilder_<Colour>_hidden` tile but no populated `_show` yet
      // still renders on the canvas: the empty tile stands in for both
      // states, so the hide/show toggle is a no-op for that piece. This is
      // what lets a module go live before its reviewed `_show` renders
      // exist. Colours that do have a `_show` take the branches above and
      // are byte-for-byte unaffected.
      var hiddenOnly = false;
      if (!showUrl && hiddenUrl) {
        showUrl = hiddenUrl;
        hiddenOnly = true;
      }
      return { showUrl: showUrl || '', hiddenUrl: hiddenUrl || '', hiddenOnly: hiddenOnly };
  }

  function updateImageView(imageShow) {
      var normalizedImageShow = imageShow.toLowerCase();
  
      $('.list-view-item.mineProList').each(function () {
          if ($(this).text().trim() === "") {
              $(this).remove();
          }
      });
  
      $('.list-view-item.mineProList').each(function () {
          var hasMatchingImage = $(this).find('img.product-img').filter(function () {
              return $(this).attr('class').toLowerCase().includes(normalizedImageShow);
          }).length > 0;
  
          if (hasMatchingImage) {
              $(this).show();
          } else {
              $(this).hide();
          }
      });
  
      var imageText = $('span[data-id="' + imageShow + '"]').attr('data-text');
      $('.colorsName').html(imageText);
  
      $('.colorsOption span').removeClass('active');
      $('span[data-id="' + imageShow + '"]').addClass('active');
  
      $('#builder-products .list-view-item img').addClass('hide');
  
      $('.product-img').filter(function () {
          return $(this).attr('class').toLowerCase().includes(normalizedImageShow);
      }).removeClass('hide');
  
      if (normalizedImageShow === "white") {
          $('.product-img.crispwhite').removeClass('hide');
      }
      if (normalizedImageShow === "black") {
          $('.product-img.sharpblack').removeClass('hide');
      }
  }
  
  // NOTE: Color click handler + initialisation are handled later in the file (single source of truth)
  // to avoid double-invocation bugs.
  
  $('#showProductPage').click(function(){
    if($('.drawerBundle .list-view-item.active').length > 0){
      //window.open(a, '_blank');
      //window.location.href=a;
      var prodId = $('.drawerBundle .list-view-item.active').attr('product-id');
      var item = allProductData.filter(function(x){
        return x.id == prodId;
      })
      window.open(mdRoot('products/' + item[0].handle), '_blank');
    } else {
        let $targetContainer = $('.fs-canvas__space .canvas-wrapper');
          if ($targetContainer.length === 0) {
              console.error("Error: Target container not found.");
              return;
          }
  
          $targetContainer.find('.error-message').remove();
  
          let $errorContainer = $('<div class="error-message db-canvas-msg">Select any product first.</div>');
  
          $targetContainer.append($errorContainer);
  
          $errorContainer.fadeIn(400).delay(3000).fadeOut(400, function () {
              $(this).remove();
          });
  
          return;
     }
})

  $('body').on('click', '.fsGrid .list-view-item', function(e){
    // Prevent double-firing if touchstart already handled this
    if (e.handled) return;
    selectItemFromCanvas(this);
  });

  $('.fsGrid').on('touchstart', '.list-view-item', function(e){
     e.handled = true;
     selectItemFromCanvas(this);
  });


  function selectItemFromCanvas(that) {

      $('.drawerBundle .list-view-item, .mineProList').removeClass('active');
      $(that).addClass('active');

      // Get the filter picker out of the way of the piece just selected.
      if (typeof window.MD_closeFilterUI === 'function') {
        try { window.MD_closeFilterUI(); } catch (_) {}
      }

      let prodId = $(that).attr('product-id');
      $(`.mineProList[product-id="${prodId}"]`).addClass('active');
  
      // Remove existing buttons before adding new ones
      $('.canvas-hoverd-item-btn-rotate, .canvas-hoverd-item-btn-remove, .canvas-hoverd-item-btn-size').remove();
  
      // Create and append Rotate button
      let rotateBtn = $('<button class="option rotate canvas-hoverd-item-btn-rotate"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(0,0,0,1)"><path d="M10.5858 3.99997L8.75736 2.17154L10.1716 0.757324L14.4142 4.99997L10.1716 9.24261L8.75736 7.82839L10.5858 5.99997H8C6.34315 5.99997 5 7.34311 5 8.99997V13H3V8.99997C3 6.23854 5.23858 3.99997 8 3.99997H10.5858ZM9 11C9 10.4477 9.44772 9.99997 10 9.99997H20C20.5523 9.99997 21 10.4477 21 11V21C21 21.5522 20.5523 22 20 22H10C9.44772 22 9 21.5522 9 21V11ZM11 12V20H19V12H11Z"></path></svg> <span style="display:none;">Rotate</span></button>');
      rotateBtn.attr('aria-label', 'Rotate');
  
      // Create and append Remove button
      let removeBtn = $('<button class="option remove canvas-hoverd-item-btn-remove"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(0,0,0,1)"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 10.5858L14.8284 7.75736L16.2426 9.17157L13.4142 12L16.2426 14.8284L14.8284 16.2426L12 13.4142L9.17157 16.2426L7.75736 14.8284L10.5858 12L7.75736 9.17157L9.17157 7.75736L12 10.5858Z"></path></svg> <span style="display:none;">Remove</span></button>');
      removeBtn.attr('aria-label', 'Remove');

      // Create size badge from grid dimensions and the selected manufacturing height.
      let gridLength = parseInt($(that).attr('pro-length'), 10) || 0;
      let gridWidth = parseInt($(that).attr('pro-width'), 10) || 0;
      let sizeBtn = null;
      if (gridLength && gridWidth) {
          let lengthMm = Math.round(gridLength * GRID_UNIT_MM);
          let widthMm = Math.round(gridWidth * GRID_UNIT_MM);
          let moduleHeightMm = Number($(that).attr('data-height-mm')) || STANDARD_MODULE_HEIGHT_MM;
          let productSize = `${lengthMm}x${widthMm}x${moduleHeightMm}mm`;
          // pointer-events:none prevents size badge from intercepting clicks
          sizeBtn = $('<span class="canvas-hoverd-item-btn-size" style="pointer-events:none;">' + productSize + '</span>');
      }

      // Mobile: append selection tools into the persistent row beneath
      // the drawer (created by setupMobileToolsRows in legacy.js). This
      // pattern keeps the controls visible without obscuring any cells
      // or items inside the canvas.
      const isMobile = window.matchMedia && window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;
      const $selRow = isMobile ? $('.db-mobile-selection-actions-row') : null;
      if (isMobile && $selRow && $selRow.length) {
        $selRow.empty();
        $selRow.append(rotateBtn, removeBtn);
        if (sizeBtn) $selRow.append(sizeBtn);
        if (window.MD_diagSnapshot) {
          try { window.MD_diagSnapshot('selection-row-populated-pre-peek'); } catch (_) {}
        }
        if (window.MD_updateMobileSheetPeek) {
          try { window.MD_updateMobileSheetPeek(); } catch (_) {}
        }
        if (window.MD_diagSnapshot) {
          try { window.MD_diagSnapshot('selection-row-populated-post-peek'); } catch (_) {}
        }
      } else if (window.innerWidth < 1000) {
        $('.grid-wrapper').append(rotateBtn, removeBtn);
        if (sizeBtn) $('.grid-wrapper').append(sizeBtn);
      } else {
        $('.list-view-item.draggable-item.active').append(rotateBtn, removeBtn);
        if (sizeBtn) $('.list-view-item.draggable-item.active').append(sizeBtn);
      }
      
  
      // Show selected product info if any item is active
      if ($('.drawerBundle .list-view-item.active').length > 0) {

          $('.selectedProInfo').show();
  
          let prodWidth = parseInt($(that).attr('pro-width'));
          let prodLength = parseInt($(that).attr('pro-length'));
  
          let item = allProductData.find(x => x.id == prodId);
        log("item", allProductData.find(x => x.id == prodId), allProductData, prodId);
          if (item) {
              $("#selectedProdTitle").text(item.title);
              $("#proDescription, #proDescriptionMobile").html(item.description);
              $('.selectedProInfo #gridInfoValue').text(`${prodLength} X ${prodWidth}`);
              $('.selectedProInfo #proDimensionContent, .selectedProductDimensions #proDimensionContentRight')
                  .text(`${prodLength * GRID_UNIT_MM}mm x ${prodWidth * GRID_UNIT_MM}mm x ${Number($(that).attr('data-height-mm')) || STANDARD_MODULE_HEIGHT_MM}mm`);
  
              $("#selectedProductImage, #selectedProductImageMobile").attr("src", "https:" + item.featured_image);
              $("#productLink, #productDescLink, #productLinkMobile, #productDescLinkMobile")
                  .attr("href", mdRoot('products/' + item.handle));
          }
      }
  }

  $(document).on('click', function (event) {
      // A floating fit/height edit must not collapse the selection row and
      // move the canvas behind it. Preserve selection until the edit closes.
      if ($(event.target).closest('.db-fit-height-trigger, #db-fit-height-panel').length ||
          ($(event.target).closest('#changeDimension').length && $('#db-fit-height-panel').is(':visible'))) return;
      const isMobile = window.matchMedia && window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;
      if (!$(event.target).closest('.draggable-item, .canvas-hoverd-item-btn-rotate, .canvas-hoverd-item-btn-remove, .canvas-hoverd-item-btn-size, #db-hide-grid-btn, #db-clear-all-btn').length) {
          if (isMobile) {
            // Deselect on mobile so tools row shrinks back to Hide/Clear only.
            $('.drawerBundle .list-view-item, .mineProList').removeClass('active');
            $('.canvas-hoverd-item-btn-rotate, .canvas-hoverd-item-btn-remove, .canvas-hoverd-item-btn-size').remove();
            $('.db-mobile-selection-actions-row').empty();
            if (window.MD_diagSnapshot) {
              try { window.MD_diagSnapshot('selection-row-emptied-pre-peek'); } catch (_) {}
            }
            if (window.MD_updateMobileSheetPeek) {
              try { window.MD_updateMobileSheetPeek(); } catch (_) {}
            }
            if (window.MD_diagSnapshot) {
              try { window.MD_diagSnapshot('selection-row-emptied-post-peek'); } catch (_) {}
            }
          } else if (window.innerWidth >= 1000) {
            $('.canvas-hoverd-item-btn-rotate, .canvas-hoverd-item-btn-remove, .canvas-hoverd-item-btn-size').remove();
          }
      }
  });
  
  function toggleRotation($item) {
    // Store original dimensions and positions in case we need to revert
    let originalWidth = $item.width();
    let originalHeight = $item.height();
    let originalTop = $item.position()?.top;
    let originalLeft = $item.position().left;

    // Calculate new dimensions
    let newWidth = originalHeight;
    let newHeight = originalWidth;

    const $editor = $item.parent();
    const editorWidth = $editor.width();
    const editorHeight = $editor.height();
    let gridSize = parseFloat($('.drawerBundle').attr('width')) || 10; // Default grid size if not found

    // Helper function to check if item can be placed at given coordinates
    const canPlaceItem = (top, left, width, height) => {
        if (top + height > editorHeight || left + width > editorWidth) {
            return false;
        }
        $item.css({
            width: width,
            height: height,
            top: top,
            left: left
        });

        let isSpaceAvailable = true;
        $editor.find('.draggable-item').not($item).each(function () {
            if (isColliding($item, $(this), 1)) {
                isSpaceAvailable = false;
                return false; // break the loop
            }
        });

        return isSpaceAvailable;
    };

    // Check if the rotated item fits within the current position
    if (canPlaceItem(originalTop, originalLeft, newWidth, newHeight)) {
        $item.toggleClass('rotated');
        $item.css({
            width: newWidth,
            height: newHeight
        });
        if($item.hasClass('rotated')){
          $item.find('div').css({
              height: originalHeight,
              width: originalWidth
          });
        }
        return;
    }

    // If it doesn't fit, check the entire canvas for a suitable position
    let placed = false;
    outerLoop:
    for (let y = 0; y <= editorHeight - newHeight; y += gridSize) {
        for (let x = 0; x <= editorWidth - newWidth; x += gridSize) {
            if (canPlaceItem(y, x, newWidth, newHeight)) {
                $item.toggleClass('rotated');
                if($item.hasClass('rotated')){
                  $item.find('div').css({
                      height: originalHeight,
                      width: originalWidth
                  });
                }
                placed = true;
                break outerLoop;
            }
        }
    }

    if (!placed) {
        // alert('Not enough space to rotate!');
        let $targetContainer = $('.fs-canvas__space .canvas-wrapper');
        if ($targetContainer.length === 0) {
            console.error("Error: Target container not found.");
            return;
        }

        $targetContainer.find('.error-message').remove();

        let $errorContainer = $('<div class="error-message db-canvas-msg">Not enough space to rotate!</div>');

        $targetContainer.append($errorContainer);

        $errorContainer.fadeIn(400).delay(3000).fadeOut(400, function () {
            $(this).remove();
        });

        // Revert the item to its original dimensions and position
        $item.css({
            width: originalWidth,
            height: originalHeight,
            top: originalTop,
            left: originalLeft
        });
    }

    setTimeout(() => {
      $('.draggable-item.active').triggerHandler('mousedown');
    }, 50);
}

  // NOTE: The legacy `.option.clear` click handler was removed — its markup
  // was deleted long ago, so the binding was orphaned (it never matched an
  // element). The live "Clear All" control is `#db-clear-all-btn` (see its
  // handler later in this file).



  function addItem($editor, proLength, proWidth, imageData, imageData1, dataImageHidden, variantId, productId, itemid, colorCheck, productUrl, price, left = null, top = null, rotateValue, comingFromURL = false, heightMmOverride = null, regionPlacement = null, restoredBasis = undefined, restoredRevision = undefined) {
    const editorWidth = $editor.width();
    const editorHeight = $editor.height();
    const gridSize = parseFloat($('.drawerBundle').attr('width')) || 10; // Default grid size
    const prodGridWidth = Math.ceil(proWidth / gridSize);
    const prodGridLength = Math.ceil(proLength / gridSize);
    // Keep these attrs canonical (the product's unrotated catalogue size).
    // Resize code no longer depends on them for the visual footprint, but the
    // selection UI uses them for the product-size label. Older URL restores
    // wrote already-rotated h/w here, creating two incompatible meanings.
    const catalogueProduct = allProductData.find(function (item) {
      return String(item.id) === String(productId);
    });
    const catalogueGrid = getCatalogueGridSize(catalogueProduct);
    const canonicalGridLength = catalogueGrid ? catalogueGrid.height : prodGridLength;
    const canonicalGridWidth = catalogueGrid ? catalogueGrid.width : prodGridWidth;
    // What this module is sold as comes from its palette tile (the one path
    // shared with Apply and add to cart): a banded tile at the requested
    // height, any other at its authored height. The variant and price the
    // caller passed are only the fallback for a module without a tile.
    const placement = placementForItem(productId, colorCheck, heightMmOverride, variantId, price, restoredBasis, restoredRevision);
    if (!placement) {
      showBuilderHeightMessage(paletteHeightMessage(catalogueTileFor(productId), colorCheck, selectedModuleHeightMm()));
      return false;
    }
    let placed = false;

    // The placement search must be bounded by the drawer's TRUE pixel
    // size. The measured $editor (.droppable-area1) size is unreliable
    // in BOTH directions and must NOT be trusted:
    //   • stale-LARGE after a shrink (updateGridInfo() early-returns
    //     and skips resizing .droppable-area1); and
    //   • stale-SMALL while the drawer is empty: the stylesheet rule
    //     `body.drawer-builder.drawer-empty .fsGrid { height:
    //     clamp(120px,22vh,200px) !important }` clamps this very
    //     element (.fsGrid == .droppable-area1) to <=200px, and an
    //     inline height cannot beat `!important`. With the old
    //     Math.min(editorHeight, …) that ~200px won, so the FIRST add
    //     to an empty tall drawer rejected any module taller than the
    //     clamp (only a 1-block item fit; placing it removed
    //     drawer-empty and unclamped the height — the reported
    //     "must add 1x4 before 8x2" bug).
    // Use the authoritative block dims × cell size directly. These come
    // from body[grid-*] and .drawerBundle[width], which the empty-state
    // clamp does NOT touch. Fall back to the measured size only when
    // the attrs are genuinely absent (pre-init), preserving old
    // behaviour for that uninitialised case.
    const gridLenBlocks = parseInt($('body').attr('grid-length'), 10) || 0;
    const gridWidBlocks = parseInt($('body').attr('grid-width'), 10) || 0;
    const fitHeight = gridLenBlocks > 0 ? (gridLenBlocks * gridSize) : editorHeight;
    const fitWidth  = gridWidBlocks > 0 ? (gridWidBlocks * gridSize) : editorWidth;


    const tryPlaceItem = (x, y, itemLength, itemWidth, isRotated, myrot) => {
        // Collision checks alone do not protect the canvas edge. This matters
        // when catalogue repair expands a corrupt hash footprint beyond the
        // drawer itself: reject that rectangle before creating any DOM item so
        // URL restore can enter its explicit incomplete-layout path.
        const boundsTolerance = 0.5;
        const withinBounds = Number.isFinite(x) && Number.isFinite(y)
            && Number.isFinite(itemLength) && Number.isFinite(itemWidth)
            && itemLength > 0 && itemWidth > 0
            && x >= -boundsTolerance && y >= -boundsTolerance
            && x + itemWidth <= fitWidth + boundsTolerance
            && y + itemLength <= fitHeight + boundsTolerance;
        if (!withinBounds) {
            warn('[DRAWER-BUILDER] rejected out-of-bounds module placement', {
              x, y, itemLength, itemWidth, fitWidth, fitHeight
            });
            return false;
        }

        let $newItem = $('<li class="list-view-item draggable-item butNotHere recently-added"></li>')
            .attr({
                "pro-length": canonicalGridLength,
                "pro-width": canonicalGridWidth,
                "data-exist": imageData,
                "data-hidden": dataImageHidden,
                "product-id": productId,
                "item-id": itemid,
                "data-color": colorCheck
            })
            .attr(placementAttributes(placement))
            .css({
                "position": "absolute",
                //"width": isRotated == 'true' ? itemLength : itemWidth + "px",
                //"height": isRotated == 'true' ? itemWidth : itemLength + "px",
                "width": itemWidth + "px",
                "height": itemLength + "px",
                "left": x + "px",
                "top": y + "px",
                "background-color": "rgba(255, 0, 0, 0.5)"
            });

        // Rotation handling:
        // - The li element is sized to fit the GRID CELL space (itemWidth x itemLength)
        // - If rotated, we add .rotated class which applies CSS rotate(-90deg)
        // - The inner div with the image needs to be sized so that AFTER rotation it fills the li
        // - When rotated -90deg, a WxH element appears as HxW visually
        // So for rotated items: inner div should be itemLength x itemWidth (swapped)
        // Then after -90deg rotation, it appears as itemWidth x itemLength (matching the li)
        
        let bgWidth, bgHeight;
        const shouldRotate = (isRotated === 'true' || isRotated === true || myrot === true);
        
        if (shouldRotate) {
            // Inner div needs swapped dimensions because CSS will rotate it
            bgWidth = itemLength;   // becomes visual width after rotation
            bgHeight = itemWidth;   // becomes visual height after rotation
            $newItem.addClass("rotated");
        } else {
            bgWidth = itemWidth;
            bgHeight = itemLength;
        }

        log('[DRAWER-BUILDER] tryPlaceItem:', {
            x, y, itemLength, itemWidth, isRotated, shouldRotate,
            bgWidth, bgHeight
        });

        let $innerDiv = $("<div></div>").css({
            "background-image": `url(${imageData})`,
            "background-repeat": "no-repeat",
            "background-size": "100% 100%",  // Force fill both dimensions exactly
            "background-position": "center center",
            "width": bgWidth + "px",
            "height": bgHeight + "px"
        });

        $newItem.append($innerDiv);
        $editor.append($newItem);

        let isSpaceAvailable = true;
        $editor.find(".draggable-item").not($newItem).each(function () {
            if (isColliding($newItem, $(this), 0.9)) {
                isSpaceAvailable = false;
                return false;
            }
        });

        if (isSpaceAvailable) {
            $newItem.css("background-color", "");
            initiateDraggable($newItem, $editor, gridSize);
            placed = true;
        } else {
            $newItem.remove();
        }

        return isSpaceAvailable;
    };

    // Tapped region (a palette click while a region is selected): land the module
    // in that space, turned the way the caller chose so it fills the region, before
    // the first-free-spot search below. Falls through to that search if it no longer
    // fits there.
    let placedInRegion = false;
    if (!comingFromURL && regionPlacement) {
      placedInRegion = regionPlacement.rotate
        ? tryPlaceItem(regionPlacement.left, regionPlacement.top, proWidth, proLength, rotateValue, true)
        : tryPlaceItem(regionPlacement.left, regionPlacement.top, proLength, proWidth, rotateValue);
    }

    if (!comingFromURL && !placedInRegion) {
      // **Prioritize given left & top values if they exist**
      if (left !== null && top !== null) {
          if (tryPlaceItem(left, top, proLength, proWidth, rotateValue) || tryPlaceItem(left, top, proWidth, proLength, rotateValue)) {
              return;
          }
      }
  
      // **Fallback: Try finding an empty space**
      let verticalFits = false;
      let horizontalFits = false;
  
      // Try vertical placement first
      outerLoop:
      for (let y = 0; y <= fitHeight - proLength; y += gridSize) {
          for (let x = 0; x <= fitWidth - proWidth; x += gridSize) {
              if (tryPlaceItem(x, y, proLength, proWidth, rotateValue)) {
                  verticalFits = true;
                  break outerLoop;
              }
          }
      }
  
      // If vertical fails, try horizontal
      if (!verticalFits) {
          log("No vertical space. Trying horizontal placement...");
          outerLoop:
          for (let y = 0; y <= fitHeight - proWidth; y += gridSize) {
              for (let x = 0; x <= fitWidth - proLength; x += gridSize) {
                  // Pass explicit boolean flag for rotation; avoid referencing undeclared `myrot`
                  if (tryPlaceItem(x, y, proWidth, proLength, rotateValue, true)) {
                      horizontalFits = true;
                      break outerLoop;
                  }
              }
          }
      }
  
      // If neither vertical nor horizontal placement is possible, show error message
      if (!verticalFits && !horizontalFits) {
          log("No space available.");
          let $targetContainer = $('.fs-canvas__space .canvas-wrapper');
          if ($targetContainer.length === 0) {
              console.error("Error: Target container not found.");
              return;
          }
  
          $targetContainer.find('.error-message').remove();
          let $errorContainer = $('<div class="error-message db-canvas-msg">The editor is full, no space to add a new item!</div>');
  
          $targetContainer.append($errorContainer);
          $errorContainer.fadeIn(400).delay(3000).fadeOut(400, function () {
              $(this).remove();
          });
          return false;
      }
    }
    else if (comingFromURL) {
      // Coming from URL - use the hash dimensions directly
      // h = rows (vertical), w = cols (horizontal)
      // proLength is the vertical size (h * cellSize)
      // proWidth is the horizontal size (w * cellSize)
      // DO NOT swap dimensions here - let tryPlaceItem handle rotation via CSS
      log('[DRAWER-BUILDER] URL placement:', {
        left, top, proLength, proWidth, rotateValue
      });
      const placedAtHashPosition = tryPlaceItem(left, top, proLength, proWidth, rotateValue);
      if (!placedAtHashPosition) {
        // Catalogue repair can legitimately grow an old corrupted footprint
        // (for example 8x2 back to 9x2). If that repaired rectangle now
        // overlaps a later hash position, keep the module and relocate it to
        // the nearest free same-orientation slot instead of silently dropping
        // it. Candidate ordering is deterministic: Manhattan distance, row,
        // then column.
        const desiredCol = Math.max(0, Math.round((parseFloat(left) || 0) / gridSize));
        const desiredRow = Math.max(0, Math.round((parseFloat(top) || 0) / gridSize));
        const maxCol = Math.floor((fitWidth - proWidth) / gridSize + 0.0001);
        const maxRow = Math.floor((fitHeight - proLength) / gridSize + 0.0001);
        const candidatePositions = [];

        if (maxCol >= 0 && maxRow >= 0) {
          for (let row = 0; row <= maxRow; row++) {
            for (let col = 0; col <= maxCol; col++) {
              if (row === desiredRow && col === desiredCol) continue;
              candidatePositions.push({
                row: row,
                col: col,
                distance: Math.abs(row - desiredRow) + Math.abs(col - desiredCol)
              });
            }
          }
        }

        candidatePositions.sort(function (a, b) {
          return a.distance - b.distance || a.row - b.row || a.col - b.col;
        });

        let fallbackPosition = null;
        for (let candidateIndex = 0; candidateIndex < candidatePositions.length; candidateIndex++) {
          const candidate = candidatePositions[candidateIndex];
          if (tryPlaceItem(
            candidate.col * gridSize,
            candidate.row * gridSize,
            proLength,
            proWidth,
            rotateValue
          )) {
            fallbackPosition = candidate;
            break;
          }
        }

        if (fallbackPosition) {
          warn('[DRAWER-BUILDER] relocated repaired hash module to nearest free grid position', {
            from: { row: desiredRow, col: desiredCol },
            to: { row: fallbackPosition.row, col: fallbackPosition.col }
          });
        } else {
          warn('[DRAWER-BUILDER] Failed to restore module from URL - no free catalogue-sized slot');
          window.MD_LAYOUT_RESTORE_INCOMPLETE = true;
          const $targetContainer = $('.fs-canvas__space .canvas-wrapper');
          if ($targetContainer.length && !$targetContainer.find('.db-layout-restore-error').length) {
            $targetContainer.append(
              $('<div class="error-message db-canvas-msg db-layout-restore-error" role="alert">This saved layout could not restore every module. Please review the drawer before ordering.</div>')
            );
            $targetContainer.find('.db-layout-restore-error').fadeIn(400);
          }
          return false;
        }
      }
    }
   

    const totalPrice = parseFloat($('.totalPrice').attr('pricemine') || 0);
    const newPrice = totalPrice + parseFloat(placement.price);
    $('.totalPrice').attr('pricemine', newPrice);
    $('.totalPrice').text(mdFormatMoney(newPrice));
    if (typeof updateIkeaReadout === 'function') { updateIkeaReadout(); }

      setTimeout(function () {
        if(!comingFromURL){
          createURL();
        }
      }, 1000);
    return placed;
}


  
  // <!-- new code teksyo 19-2-25 -->

  const findCommonVariants = (arr1, arr2) => {
    const ids1 = new Set(arr1.flatMap(p => p.variants.map(v => v.id)));
    return arr2.flatMap(p => p.variants.filter(v => ids1.has(v.id)));
  };

  function extractGridSize(str) {
    // look for digits, then an 'x' (case-insensitive), then digits
    const regex = /(\d+)\s*[xX]\s*(\d+)/;
    const match = str.match(regex);
    if (!match) return null;
    
    return {
      height: parseInt(match[1], 10),
      width: parseInt(match[2], 10)
    };
  }

  function getCatalogueGridSize(product) {
    if (!product) return null;
    // Product metafields are the catalogue contract. Title parsing is retained
    // only as a compatibility fallback for older products/layout payloads.
    const metaHeight = parseInt(product.grid_length, 10);
    const metaWidth = parseInt(product.grid_width, 10);
    if (Number.isFinite(metaHeight) && metaHeight > 0 && Number.isFinite(metaWidth) && metaWidth > 0) {
      return { height: metaHeight, width: metaWidth };
    }
    return extractGridSize(product.title || '');
  }


  const extractGrid = url => (url.match(/(\d+)x(\d+)/) || []).slice(1, 3).map(Number);

  var mdShareOpenSent = false;

  function restoreLegacyHash(hash, options) {
    options = options || {};
    var mdWasSharedOpen = options.initial && /[?&]shared=1(?:&|$)/.test(window.location.search || '');
    if (mdWasSharedOpen) {
      try {
        var cleaned = window.location.search.slice(1).split('&').filter(function(p){ return p !== 'shared=1'; }).join('&');
        window.history.replaceState(null, '', window.location.pathname + (cleaned ? '?' + cleaned : '') + window.location.hash);
      } catch (e) { /* sandboxed iframe / old browser — leave the marker; restore must proceed */ }
    }

    if (hash) { // Check if hash is present
        let parts = hash.split("&"); // Split into width-height and product variants

        // Extract Width & Height from First Part
        let dimensions = parts[0].split("x");
        let height = parseFloat(dimensions[0]) || 0;
        let width = parseFloat(dimensions[1]) || 0;
        
        let $editor = $('.droppable-area1');

        $('input[name="length"]').attr('data-original', height).val(height);
        $('input[name="width"]').attr('data-original', width).val(width);

        // Fit preference was restored before the initial grid refresh. This
        // refresh rechecks availability using the restored drawer dimensions.
        updateGridInfo();
        // IKEA MAXIMERA opt-in rides the share URL as a bare `ikea=1` token.
        // Only restore when the option is actually present (feature enabled).
        if (parts.indexOf('ikea=1') !== -1 && $('#db-ikea-maximera').length) {
            mdSetFitPreference('standard', 'restored');
            $('#db-ikea-maximera').prop('checked', true);
            $('body').attr('data-ikea-maximera', 'yes');
            // Mutually exclusive with true-to-size.
            if ($('#db-true-to-size').prop('checked')) {
                $('#db-true-to-size').prop('checked', false);
                $('body').attr('data-true-to-size', 'no');
                $('body').attr('data-fit-choice-source', 'unavailable');
                if (typeof updateConvertedReadout === 'function') { updateConvertedReadout(); }
            }
            if (typeof updateIkeaReadout === 'function') { updateIkeaReadout(); }
        }

        if (mdWasSharedOpen && !mdShareOpenSent && height > 0 && width > 0) {
            mdShareOpenSent = true;
            mdPushDL({
              event: 'share_open',
              drawer_length: height,
              drawer_width: width,
              module_count: parts.slice(1).filter(function(part) {
                return /^\d+-/.test(part);
              }).length
            });
        }

        // md-builder-restore-cell-start
        let totalBlocksInLength = Math.max(1, Math.floor(height / GRID_UNIT_MM)); // height = drawer's internal length
        // Use the same cell updateGridInfo rendered and Share/Cart serialize.
        // The canvas wrapper can have a different CSS height on a warm load.
        let cellSize = getCurrentCellSize();
        // md-builder-restore-cell-end

        // Grid dimensions in blocks (must match AI builder)
        const gridRows = totalBlocksInLength;
        const gridCols = Math.max(1, Math.floor(width / GRID_UNIT_MM));


        // Extract Product Variants
        let products = [];

        for (let i = 1; i < parts.length; i++) { // Skip first part
            // Build-level tokens are not item segments.
            if (parts[i] === 'tts=1' || parts[i] === 'ikea=1' || parts[i] === 'ch=1' || /^mh=\d+$/.test(parts[i])) continue;
            let keyValuePairs = parts[i].split("-");
            let productId = canonicalBuilderVariantId(keyValuePairs[0]); // First part is variant ID
            let productData = { id: productId };
            const recordedBand = (window.MD_BAND_INDEX || {})[keyValuePairs[0]];
            if (recordedBand) {
              productData.recordedVariantId = keyValuePairs[0];
              productData.hz = String(recordedBand.heightMm);
            }

            for (let j = 1; j < keyValuePairs.length; j++) {
                let keyValue = keyValuePairs[j].split("=");
                let key = keyValue[0];
                let value = keyValue[1];

                productData[key] = value;
            }

            products.push(productData);
        }

        try {
          products.forEach(function (product) {
            restoredHeightIdentity(product.hz, product.hb, product.hr, variantPricing(product.id).heightMm);
          });
        } catch (error) {
          if (window.MD_HeightControls) window.MD_HeightControls.error(mdT('modu.builder_js.custom_height_paused'));
          return; // The original saved hash remains intact; no unsupported basis is rewritten.
        }

          // Restore the target/max height. New links carry an explicit mh token
          // because specialty modules can make a valid build mixed-height;
          // older links fall back to the maximum placement height.
          var restoredHeights = products.map(function (entry) {
            return Number(entry.hz) || Number(variantPricing(entry.id).heightMm) || STANDARD_MODULE_HEIGHT_MM;
          });
          var targetHeightPart = parts.find(function (part) { return /^mh=\d+$/.test(part); });
          var restoredTargetHeight = targetHeightPart
            ? Number(targetHeightPart.slice(3))
            : restoredHeights.length ? Math.max.apply(Math, restoredHeights) : STANDARD_MODULE_HEIGHT_MM;
          // An old link containing only authored specialty heights does not
          // request resized trays. Keep those placements without opting in.
          if (!targetHeightPart && !customHeightPurchasesEnabled() && products.every(function (entry) {
            var authored = Number(variantPricing(entry.id).heightMm) || STANDARD_MODULE_HEIGHT_MM;
            return !entry.hz || Number(entry.hz) === authored;
          })) restoredTargetHeight = STANDARD_MODULE_HEIGHT_MM;
          if (
            customHeightInputEnabled() &&
            Number.isSafeInteger(restoredTargetHeight) &&
            restoredTargetHeight >= CUSTOM_MODULE_HEIGHT_MIN_MM &&
            restoredTargetHeight <= CUSTOM_MODULE_HEIGHT_MAX_MM
          ) {
            $('#db-module-height')
              .val(String(restoredTargetHeight))
              .attr('data-confirmed-height', restoredTargetHeight);
            applyHeightAvailability(restoredTargetHeight);
            if (window.MD_HeightControls) window.MD_HeightControls.restore(restoredTargetHeight,
              parts.indexOf('ch=1') !== -1 || restoredTargetHeight !== STANDARD_MODULE_HEIGHT_MM ||
              products.some(function (entry) { return entry.hb === 'f1'; }));
          }

        if (products.length > 0) {
          log("product", products);
           
          
          let selectedVariantIds = products.map(product => Number(product.id));
          
          // Convert allProductData into a map of variant ID → product
          let variantToProductMap = new Map();
          allProductData.forEach(product => {
              product.variants.forEach(variant => {
                  variantToProductMap.set(Number(variant.id), product);
              });
          });

          
        
            // Map selectedVariantIds directly to products, preserving order & duplicates
            let matchingProducts = selectedVariantIds.map((variantId, idx) => {
              const product = variantToProductMap.get(variantId);
              if (!product) {
                console.error('[DRAWER-BUILDER] Variant ID not found in product catalog:', {
                  variantId,
                  index: idx,
                  hashData: products[idx]
                });
              }
              return product;
            });
            log("[DRAWER-BUILDER] matchingProducts:", matchingProducts);

            // Add position data from `products` into `matchingProducts`
            matchingProducts = matchingProducts.map((product, index) => {
                if (product) {
                  var grid = getCatalogueGridSize(product) || {};

                  // Standard module dimensions are owned by the catalogue, not
                  // by the share hash. Older serializer races could write a 9x2
                  // module as h=8; trusting that value silently changed the SKU's
                  // footprint on reload. The hash remains the fallback only when
                  // catalogue dimensions are genuinely unavailable.
                  const hashData = products[index] || {};
                  const hashW = parseInt(hashData.w, 10);
                  const hashH = parseInt(hashData.h, 10);
                  const hashRotated = String(hashData.r) === 'true';
                  const hasCatalogueGrid = Number.isFinite(grid.height) && grid.height > 0
                    && Number.isFinite(grid.width) && grid.width > 0;
                  const catalogueH = hasCatalogueGrid ? (hashRotated ? grid.width : grid.height) : 0;
                  const catalogueW = hasCatalogueGrid ? (hashRotated ? grid.height : grid.width) : 0;
                  const finalH = catalogueH || ((Number.isFinite(hashH) && hashH > 0) ? hashH : 1);
                  const finalW = catalogueW || ((Number.isFinite(hashW) && hashW > 0) ? hashW : 1);

                  if (hasCatalogueGrid && (hashH !== finalH || hashW !== finalW)) {
                    warn('[DRAWER-BUILDER] repaired hash footprint from catalogue', {
                      variantId: hashData.id,
                      hash: { h: hashH, w: hashW, rotated: hashRotated },
                      repaired: { h: finalH, w: finalW }
                    });
                  }

                  return {
                    ...product,
                    ...hashData,
                    w: finalW,
                    h: finalH,
                    productId: product.id
                  }; // Merge position + size details
                }
                return product;
            });

          log("matchingProducts", matchingProducts)

          // Optional: expose parsed hash + matching products for debugging
          try {
            if (window.MD_DEBUG_LAYOUT || /[?&]debug=1/.test(window.location.search || '')) {
              window.MD_LAST_BUILDER_HASH = {
                rawHash: window.location.hash,
                productsFromHash: products,
                matchingProducts
              };
              log('[DRAWER-BUILDER] debug:hashParsed', window.MD_LAST_BUILDER_HASH);
            }
          } catch (e) {
            warn('MD_DEBUG_LAYOUT inspection failed', e);
          }
         

            if (matchingProducts.length > 0) {  


               function extractRotateValues() {
                    let rotateValues = {};
                    let hash = window.location.hash.substring(1); // Remove '#'
                
                    let matches = hash.match(/([\d]+)-t=[^&]+-l=[^&]+-r=(true|false)/g);
                
                    if (matches) {
                        matches.forEach(match => {
                            let idMatch = match.match(/^([\d]+)/); // Extract product ID
                            let rotateMatch = match.match(/-r=(true|false)/); // Extract rotate value
                
                            if (idMatch && rotateMatch) {
                                let productId = idMatch[1];
                                let rotateValue = rotateMatch[1];
                
                                // Store values in an array for each product ID
                                if (!rotateValues[productId]) {
                                    rotateValues[productId] = [];
                                }
                                rotateValues[productId].push(rotateValue);
                            }
                        });
                    }

                    return rotateValues;
                }
                
                // Extract rotate values dynamically
                let rotateData = extractRotateValues();

                // Segments whose -hz could not be honoured: the module is sold
                // at another height (any module that is not banded keeps its
                // authored height, a banded one falls back to 45 mm when it
                // does not come at that height). One note after the loop.
                let restoredHeightChanges = 0;

                matchingProducts.forEach((product, index) => {
                  // Calculate size in blocks first, then pixels
                  let cellCountW = parseInt(product.w) || 1;
                  let cellCountH = parseInt(product.h) || 1;
                  cellCountW = Math.max(1, cellCountW);
                  cellCountH = Math.max(1, cellCountH);

                  const filteredProducts = products.filter((x,i) => {
                    return x.id === product.id && i === index
                  });

                
                  // Find the EXACT variant placed in this build. After the
                  // matchingProducts merge, product.id is the colour-specific variant
                  // id from the hash, so match on it directly. Fall back to any ordered
                  // variant of the product so older/edge builds still load.
                  const matchingVariant =
                    product.variants.find(v => Number(v.id) === Number(product.id)) ||
                    product.variants.find(v => selectedVariantIds.includes(Number(v.id)));
                  if (!matchingVariant) {
                    warn(`No matching variant found for product ${product.id}`);
                    return;
                  }

                  // Restore each module in ITS OWN variant colour — the build stores a
                  // colour-specific variant id per piece, so a mixed-colour drawer must
                  // redraw per piece. Prefer the variantId→colour map emitted by the
                  // theme (window.MD_VARIANT_COLORS), then the variant's own option,
                  // and only fall back to the active swatch when neither is present.
                  const variantColorRaw =
                    (window.MD_VARIANT_COLORS && window.MD_VARIANT_COLORS[product.id]) ||
                    matchingVariant?.option1 || matchingVariant?.color || '';
                  const selectedColorRaw = $('.colorsOption .active').attr('data-id') || '';
                  const colorToken = normalizeColorToken(variantColorRaw || selectedColorRaw || '');
                  const manifest = buildImageManifest(matchingProducts[index]);
                  let pair = pickShowHidden(manifest, colorToken, { productId: product.id, product: matchingProducts[index], path: 'deeplink' });
                  // Defensive: if the per-piece colour can't be resolved to an image,
                  // fall back to the active swatch colour so the module still RENDERS
                  // (never drop a tile just because its colour lookup missed). This
                  // preserves the pre-fix tile count as a hard floor.
                  if ((!pair.showUrl || !pair.hiddenUrl) && selectedColorRaw) {
                    const fallbackToken = normalizeColorToken(selectedColorRaw);
                    if (fallbackToken && fallbackToken !== colorToken) {
                      pair = pickShowHidden(manifest, fallbackToken, { productId: product.id, product: matchingProducts[index], path: 'deeplink' });
                    }
                  }
                  if (!pair.showUrl || !pair.hiddenUrl) {
                    warn('Deep-link missing show/hidden; skipping product', { id: product.id, token: colorToken });
                    return;
                  }
                  const imageData = pair.showUrl;
                  const imageThumb = pair.showUrl;
                
                  // Unique item ID based on existing items
                  const itemId = $('.droppable-area1 li').length + 1;
                
                  // Rotation value (take first entry if array, or false)
                  const rotateValues = filteredProducts[0].r || [];
                  const rotateValue = Array.isArray(rotateValues) ? rotateValues[0] : rotateValues;
                
                  // Position on the grid (block coordinates from hash)
                  let blockTop  = parseInt(product.t) || 0;
                  let blockLeft = parseInt(product.l) || 0;

                  // Clamp to grid so modules never render out of bounds
                  if (blockTop + cellCountH > gridRows) {
                    warn('[DRAWER-BUILDER] hash module overflows vertically; clamping', {
                      id: product.id,
                      blockTop,
                      cellCountH,
                      gridRows
                    });
                    blockTop = Math.max(0, gridRows - cellCountH);
                  }
                  if (blockLeft + cellCountW > gridCols) {
                    warn('[DRAWER-BUILDER] hash module overflows horizontally; clamping', {
                      id: product.id,
                      blockLeft,
                      cellCountW,
                      gridCols
                    });
                    blockLeft = Math.max(0, gridCols - cellCountW);
                  }

                  const proWidth = cellCountW * cellSize;
                  const proLength = cellCountH * cellSize;
                  const topPos  = blockTop * cellSize;
                  const leftPos = blockLeft * cellSize;
                
                  // Determine color: prefer selected color token
                  const color = colorToken || matchingVariant.color 
                    || (imageData && imageData.match(/_drawerbuilder_([^_]+)_show/i)?.[1] || "");

                  log("product in matching products", product);

                  // Explicit per-placement intent wins. A build target alone
                  // cannot convert an authored part into resized geometry.
                  const restoreProductId = product.productId || product.id;
                  const restoredIdentity = restoredHeightIdentity(product.hz, product.hb, product.hr, variantPricing(product.id).heightMm);
                  const requestedHeightMm = restoredIdentity.heightMm;
                  const restoredBasis = restoredIdentity.basis;
                  const recordedVariantId = product.recordedVariantId || product.id;
                  if (placementForItem(restoreProductId, color, requestedHeightMm, recordedVariantId, matchingVariant.price, restoredBasis, product.hr).unavailable) {
                    restoredHeightChanges += 1;
                  }

                  // Place the item into the editor
                  addItem(
                    $editor,
                    proLength,
                    proWidth,
                    imageData,
                    imageThumb,
                    pair.hiddenUrl,            // hidden-data
                    recordedVariantId,
                    // product id (older deep-link payloads used `productId`; minimal payload uses `id`)
                    restoreProductId,
                    itemId,
                    color,
                    "",            // extraClass
                    matchingVariant.price,
                    leftPos,
                    topPos,
                    rotateValue,
                    true, // Coming from URL, so don't change position
                    requestedHeightMm,
                    null,
                    restoredBasis,
                    product.hr
                  );

                  // Total price is maintained by addItem() (which runs for
                  // every placed module, URL or manual). Do NOT re-add it here:
                  // a second addition double-counted each module's price on the
                  // deep-link / share-link load path, making the "Add to Cart"
                  // total show ~2× the real amount versus the cart subtotal.
                });

                if (restoredHeightChanges > 0 && pausedCustomHeightRequest(selectedModuleHeightMm())) {
                  showBuilderHeightMessage(mdT('modu.builder_js.custom_height_paused'));
                }

                // A single-finish share link also sets the palette for the next
                // item the customer adds. Per-piece colours stay authoritative;
                // mixed-colour links keep their existing palette selection.
                var restoredColours = $('.droppable-area1 .draggable-item').map(function () {
                  return normalizeColorToken($(this).attr('data-color') || '');
                }).get();
                var restoredFinish = restoredColours[0];
                if (restoredFinish && restoredColours.every(function (colour) { return colour === restoredFinish; })) {
                  updateImageView(restoredFinish);
                  applyHeightAvailability(selectedModuleHeightMm());
                }

                // After placing all items from URL, stabilize inner div positions
                // This handles race conditions where layout settles after initial placement
                setTimeout(function() {
                  syncInnerDivDimensions();
                }, 100);
              }
          }
      } else {
          updateGridInfo();
          $('#changeDimension').click();
      }
  }

  $(function () {
    restoreLegacyHash(window.location.hash.substring(1), { initial: true });
  });

  /**
   * Sync all inner div dimensions to match their parent li elements.
   * This fixes any misalignment caused by race conditions during page load.
   */
  function syncInnerDivDimensions() {
    var cellSize = getCurrentCellSize();
    if (!cellSize) return;

    $('.droppable-area1 .draggable-item').each(function() {
      var $item = $(this);
      var $inner = $item.children('div').first();
      if (!$inner || !$inner.length) return;

      var itemWidth = $item.width();
      var itemHeight = $item.height();
      var isRotated = $item.hasClass('rotated');

      // For rotated items, inner div dimensions are swapped (before CSS rotation)
      var innerW = isRotated ? itemHeight : itemWidth;
      var innerH = isRotated ? itemWidth : itemHeight;

      $inner.css({
        width: innerW,
        height: innerH,
        'background-size': '100% 100%',
        'background-position': 'center center',
        'background-repeat': 'no-repeat'
      });
    });

    log('[DrawerBuilder] syncInnerDivDimensions completed');
  }

  // Expose for debugging
  if (MD_DEBUG_BUILDER) {
    window.MD_BUILDER_SYNC = {
      syncInnerDivDimensions: syncInnerDivDimensions
    };
  }

  // md-builder-inplace-start
  // URL restore intentionally repairs historical links. New generated choices
  // pass an additional, non-mutating preflight: a stale catalogue must never
  // turn a preview into a different, partially populated drawer.
  var mdLayoutApplySerial = 0;
  var mdLayoutApplyQueue = Promise.resolve();
  var mdLayoutApplying = false;
  var mdLastCommittedLayoutHash = null;

  function confirmedEffectiveLayoutHash() {
    var snapshot = getConfirmedLayoutState();
    if (!snapshot) return null;
    return snapshot.hash + ($('body').attr('data-true-to-size') === 'yes' ? '&tts=1' : '') +
      ($('body').attr('data-ikea-maximera') === 'yes' ? '&ikea=1' : '');
  }

  function emitBuilderLayoutEvent(name, detail) {
    // Events are observations, never a dependency of editing or commerce.
    try { document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail })); } catch (_) {}
  }

  function emitCommittedLayout(source) {
    if (mdLayoutApplying) return;
    var hash = confirmedEffectiveLayoutHash();
    if (!hash || hash === mdLastCommittedLayoutHash) return;
    mdLastCommittedLayoutHash = hash;
    emitBuilderLayoutEvent('db:layout-committed', {
      source: source || 'builder', hash: hash,
      placementCount: $('.droppable-area1 .list-view-item.draggable-item').length
    });
  }

  function preflightLayoutHash(fragment) {
    var raw = String(fragment == null ? '' : fragment).replace(/^#/, '');
    if (raw.length > 100000) throw new Error('layout_too_large');
    var parts = raw.split('&');
    var dimensions = /^(\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)$/.exec(parts[0]);
    if (!dimensions) throw new Error('invalid_dimensions');
    var length = Number(dimensions[1]);
    var width = Number(dimensions[2]);
    if (!(length >= GRID_UNIT_MM && width >= GRID_UNIT_MM) ||
        length > TTS_MAX_DIMENSION_MM || width > TTS_MAX_DIMENSION_MM) throw new Error('invalid_dimensions');
    var rows = Math.floor(length / GRID_UNIT_MM);
    var cols = Math.floor(width / GRID_UNIT_MM);
    var tokens = {};
    var segments = [];
    parts.slice(1).forEach(function (part) {
      var metadata = /^(tts|ikea|ch|mh)=(\d+)$/.exec(part);
      if (metadata) {
        if (tokens[metadata[1]] !== undefined) throw new Error('duplicate_metadata');
        if (metadata[1] !== 'mh' && metadata[2] !== '1') throw new Error('invalid_metadata');
        tokens[metadata[1]] = Number(metadata[2]);
        return;
      }
      var match = /^(\d+)-h=(\d+)-w=(\d+)-t=(\d+)-l=(\d+)-r=(true|false)(?:-hz=(\d+(?:\.\d+)?))?(?:-hb=(f1))?(?:-hr=([a-f0-9]{64}))?$/.exec(part);
      if (!match) throw new Error('invalid_placement');
      segments.push({ recordedId: match[1], h: Number(match[2]), w: Number(match[3]),
        t: Number(match[4]), l: Number(match[5]), r: match[6] === 'true',
        hz: match[7], hb: match[8], hr: match[9] });
    });
    if (!segments.length || segments.length > rows * cols) throw new Error('invalid_placement_count');
    var target = tokens.mh === undefined ? STANDARD_MODULE_HEIGHT_MM : tokens.mh;
    if (!Number.isSafeInteger(target) || target < CUSTOM_MODULE_HEIGHT_MIN_MM || target > CUSTOM_MODULE_HEIGHT_MAX_MM) {
      throw new Error('invalid_target_height');
    }
    var custom = tokens.ch === 1 || target !== STANDARD_MODULE_HEIGHT_MM ||
      segments.some(function (segment) { return segment.hb === 'f1'; });
    if (custom && (!customHeightInputEnabled() || !customHeightPurchasesEnabled())) throw new Error('custom_height_unavailable');
    if (custom && tokens.tts) throw new Error('custom_height_fit_unavailable');
    if (tokens.tts && (tokens.ikea || !$('#db-true-to-size').length || !mdTtsEligibilityForDrawer(length, width).eligible)) {
      throw new Error('fit_unavailable');
    }
    if (tokens.ikea && !$('#db-ikea-maximera').length) throw new Error('fit_unavailable');
    var catalogue = new Map();
    allProductData.forEach(function (product) {
      (product.variants || []).forEach(function (variant) { catalogue.set(String(variant.id), { product: product, variant: variant }); });
    });
    var occupied = new Set();
    segments.forEach(function (segment) {
      var canonicalId = canonicalBuilderVariantId(segment.recordedId);
      // Dedicated height-band ids have an explicit source identity. Retired
      // variant aliases, unlike historical URL restoration, are not a match.
      if (canonicalId !== segment.recordedId && !(window.MD_BAND_INDEX || {})[segment.recordedId]) throw new Error('retired_variant');
      var entry = catalogue.get(String(canonicalId));
      if (!entry || entry.variant.available !== true) throw new Error('variant_unavailable');
      var grid = getCatalogueGridSize(entry.product);
      var h = grid && (segment.r ? grid.width : grid.height);
      var w = grid && (segment.r ? grid.height : grid.width);
      if (segment.h !== h || segment.w !== w || !(h > 0 && w > 0)) throw new Error('footprint_mismatch');
      if (segment.t + h > rows || segment.l + w > cols) throw new Error('placement_out_of_bounds');
      for (var row = segment.t; row < segment.t + h; row += 1) {
        for (var col = segment.l; col < segment.l + w; col += 1) {
          var cell = row * cols + col;
          if (occupied.has(cell)) throw new Error('placement_overlap');
          occupied.add(cell);
        }
      }
      var color = normalizeColorToken((window.MD_VARIANT_COLORS || {})[canonicalId] || entry.variant.option1 || entry.variant.color || '');
      if (!color) throw new Error('colour_unavailable');
      var media = buildImageManifest(entry.product)[color];
      // A hidden-only tile is valid. Inventing a hidden URL from a show URL
      // is legacy compatibility, not evidence that the media exists.
      if (!media || !media.hidden) throw new Error('media_unavailable');
      var band = (window.MD_BAND_INDEX || {})[segment.recordedId];
      var explicitHeight = segment.hz === undefined && band ? band.heightMm : segment.hz;
      var identity = restoredHeightIdentity(explicitHeight, segment.hb, segment.hr, variantPricing(canonicalId).heightMm);
      var model = tileHeightModel(catalogueTileFor(entry.product.id), color, custom);
      var placement = resolvePlacementHeight(model, identity.heightMm, heightBandsMm());
      if (!placement || placement.unavailable ||
          (String(placement.id) !== segment.recordedId && String(placement.checkoutId) !== segment.recordedId) ||
          placement.heightMm !== identity.heightMm || (placement.heightBasis || 'authored') !== identity.basis ||
          (placement.heightContract || '') !== (identity.revision || '') || !Number.isFinite(Number(placement.price))) {
        throw new Error('height_or_variant_mismatch');
      }
      segment.id = String(placement.id);
      segment.productId = String(entry.product.id);
      segment.color = color;
      segment.heightMm = identity.heightMm;
      segment.basis = identity.basis;
      segment.revision = identity.revision || '';
      segment.price = Number(placement.price);
      segment.media = media;
    });
    return { fragment: raw, length: length, width: width, target: target, custom: custom,
      trueToSize: tokens.tts === 1, ikea: tokens.ikea === 1, segments: segments };
  }

  function waitForLayoutCatalogue(serial) {
    var deadline = Date.now() + 5000;
    return new Promise(function (resolve, reject) {
      function check() {
        if (serial !== mdLayoutApplySerial) return reject(new Error('superseded'));
        if (typeof allProductData !== 'undefined' && Array.isArray(allProductData) && allProductData.length &&
            $('.droppable-area1').length && $('.mineProList').length && getCurrentCellSize() > 0) return resolve();
        if (Date.now() >= deadline) return reject(new Error('builder_not_ready'));
        setTimeout(check, 50);
      }
      check();
    });
  }

  function verifyAppliedLayout(plan) {
    var state = getConfirmedLayoutState();
    var items = $('.droppable-area1 .list-view-item.draggable-item');
    var cell = getCurrentCellSize();
    var valid = Boolean(state && cell > 0 && items.length === plan.segments.length &&
      state.dimensions.length === plan.length && state.dimensions.width === plan.width &&
      selectedModuleHeightMm() === plan.target &&
      ($('body').attr('data-true-to-size') === 'yes') === plan.trueToSize &&
      ($('body').attr('data-ikea-maximera') === 'yes') === plan.ikea && !window.MD_LAYOUT_RESTORE_INCOMPLETE);
    var total = 0;
    items.each(function (index) {
      var item = $(this);
      var expected = plan.segments[index];
      if (!expected) { valid = false; return; }
      var near = function (actual, wanted) { return Math.abs(Number(actual) - wanted) < 0.01; };
      var image = item.children('div').first();
      var show = item.attr('data-exist');
      var allowedShow = show === expected.media.hidden || Object.keys(expected.media.show).some(function (key) { return expected.media.show[key] === show; });
      valid = valid && String(item.attr('data-id')) === expected.id &&
        String(item.attr('product-id')) === expected.productId &&
        normalizeColorToken(item.attr('data-color')) === expected.color &&
        item.hasClass('rotated') === expected.r &&
        Number(item.attr('data-height-mm')) === expected.heightMm &&
        (item.attr('data-height-basis') || 'authored') === expected.basis &&
        (item.attr('data-height-contract') || '') === expected.revision &&
        item.attr('data-height-unavailable') !== 'true' &&
        Number(item.attr('price')) === expected.price &&
        near(parseFloat(item.css('top')), expected.t * cell) && near(parseFloat(item.css('left')), expected.l * cell) &&
        near(item.width(), expected.w * cell) && near(item.height(), expected.h * cell) &&
        near(image.width(), (expected.r ? expected.h : expected.w) * cell) &&
        near(image.height(), (expected.r ? expected.w : expected.h) * cell) &&
        allowedShow && item.attr('data-hidden') === expected.media.hidden;
      total += expected.price;
    });
    if (!valid || Number($('.totalPrice').attr('pricemine')) !== total) throw new Error('layout_verification_failed');
  }

  function commitInplaceLayout(plan, source, serial) {
    if (serial !== mdLayoutApplySerial) throw new Error('superseded');
    var editor = $('.droppable-area1');
    var oldIncomplete = window.MD_LAYOUT_RESTORE_INCOMPLETE;
    var oldRegion = window.MD_spaceFit;
    var oldColour = $('.colorsOption .active').attr('data-id');
    var oldHeight = selectedModuleHeightMm();
    var oldCustom = Boolean(window.MD_HeightControls && window.MD_HeightControls.customConfirmed());
    var fitSource = source === 'onboarding' ? ($('body').attr('data-fit-preference-source') || 'default') : source;
    // updateGridInfo also changes rulers and canvas styles. Retain their exact
    // attributes for rollback, along with field drafts (which are not orders).
    var saved = [];
    document.querySelectorAll('body, .drawerBundle, .fs-canvas__space, .canvas-wrapper, .fs-canvas__canvas, .drawerSize, .drawerSize *, #db-module-height, #db-custom-height, .totalPrice').forEach(function (node) {
      saved.push({ node: node, attributes: Array.from(node.attributes).map(function (attr) { return [attr.name, attr.value]; }),
        value: node.value, checked: node.checked });
    });
    var oldTotal = $('.totalPrice').attr('pricemine');
    var oldChildren = editor.children().detach();
    var hash;
    mdLayoutApplying = true;
    try {
      window.MD_LAYOUT_RESTORE_INCOMPLETE = false;
      mdSetFitPreference(plan.trueToSize ? 'true-to-size' : 'standard', fitSource);
      $('#db-ikea-maximera').prop('checked', plan.ikea);
      $('body').attr('data-ikea-maximera', plan.ikea ? 'yes' : 'no');
      $('.totalPrice').attr('pricemine', '0').text(mdFormatMoney(0));
      restoreLegacyHash(plan.fragment);
      mdSetFitPreference(plan.trueToSize ? 'true-to-size' : 'standard', fitSource);
      mdSyncFitPreference(mdTtsEligibilityForDrawer(plan.length, plan.width).eligible);
      syncInnerDivDimensions();
      if (serial !== mdLayoutApplySerial) throw new Error('superseded');
      verifyAppliedLayout(plan);
      hash = confirmedEffectiveLayoutHash();
      window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search + '#' + hash);
    } catch (error) {
      editor.empty().append(oldChildren);
      window.MD_LAYOUT_RESTORE_INCOMPLETE = oldIncomplete;
      window.MD_spaceFit = oldRegion;
      var restoreAttributes = function () {
        saved.forEach(function (record) {
          Array.from(record.node.attributes).forEach(function (attr) { record.node.removeAttribute(attr.name); });
          record.attributes.forEach(function (attr) { record.node.setAttribute(attr[0], attr[1]); });
          if (record.value !== undefined) record.node.value = record.value;
          if (record.checked !== undefined) record.node.checked = record.checked;
        });
      };
      restoreAttributes();
      try {
        if (window.MD_HeightControls) window.MD_HeightControls.restore(oldHeight, oldCustom);
        if (oldColour) updateImageView(oldColour);
        // Repaint readouts from confirmed dimensions, preserving any unapplied
        // field drafts when the exact saved attributes are restored below.
        $('input[name="length"]').val($('input[name="length"]').attr('data-original'));
        $('input[name="width"]').val($('input[name="width"]').attr('data-original'));
        updateGridInfo(); syncInnerDivDimensions(); applyHeightAvailability(oldHeight);
      } catch (_) {}
      restoreAttributes();
      $('.totalPrice').attr('pricemine', oldTotal).text(mdFormatMoney(oldTotal));
      throw error;
    } finally {
      mdLayoutApplying = false;
    }
    // The verified canvas and URL are now committed. Auxiliary UI observers
    // cannot turn that success into a rollback after old nodes were disposed.
    oldChildren.remove();
    $('.drawerBundle .list-view-item, .mineProList').removeClass('active');
    $('.canvas-hoverd-item-btn-rotate, .canvas-hoverd-item-btn-remove, .canvas-hoverd-item-btn-size').remove();
    $('.db-mobile-selection-actions-row').empty();
    $('.db-layout-restore-error').remove();
    $('#db-hide-grid-btn').removeClass('active').find('span').text(mdT('modu.builder.hide'));
    try { if (typeof window.MD_clearSpaceFit === 'function') window.MD_clearSpaceFit(); } catch (_) {}
    window.MD_spaceFit = null;
    $('body').removeClass('drawer-empty db-canvas-dragging');
    try { if (typeof applyFiltersAndPaginate === 'function') applyFiltersAndPaginate(); } catch (_) {}
    try { if (typeof window.MD_updateMobileSheetPeek === 'function') window.MD_updateMobileSheetPeek(); } catch (_) {}
    emitCommittedLayout(source);
    var result = { ok: true, hash: hash, placementCount: plan.segments.length };
    emitBuilderLayoutEvent('db:layout-applied', Object.assign({ source: source }, result));
    return result;
  }

  function applyLayoutFromHash(fragment, options) {
    options = options || {};
    var serial = ++mdLayoutApplySerial;
    var source = options.source || 'generated-layout';
    // Both APIs use the established legacy renderer. New callers always get
    // strict validation; only the initial historical URL may repair placements.
    var pending = mdLayoutApplyQueue.catch(function () {}).then(function () {
      return waitForLayoutCatalogue(serial);
    }).then(function () {
      if (serial !== mdLayoutApplySerial) throw new Error('superseded');
      return commitInplaceLayout(preflightLayoutHash(fragment), source, serial);
    }).catch(function (error) {
      return { ok: false, error: error && error.message || 'layout_apply_failed' };
    });
    mdLayoutApplyQueue = pending;
    return pending;
  }

  function cancelPendingLayoutApply() {
    mdLayoutApplySerial += 1;
  }
  // md-builder-inplace-end

  $('.info-dragger svg').on('click', function() {
    $('.info-dragger').remove();
})

// NOTE: Removed unused/incomplete helpers (kept in git history):
// - blockSizeInPx
// - checkPosByBlock

function formatDrawerDimension(n) {
  const s = String(n);
  return s.indexOf('.') >= 0 ? s.replace(/\.0+$/, '').replace(/(\.[1-9]*)0+$/, '$1') : s;
}

function getConfirmedDrawerDimensions() {
  const readConfirmed = function ($input, fallback) {
    let value = parseFloat($input.attr('data-original'));
    if (!Number.isFinite(value) || value <= 0) value = parseFloat($input.val());
    if (!Number.isFinite(value) || value <= 0) value = parseFloat(fallback) || 0;
    return value;
  };
  return {
    length: readConfirmed($('input[name="length"]'), defaultLength),
    width: readConfirmed($('input[name="width"]'), defaultWidth)
  };
}

/**
 * Read one authoritative layout snapshot. Drawer millimetres come from the
 * confirmed Apply state; module blocks come from the cell that rendered them.
 * Mixing raw input values with the old canvas height is what changed a 9x2
 * module into h=8 after a cancelled resize.
 */
function getConfirmedLayoutState() {
  const dimensions = getConfirmedDrawerDimensions();
  const cellSize = getCurrentCellSize();
  if (!dimensions.length || !dimensions.width || !cellSize) return null;

  const segments = [];
  $('.droppable-area1 .list-view-item.draggable-item').each(function () {
    const $item = $(this);
    const variantId = $item.attr('data-id') || $item.attr('data-variant-id') || $item.attr('variant-id');
    if (!variantId) return;

    const topPx = parseFloat($item.css('top')) || 0;
    const leftPx = parseFloat($item.css('left')) || 0;
    const widthPx = parseFloat($item.css('width')) || 0;
    const heightPx = parseFloat($item.css('height')) || 0;
    const topBlocks = Math.round(topPx / cellSize);
    const leftBlocks = Math.round(leftPx / cellSize);
    const heightBlocks = Math.max(1, Math.round(heightPx / cellSize));
    const widthBlocks = Math.max(1, Math.round(widthPx / cellSize));
    const rotated = $item.hasClass('rotated') ? 'true' : 'false';
    const heightMm = Number($item.attr('data-height-mm')) || STANDARD_MODULE_HEIGHT_MM;
    const heightSuffix = placementHeightSuffix(heightMm, $item.attr('data-height-basis') || 'authored', $item.attr('data-height-contract'));

    segments.push(`${variantId}-h=${heightBlocks}-w=${widthBlocks}-t=${topBlocks}-l=${leftBlocks}-r=${rotated}${heightSuffix}`);
  });

  const dimensionsString = `${formatDrawerDimension(dimensions.length)}x${formatDrawerDimension(dimensions.width)}`;
  const targetHeightSegment = customHeightInputEnabled() ? `&mh=${selectedModuleHeightMm()}` : '';
  const customHeightSegment = window.MD_HeightControls && window.MD_HeightControls.customConfirmed() ? '&ch=1' : '';
  return {
    dimensions: dimensions,
    dimensionsString: dimensionsString,
    cellSize: cellSize,
    segments: segments,
    hash: dimensionsString + targetHeightSegment + customHeightSegment + (segments.length ? `&${segments.join('&')}` : '')
  };
}

function createURL() {
  if (mdLayoutApplying) return;
  const layoutState = getConfirmedLayoutState();
  if (!layoutState) return;

  // History API only accepts same-origin URLs. Deriving the origin keeps the
  // live share URL canonical while allowing Shopify's isolated preview host
  // to exercise the complete builder flow without a SecurityError.
  let url = window.location.origin + mdRoot('pages/drawer-builder');
  // Keep the query string (?bid=<uuid> from a saved-build link) so a reload
  // mid-session doesn't lose the build identity — pushState would drop it.
  if (window.location.search) {
    url += window.location.search;
  }
  url += `#${layoutState.hash}`;

  // True-to-size opt-in rides the share URL as a bare `tts=1` token so the
  // toggle round-trips on restore. The hash-parse loop and the rotate regex
  // both ignore non-`variantId-h=…` tokens, so it never confuses item parsing.
  if ($('body').attr('data-true-to-size') === 'yes') {
    url += '&tts=1';
  }
  if ($('body').attr('data-ikea-maximera') === 'yes') {
    url += '&ikea=1';
  }

  window.history.pushState(null, null, url);
  emitCommittedLayout('builder');
}

// Several legacy delegated handlers live outside this ready callback. Give
// them a deliberately small bridge into initialized builder state instead of
// relying on callback-local names that are not in their lexical scope.
window.MD_BuilderLegacyContext = {
  defaultLength: defaultLength,
  defaultWidth: defaultWidth,
  createConfirmedURL: createURL,
  getConfirmedLayoutState: getConfirmedLayoutState,
  getConfirmedEffectiveHash: confirmedEffectiveLayoutHash,
  applyLayoutFromHash: applyLayoutFromHash,
  cancelPendingLayoutApply: cancelPendingLayoutApply,
  countWallAdjacentModules: countWallAdjacentModules,
  setDimensionErrors: setDimensionErrors,
  getOrderBuildUuid: function () {
    return sourceBuildUuid || newBuildUuid();
  }
};

function mdPushDL(payload) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  } catch (e) { /* analytics must never break the builder */ }
}

function mdShareEventParams() {
  var confirmed = getConfirmedDrawerDimensions();
  return {
    drawer_length: confirmed.length || null,
    drawer_width: confirmed.width || null,
    module_count: $('.droppable-area1 .list-view-item').length
  };
}

// md-share-url-start
// An outbound share URL drops the sharer's click identifiers and campaign
// tags. Otherwise the recipient's visit is credited to the sharer's paid click
// (GA4 session source, Google Ads click ID) or tied to the sharer's Klaviyo
// profile (_kx). Every other parameter stays, including the saved-build ?bid=.
// tests/builder-share-url.test.js evaluates this block verbatim; keep it free
// of DOM globals.
var MD_SHARE_STRIP_PARAM = /^(?:ai|ai_set|ai_option|utm_[a-z0-9_]+|gclid|gclsrc|dclid|gbraid|wbraid|gad_[a-z0-9_]+|srsltid|_gl|fbclid|msclkid|ttclid|twclid|li_fat_id|epik|_kx)$/i;

function mdCleanShareHref(href) {
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  var hash = i >= 0 ? href.slice(i) : '';
  var q = base.indexOf('?');
  if (q >= 0) {
    var kept = base.slice(q + 1).split('&').filter(function (pair) {
      if (!pair) return false;
      var key = pair.split('=')[0];
      try { key = decodeURIComponent(key.replace(/\+/g, ' ')); } catch (e) { /* keep the raw key */ }
      return !MD_SHARE_STRIP_PARAM.test(key);
    });
    base = base.slice(0, q) + (kept.length ? '?' + kept.join('&') : '');
  }
  if (!/[?&]shared=1(?:&|$)/.test(base)) base += (base.indexOf('?') >= 0 ? '&' : '?') + 'shared=1';
  return base + hash;
}
// md-share-url-end

function mdBuildShareUrl() {
  return mdCleanShareHref(window.location.href);
}

//   // working URL function 14/4/25
$(document).ready(function() {

  $('.get-dimensions').on('click', function() {
    createURL();

    const url = mdBuildShareUrl();

    if (navigator.share) {
      navigator.share({
        title: mdT('modu.builder.share_title'),
        text: mdT('modu.builder.share_text'),
        url: url
      }).then(() => {
        log('Shared successfully');
        mdPushDL(Object.assign({event: 'share_click', share_method: 'web_share'}, mdShareEventParams()));
      }).catch(err => {
        console.error('Share failed:', err);
      });
    } else {
      navigator.clipboard.writeText(url).then(() => {
        log("URL copied to clipboard:", url);
        alert(mdT('modu.builder.url_copied'));
        mdPushDL(Object.assign({event: 'share_click', share_method: 'clipboard'}, mdShareEventParams()));
      }).catch(err => {
        console.error("Failed to copy URL:", err);
      });
    }

    // log("Final URL:", url);
  });

  // ---------------------------------------------------------------------
  // True-to-size opt-in
  //
  // The checkbox writes the choice onto body[data-true-to-size] (mirrors the
  // grid-* attrs) and refreshes the share URL so the toggle round-trips. The
  // "?" info button mirrors the aria-aware tooltip pattern in
  // drawer-builder.js (click to open, aria-expanded/aria-hidden, Escape +
  // outside-click close). No price logic here — true-to-size is free.
  // ---------------------------------------------------------------------
  $('#db-true-to-size').on('change', function (event) {
    $('body').attr('data-true-to-size', this.checked ? 'yes' : 'no');
    // Funnel completion and URL restoration are programmatic; only a real
    // control interaction is evidence that this choice was actively made.
    if (event.originalEvent && (event.originalEvent.isTrusted ||
        (event.originalEvent.detail && event.originalEvent.detail.source === 'height-panel'))) {
      mdSetFitPreference(this.checked ? 'true-to-size' : 'standard', 'explicit');
      $('body').attr('data-fit-choice-source', 'explicit');
    }
    // Mutually exclusive with IKEA MAXIMERA (both customise the edge modules).
    if (this.checked) {
      var $ikea = $('#db-ikea-maximera');
      if ($ikea.length && $ikea.prop('checked')) {
        $ikea.prop('checked', false);
        $('body').attr('data-ikea-maximera', 'no');
        if (typeof updateIkeaReadout === 'function') { updateIkeaReadout(); }
      }
    }
    updateConvertedReadout();
    if (typeof createURL === 'function') {
      try { createURL(); } catch (e) { warn('createURL failed on true-to-size toggle:', e); }
    }
  });

  var ttsInfo = document.querySelector('.db-tts__info');
  var ttsTip = document.getElementById('db-tts-tooltip');
  if (ttsInfo && ttsTip) {
    var closeTtsTip = function () {
      ttsInfo.setAttribute('aria-expanded', 'false');
      ttsTip.setAttribute('aria-hidden', 'true');
    };
    ttsInfo.addEventListener('click', function (event) {
      event.stopPropagation();
      var expanded = ttsInfo.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        closeTtsTip();
      } else {
        ttsInfo.setAttribute('aria-expanded', 'true');
        ttsTip.setAttribute('aria-hidden', 'false');
      }
    });
    document.addEventListener('click', function (event) {
      var wrap = ttsInfo.closest('.db-true-to-size');
      if (wrap && !wrap.contains(event.target)) {
        closeTtsTip();
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeTtsTip();
      }
    });
  }

  // ---------------------------------------------------------------------
  // IKEA MAXIMERA option (only present when the section setting is enabled).
  // Writes the choice to body[data-ikea-maximera], is mutually exclusive with
  // true-to-size, refreshes the surcharge readout, and round-trips via the
  // share URL. The "?" tooltip mirrors the true-to-size aria pattern.
  // ---------------------------------------------------------------------
  if (document.getElementById('db-ikea-maximera')) {
    $('#db-ikea-maximera').on('change', function () {
      if (this.checked) {
        mdSetFitPreference('standard', 'explicit');
        $('body').attr('data-ikea-maximera', 'yes');
        if ($('#db-true-to-size').prop('checked')) {
          $('#db-true-to-size').prop('checked', false);
          $('body').attr('data-true-to-size', 'no');
          $('body').attr('data-fit-choice-source', 'unavailable');
          updateConvertedReadout();
        }
      } else {
        $('body').attr('data-ikea-maximera', 'no');
      }
      updateIkeaReadout();
      if (typeof createURL === 'function') {
        try { createURL(); } catch (e) { warn('createURL failed on IKEA toggle:', e); }
      }
    });

    var ikeaInfo = document.querySelector('.db-ikea-maximera .db-tts__info');
    var ikeaTip = document.getElementById('db-ikea-tooltip');
    if (ikeaInfo && ikeaTip) {
      var closeIkeaTip = function () {
        ikeaInfo.setAttribute('aria-expanded', 'false');
        ikeaTip.setAttribute('aria-hidden', 'true');
      };
      ikeaInfo.addEventListener('click', function (event) {
        event.stopPropagation();
        var expanded = ikeaInfo.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          closeIkeaTip();
        } else {
          ikeaInfo.setAttribute('aria-expanded', 'true');
          ikeaTip.setAttribute('aria-hidden', 'false');
        }
      });
      document.addEventListener('click', function (event) {
        var wrap = ikeaInfo.closest('.db-ikea-maximera');
        if (wrap && !wrap.contains(event.target)) {
          closeIkeaTip();
        }
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeIkeaTip();
        }
      });
    }
    updateIkeaReadout();
  }

  // ---------------------------------------------------------------------
  // Save Build flow
  //
  // Anonymous users: open the auth modal (md-auth.js), which stashes
  //   sessionStorage[md_return_url] + sessionStorage[md_pending_save] before
  //   the form posts. After Shopify redirects to /account, md-auth.js sends
  //   the customer back to /pages/drawer-builder#... and fires the
  //   `md:auth:resume-save` event so we can finish the save without further
  //   user input.
  //
  // Logged-in users: open the save dialog (name + optional drawer profile),
  //   render a thumbnail off-screen, and call MD_Favourites.saveBuild().
  // ---------------------------------------------------------------------
  function ensureItemsExist() {
    return $('.list-view-item.draggable-item').length > 0;
  }

  function fetchProfilesForSave(cb) {
    if (window.MD_DrawerProfiles && typeof window.MD_DrawerProfiles.listAsync === 'function') {
      window.MD_DrawerProfiles.listAsync(cb);
    } else {
      cb([]);
    }
  }

  function performSave(payload) {
    // Render a thumbnail (best-effort; never blocks the save).
    renderBuildThumbnail()
      .catch(function () { return null; })
      .then(function (thumb) {
        if (window.MD_Favourites && typeof window.MD_Favourites.saveBuild === 'function') {
          window.MD_Favourites.saveBuild({
            name: payload.name || '',
            pathname: window.location.pathname,
            hash: window.location.hash,
            drawerProfileId: payload.drawerProfileId || null,
            thumbnail: thumb || null
          });
        }
      });
  }

  $('.db-save-build').on('click', function () {
    if (!ensureItemsExist()) {
      // Surface the "nothing to save" prompt as an in-canvas toast (same
      // pattern as the other builder messages) instead of a blocking alert().
      var $saveTarget = $('.fs-canvas__space .canvas-wrapper');
      if ($saveTarget.length) {
        $saveTarget.find('.error-message').remove();
        var $saveMsg = $('<div class="error-message db-canvas-msg"></div>').text(mdT('modu.builder.nothing_to_save'));
        $saveTarget.append($saveMsg);
        $saveMsg.fadeIn(400).delay(3000).fadeOut(400, function () { $(this).remove(); });
      }
      return;
    }

    // Always rebuild the URL hash so the saved hash reflects the latest state.
    createURL();

    var customerId = (window.MD_FAV && window.MD_FAV.customerId) || null;
    var isGuest = !customerId;

    // Guests save to this device (no login wall). performSave -> saveBuild
    // routes to localStorage when logged out and auto-syncs to the account on
    // the next logged-in visit. Show a brief toast so the save feels real.
    function notifyGuestSaved() {
      if (!isGuest) return;
      var $t = $('.fs-canvas__space .canvas-wrapper');
      if (!$t.length) return;
      $t.find('.error-message').remove();
      var $m = $('<div class="error-message db-canvas-msg"></div>').text(mdT('modu.builder.saved_to_device'));
      $t.append($m);
      $m.fadeIn(400).delay(3500).fadeOut(400, function () { $(this).remove(); });
    }

    if (!window.MD_Auth || typeof window.MD_Auth.openSaveDialog !== 'function') {
      // Safety fallback: simple prompt.
      var name = window.prompt(mdT('modu.builder.name_design'), '');
      if (name === null) return;
      performSave({ name: name, drawerProfileId: null });
      notifyGuestSaved();
      return;
    }

    function openSaveDialogWith(profiles) {
      // Pre-name from active profile if one is chosen via the For-drawer pill.
      var activeProfile = window.MD_BuilderActiveProfile || null;
      var defaultName = activeProfile
        ? activeProfile.name + ' · ' + new Date().toLocaleDateString()
        : '';
      window.MD_Auth.openSaveDialog({
        name: defaultName,
        profiles: profiles || [],
        drawerProfileId: activeProfile ? activeProfile.id : null,
        onSave: function (result) {
          performSave(result);
          notifyGuestSaved();
        }
      });
    }

    if (isGuest) {
      // Drawer profiles are an account feature, so skip the profile fetch and
      // let the guest name + save straight to this device.
      openSaveDialogWith([]);
    } else {
      fetchProfilesForSave(function (profiles) { openSaveDialogWith(profiles); });
    }
  });

  // Resume save after a post-login round-trip.
  window.addEventListener('md:auth:resume-save', function (e) {
    var pending = e && e.detail;
    if (!pending) return;
    // The hash should have been restored by the URL on landing; if it's not,
    // try to use the pending payload.
    if (!window.location.hash && pending.hash) {
      window.location.hash = pending.hash;
    }
    // Wait for the builder to finish parsing the hash before saving so the
    // canvas has items + we can render a thumbnail.
    setTimeout(function () {
      if (!ensureItemsExist()) return; // nothing meaningful to save
      if (pending.needsName && window.MD_Auth && window.MD_Auth.openSaveDialog) {
        fetchProfilesForSave(function (profiles) {
          window.MD_Auth.openSaveDialog({
            name: '',
            profiles: profiles,
            drawerProfileId: pending.drawerProfileId || null,
            onSave: function (result) { performSave(result); }
          });
        });
      } else {
        performSave({
          name: pending.name || '',
          drawerProfileId: pending.drawerProfileId || null
        });
      }
    }, 1500);
  });

});




  // <!-- new code teksyo 19-2-25 -->
  
// Rotate Function
$(document).on('touchend click', '.option.rotate', function(e) {
    e.preventDefault();
    e.stopPropagation();

    let $item = $('.draggable-item.active');
    let $editor = $('.droppable-area1');
    let gridSize = parseFloat($('.drawerBundle').attr('width')) || 10; // Default grid size

    const $el = $(this).closest('.draggable-item');
  
    // Force focus (touch-friendly)
    this.focus();


    try {
      $item.draggable('destroy');
      initiateDraggable($item, $editor, gridSize);
    } catch (err) {
      warn('Draggable destroy error', err);
    }
    
    toggleRotation($item);

    // Rotation changes the footprint, so a module can gain/lose wall contact.
    if (typeof updateIkeaReadout === 'function') { updateIkeaReadout(); }

    setTimeout(function () {
        createURL();
    }, 1000);
});

  // Remove Function
  $(document).on('click', '.option.remove', function () {
      
      let $item = $('.draggable-item.active');
      if (!$item.length) return;
  
      let idMine = $item.attr('data-id');
      let proPrice = $item.attr('price');
  
      $item.remove();
      // Remove existing option buttons
      $('.canvas-hoverd-item-btn-rotate, .canvas-hoverd-item-btn-remove, .canvas-hoverd-item-btn-size').remove();
  
      var totalPrice = parseFloat($('.totalPrice').attr('pricemine') || 0);
      var newPrice = totalPrice - parseFloat(proPrice);
      $('.totalPrice').attr('pricemine', newPrice);
      $('.totalPrice').text(mdFormatMoney(newPrice));
      if (typeof updateIkeaReadout === 'function') { updateIkeaReadout(); }
      $('.drawerBundle .list-view-item, .mineProList').removeClass('active');

      // The selection-actions row is now empty; recompute the bottom-sheet
      // peek so it doesn't keep the taller, stale value until a later
      // resize (matches the outside-tap deselect path).
      $('.db-mobile-selection-actions-row').empty();
      if (window.MD_updateMobileSheetPeek) {
        try { window.MD_updateMobileSheetPeek(); } catch (_) {}
      }

    setTimeout(function () {
          createURL();
      }, 1000);
  });
  
  function isColliding($item1, $item2, buffer = 0) {
      const item1Pos = $item1.position();
      const item2Pos = $item2.position();
  
      const item1Width = $item1.outerWidth();
      const item1Height = $item1.outerHeight();
      const item2Width = $item2.outerWidth();
      const item2Height = $item2.outerHeight();
  
      return !(
          ((item1Pos.top + item1Height - buffer) <= item2Pos.top) ||
          (item1Pos.top >= (item2Pos.top + item2Height - buffer)) ||
          ((item1Pos.left + item1Width - buffer) <= item2Pos.left) ||
          (item1Pos.left >= (item2Pos.left + item2Width - buffer))
      );
  }

  function initiateDraggable($item, $editor, gridSize) {
      // Check and destroy if already draggable
    
      $item.draggable({
          grid: [gridSize, gridSize],
          containment: "parent",
          start: function () {
              // Drag-focus: dim the product sheet so the canvas is the
              // visual focus while a piece is being placed. Class removed
              // on stop (below). CSS: body.drawer-builder.db-canvas-dragging.
              document.body.classList.add('db-canvas-dragging');
          },
          stop: function (event, ui) {
              document.body.classList.remove('db-canvas-dragging');
              let $item = $(this);
              let originalTop = Math.round(ui.originalPosition.top / gridSize) * gridSize;
              let originalLeft = Math.round(ui.originalPosition.left / gridSize) * gridSize;
              let newTop = Math.round(ui.position.top / gridSize) * gridSize;
              let newLeft = Math.round(ui.position.left / gridSize) * gridSize;
  
              $item.css({ top: newTop, left: newLeft });
  
              $editor.find('.draggable-item').not($item).each(function () {
                  if (isColliding($item, $(this), 1)) {
                      $item.css({ top: originalTop, left: originalLeft });
                      return false;
                  }
              });

              // A move can put a module onto (or off) a wall — refresh the
              // IKEA converted count.
              if (typeof updateIkeaReadout === 'function') { updateIkeaReadout(); }

             setTimeout(function () {
                createURL();
            }, 1000);
          }
      });
  }

   let selectedProduct = [];
    let matchedColor = null;
    let matchedImage = null;
  
  $('body').on('click', '.mineProList', function(){

      var activeColorRaw = $('.colorsOption .active').attr('data-id') || '';
      var colorCheck = normalizeColorToken(activeColorRaw);
      var normalizedColor = colorCheck;

      log('colorCheck ===>', colorCheck, 'rawColor ===>', activeColorRaw)
      var checkLength = $('input[name="length"]').val();
      var checkWidth = $('input[name="width"]').val();
       if (checkLength === '' || checkWidth === '') {
        let $targetContainer = $('.fs-canvas__space .canvas-wrapper');
        if ($targetContainer.length === 0) {
            console.error("Error: Target container not found.");
            return;
        }

        $targetContainer.find('.error-message').remove();

        let $errorContainer = $('<div class="error-message db-canvas-msg">First, Please Enter Length and Width for the Drawer.</div>');

        $targetContainer.append($errorContainer);

        $errorContainer.fadeIn(400).delay(3000).fadeOut(400, function () {
            $(this).remove();
        });
        log('Testing adding product---> If')

        return;
    } else {

        let productIds = $(this).attr('product-id');
         
        selectedProduct = allProductData.filter((item) => {
            if (item.id == productIds) {
                log('Final matchedImage:', matchedImage, matchedColor, colorCheck);

                const suffixes = ['_a', '_b', '_c', '_d', '_e', '_f', '_g', '_h', '_i']; // Extendable suffix list
                let suffixIndex = count % suffixes.length;
                let currentSuffix = suffixes[suffixIndex];

                // Filter images that contain any of the suffixes but NOT '_hidden'
                let validImages = item.images.filter(img =>
                    suffixes.some(suf => img.includes(suf)) && !img.includes('_hidden') && !img.includes('_Hidden')
                );

                // Further filter images that match the colorCheck
                let colorMatchedImages = validImages.filter(img => {
                    let match = img.match(/drawerbuilder_([A-Za-z]+)/);
                    let extractedColor = match ? match[1].toLowerCase() : null;
                    return extractedColor === normalizedColor;
                });

                // If no matching image is found, return false
                if (colorMatchedImages.length === 0) return false;

                // Prioritize image with the currentSuffix (_a, _b, _c, etc.)
                matchedImage = colorMatchedImages.find(img => img.includes(currentSuffix)) || colorMatchedImages[count % colorMatchedImages.length];
                matchedColor = colorCheck;

                log('matchedImage:', matchedImage);

                count++; // Increment count after each valid match
                return true; // Keep valid items
            }
            return false;
        });

         log("Total Matches:", count);

         let $editor = $('.droppable-area1');
         var selectedHeightMm = selectedModuleHeightMm();
         // A placement: id is the 45 mm source (banded) or authored variant,
         // price the price of the variant the line will buy at this height.
         var selectedHeightVariant = heightVariantForTile($(this), colorCheck, selectedHeightMm);
         if (!selectedHeightVariant || !Number.isFinite(selectedHeightVariant.price)) {
           showBuilderHeightMessage(paletteHeightMessage($(this), colorCheck, selectedHeightMm));
           return;
         }
         var proPrice = selectedHeightVariant.price;

         // Canonical picker based on product images
         var productIdForPick = $(this).attr('product-id');
         var productRec = (window.allProductData || []).find(function(p){ return String(p.id) === String(productIdForPick); });
         var manifest = buildImageManifest(productRec);
         var pair = pickShowHidden(manifest, colorCheck, { productId: productIdForPick, product: productRec, path: 'click' });
         if (!pair.showUrl || !pair.hiddenUrl) {
           warn('Missing show/hidden pair for canvas add', { productId: productIdForPick, color: colorCheck, manifest: manifest });
           return;
         }
         var imageData = pair.showUrl;
         var imageData1 = pair.showUrl;
        var productUrl = $(this).find('img').attr('url');
        var variantId = selectedHeightVariant.id;
        var productId = $(this).attr('product-id');
        var drawerWidth = parseFloat($('.drawerBundle').attr('width'));
        var drawerLength = parseFloat($('.drawerBundle').attr('length'));

        // Defensive: if sizing hasn't been initialized yet, compute it now.
        if (!Number.isFinite(drawerWidth) || !Number.isFinite(drawerLength)) {
          updateGridInfo();
          drawerWidth = parseFloat($('.drawerBundle').attr('width'));
          drawerLength = parseFloat($('.drawerBundle').attr('length'));
        }

        var width = parseFloat($(this).attr('grid-width'));
        var length = parseFloat($(this).attr('grid-length'));
        var proWidth = parseFloat(width * drawerWidth);
        var proLength = parseFloat(length * drawerLength);
        var itemid= $('.droppable-area1 li').length + 1;
        var itemid2= $('.droppable-area1 li').length;
         var dataImageHidden = pair.hiddenUrl;
        log("colorCheck", colorCheck, imageData, imageData1, productUrl);

          // A region selected on the canvas (tap-to-fit) is where the customer
          // wants this module: place it there, turned to fill the region when
          // that takes a rotation (a 3x2 fills a 2×3 region on its side).
          var spaceFit = window.MD_spaceFit || null;
          var regionPlacement = null;
          if (spaceFit && Number.isFinite(spaceFit.col) && Number.isFinite(spaceFit.row)) {
            var orientation = mdFitSections.orientationFor(length, width, { L: Number(spaceFit.maxL), W: Number(spaceFit.maxW) });
            if (orientation) {
              regionPlacement = {
                left: spaceFit.col * drawerWidth,
                top: spaceFit.row * drawerLength,
                rotate: orientation === 'rotated'
              };
            }
          }

          // Always use canonical picker results for canvas imagery
          var placed = addItem(
            $editor,
            proLength,
            proWidth,
            imageData,
            imageData1,
            dataImageHidden,
            variantId,
            productId,
            itemid,
            colorCheck,
            productUrl,
            proPrice,
            null,
            null,
            false,
            false,
            selectedHeightVariant.heightMm,
            regionPlacement
          );
          // The selected region is now (at least partly) filled: drop it so the
          // palette goes back to what fits the drawer.
          if (placed && regionPlacement && typeof window.MD_clearSpaceFit === 'function') {
            try { window.MD_clearSpaceFit(); } catch (_) {}
          }

          // AUTO-COLLAPSE: Close expanded panel after product is added.
          // Route through window.MD_setSheetExpanded (exposed by
          // drawer-builder-legacy.js) so the collapse goes through the
          // same path as user-driven collapses: sets products-animating
          // (which gates the gesture handler), resets sheet scrollTop,
          // and fires consistent debug logs. Falls back to the previous
          // direct class mutation if the controller isn't available
          // (e.g. legacy.js failed to load).
          // Close any open filter picker (desktop shelf / mobile refine dialog)
          // so it doesn't linger over the piece just added. Desktop: the panel
          // stays open, but the filter shelf tucks away.
          if (typeof window.MD_closeFilterUI === 'function') {
            try { window.MD_closeFilterUI(); } catch (_) {}
          }
          if ($('body').hasClass('products-expanded')) {
            setTimeout(function() {
              if (typeof window.MD_setSheetExpanded === 'function') {
                window.MD_setSheetExpanded(false, 'product-selected');
              } else {
                $('body').removeClass('products-expanded');
                localStorage.setItem('db-products-expanded', 'false');
              }
              log('[DrawerBuilder] Products panel auto-collapsed after product selection');
            }, 300); // Brief delay so user can see product was added
          }
        
            log("-=-=>Editor:", $editor);
            log("-=-=> Product Length:", proLength);
            log("-=-=> Product Width:", proWidth);
            log("-=-=> Image Data:", imageData);
            log("-=-=> Image Data 1:", imageData1);
            log("-=-=> Data Image Hidden:", dataImageHidden);
            log("-=-=> Variant ID:", variantId);
            log("-=-=> Product ID:", productId);
            log("-=-=> Item ID:", itemid);
            log("-=-=> Color Check:", colorCheck);
            log("-=-=> Product URL:", productUrl);
            log("-=-=> Product Price:", proPrice);
            log("$(this) ============> ", $(this))
         
      }
      
    });



  // md-builder-cart-start
  // Cart v2 is independent of placement insertion order. Saved/share links
  // keep their established ordering; only the commerce snapshot is canonical.
  function canonicalBuilderCartHash(state) {
    var buildTokens = String(state.hash || '').split('&').slice(1).filter(function (token) {
      return token && !/^\d+-/.test(token);
    });
    return state.dimensionsString + (buildTokens.length ? '&' + buildTokens.join('&') : '') +
      (state.segments.length ? '&' + state.segments.slice().sort().join('&') : '');
  }

  function builderCartBuildId(canonical) {
    var hash = 5381;
    for (var i = 0; i < canonical.length; i += 1) hash = ((hash << 5) + hash + canonical.charCodeAt(i)) | 0;
    // Legacy uint32/base36 ids have at most seven characters after b_. Eight
    // characters gives a disjoint namespace while preserving b_[a-z0-9]+.
    return 'b_2' + (hash >>> 0).toString(36).padStart(7, '0');
  }

  function builderCartLineIdentity(item) {
    var props = item.properties || {};
    return JSON.stringify([
      String(item.variant_id || item.id),
      Object.keys(props).sort().map(function (key) { return [key, String(props[key])]; })
    ]);
  }

  function builderCartReceivedAdd(before, after, items) {
    if (!before || !after || !Array.isArray(before.items) || !Array.isArray(after.items)) return false;
    var quantities = function (cart) {
      var result = {};
      cart.items.forEach(function (item) {
        var key = builderCartLineIdentity(item);
        result[key] = (result[key] || 0) + Number(item.quantity || 0);
      });
      return result;
    };
    var oldQuantities = quantities(before);
    var newQuantities = quantities(after);
    return items.length > 0 && items.every(function (item) {
      var key = builderCartLineIdentity(item);
      return (newQuantities[key] || 0) - (oldQuantities[key] || 0) >= Number(item.quantity);
    });
  }

  function captureLayoutChoiceContext(choices) {
    try {
      var context = choices && typeof choices.capture === 'function' ? choices.capture() : null;
      if (!context || typeof context !== 'object') return null;
      var captured = Object.assign({}, context);
      if (context.choiceRef) captured.choiceRef = Object.assign({}, context.choiceRef);
      return captured;
    } catch (_) { return null; }
  }

  function encodeLayoutChoiceAttribute(ref) {
    try {
      var keys = ['requestUuid', 'setId', 'optionId', 'runId', 'candidateId'];
      if (!ref || ref.schema !== 'layout-choice-ref.v2' || keys.some(function (key) {
        return typeof ref[key] !== 'string' || !ref[key] || ref[key].length > 200;
      })) return null;
      // Copy only the shared reference fields at the start of the operation.
      // Later selection changes cannot relabel a queued cart add.
      var value = { schema: ref.schema };
      keys.forEach(function (key) { value[key] = ref[key]; });
      return JSON.stringify(value);
    } catch (_) { return null; }
  }

  function effectiveBuilderCartHash(hash, trueToSize, ikeaSelected) {
    return String(hash || '').split('&').filter(function (part) { return part !== 'tts=1' && part !== 'ikea=1'; }).join('&') +
      (trueToSize ? '&tts=1' : '') + (ikeaSelected ? '&ikea=1' : '');
  }

  function emitBuilderCartAdded(result, hash, buildId, buildUuid, trueToSize, ikeaSelected, choiceContext) {
    if (!result.accepted) return;
    emitBuilderLayoutEvent('db:cart-added', {
      hash: effectiveBuilderCartHash(hash, trueToSize, ikeaSelected), buildId: buildId, buildUuid: buildUuid,
      attributionPersisted: result.attributionPersisted === true,
      choiceContext: choiceContext || null
    });
  }

  async function commitBuilderCart(addBody, layoutAttrs) {
    var debug = window.MD_DEBUG_BUILDER === true;
    var warn = debug && window.console && window.console.warn ? window.console.warn.bind(window.console) : function () {};
    var cartOps = window.FoxTheme.cart;
    var items = JSON.parse(addBody).items;
    var result = { accepted: false, uncertain: false, cart: null, added: null, error: null, refreshError: null, attributionPersisted: false };
    return cartOps.enqueue(async function () {
      var before = null;
      try { before = await cartOps.read(); } catch (error) { warn('Pre-add cart read failed:', error); }

      try {
        // Never retry this non-idempotent request. A dropped response is
        // reconciled by the exact variant+property quantity delta instead.
        var response = await fetch(window.FoxTheme.routes.cart_add_url, {
          ...window.FoxTheme.utils.fetchConfig('javascript'), body: addBody
        });
        var added = await response.json();
        if (!response.ok || added.errors || Number(added.status) >= 400) {
          var rejection = new Error(added.description || (typeof added.errors === 'string' && added.errors) || mdT('sections.cart.cart_error'));
          rejection.status = response.status;
          throw rejection;
        }
        result.accepted = true;
        result.added = added;
      } catch (primaryError) {
        try { result.cart = await cartOps.read(); } catch (error) { result.refreshError = error; }
        if (builderCartReceivedAdd(before, result.cart, items)) {
          result.accepted = true;
          result.added = { items: items };
        } else {
          result.error = primaryError;
          // An HTTP400 section-context failure or a5xx can happen after the
          // mutation. Without a baseline/authoritative read, even a rejection
          // cannot prove that none of the requested lines reached the cart.
          result.uncertain = !primaryError.status || !before || !result.cart ||
            primaryError.status === 400 || primaryError.status >= 500;
          if (result.cart) {
            try { await cartOps.publish(result.cart); } catch (error) { result.refreshError = error; }
          }
          return result;
        }
      }

      if (!result.cart) {
        try { result.cart = await cartOps.read(); } catch (error) { result.refreshError = error; }
      }
      var sectionsToBundle = cartOps.sections();
      var payload = { attributes: layoutAttrs, sections: sectionsToBundle, sections_url: window.location.pathname };
      // Never fall back to this build's summary if the note read failed: that
      // would overwrite another build or the customer's own instructions.
      if (result.cart) payload.note = cartOps.reconcileNote(result.cart);
      const notePayload = JSON.stringify(payload);
      var noteState = null;
      var metadataAccepted = false;
      for (var attempt = 0; attempt < 3; attempt += 1) {
        if (attempt) await new Promise(function (resolve) { setTimeout(resolve, 250 * attempt); });
        try {
          noteState = await cartOps.request(window.FoxTheme.routes.cart_update_url, {
            ...window.FoxTheme.utils.fetchConfig(), body: notePayload
          });
          metadataAccepted = true;
          break;
        } catch (error) { warn('Note/attribute update attempt ' + (attempt + 1) + ' failed:', error); }
      }
      if (noteState && Array.isArray(noteState.items)) result.cart = noteState;
      if (!result.cart) {
        try { result.cart = await cartOps.read(); } catch (error) { result.refreshError = error; }
      }
      // request() validates Shopify's acknowledgement. Private attributes may
      // be absent from Ajax readback, so a later read cannot verify this write.
      // A lost response stays unconfirmed even if Shopify accepted the update.
      result.attributionPersisted = metadataAccepted;
      if (result.cart) {
        result.cart.sections = {
          ...((result.added && result.added.sections) || {}),
          ...((noteState && noteState.sections) || {})
        };
        try {
          await cartOps.publish(result.cart);
          result.refreshError = null;
        } catch (error) { result.refreshError = error; }
      }
      return result;
    }).catch(function (error) {
      // Acceptance is a receipt from Shopify, not the outcome of a later
      // note/render/read. Even an unexpected recovery exception keeps it.
      if (result.accepted) result.refreshError = error;
      else { result.error = error; result.uncertain = true; }
      return result;
    });
  }
  // md-builder-cart-end

// COMPREHENSIVE DRAWER BUILDER ADD TO CART - THEME INTEGRATED
var builderCartPending = false;
$(document).on('click', '.addToCart button', function(e) {
    e.preventDefault();
    if (builderCartPending) return;
    builderCartPending = true;
    
    // Show loading state
    var $button = $(this);
    var $spinner = $button.find('.loading__spinner');
    var addedOk = false; // gates the success affordance + delayed reset
    var builderContext = window.MD_BuilderLegacyContext;
    var debugBuilder = window.MD_DEBUG_BUILDER === true;
    var log = debugBuilder && window.console && console.log ? console.log.bind(console) : function () {};
    var warn = debugBuilder && window.console && console.warn ? console.warn.bind(console) : function () {};
    $button.prop('disabled', true);
    $button.removeClass('db-atc-success');
    $spinner.removeClass('hidden');

    try {
        if (!builderContext) {
            alert(mdT('modu.builder.builder_loading'));
            resetButton();
            return;
        }
        if (window.MD_HeightControls && window.MD_HeightControls.hasPendingChoice()) {
            window.MD_HeightControls.error(mdT('modu.builder_js.apply_height_before_cart'));
            resetButton();
            return;
        }
        var heightValidation = validateRequestedModuleHeight(selectedModuleHeightMm());
        if (!heightValidation.ok) {
            resetButton();
            return;
        }

        // Get drawer dimensions and create proper order note
        var $lengthInput = $('input[name="length"]');
        var $widthInput = $('input[name="width"]');

        // Read the *confirmed* canvas dimensions (data-original), not the raw
        // input value. data-original is only updated when the user actually
        // commits a size change via #changeDimension; .val() reflects an
        // unconfirmed typed/slid value that the canvas hasn't applied yet, so
        // using it produces a note that doesn't match the items on canvas.
        var inputLength = parseFloat($lengthInput.attr('data-original'));
        if (!Number.isFinite(inputLength) || inputLength <= 0) {
            inputLength = parseFloat($lengthInput.val());
        }
        if (!Number.isFinite(inputLength) || inputLength <= 0) {
            inputLength = parseFloat(builderContext.defaultLength) || 0;
        }

        var inputWidth = parseFloat($widthInput.attr('data-original'));
        if (!Number.isFinite(inputWidth) || inputWidth <= 0) {
            inputWidth = parseFloat($widthInput.val());
        }
        if (!Number.isFinite(inputWidth) || inputWidth <= 0) {
            inputWidth = parseFloat(builderContext.defaultWidth) || 0;
        }

        if (!Number.isFinite(inputLength) || inputLength <= 0 || !Number.isFinite(inputWidth) || inputWidth <= 0) {
            alert(mdT('modu.builder.valid_dimensions'));
            resetButton();
            return;
        }

        inputLength = Math.round(inputLength * 10) / 10;
        inputWidth = Math.round(inputWidth * 10) / 10;

        var gridLength = Math.max(1, Math.floor(inputLength / GRID_UNIT_MM));
        var gridWidth = Math.max(1, Math.floor(inputWidth / GRID_UNIT_MM));

        // True-to-size capture. Read the choice from body[data-true-to-size]
        // (set by the toggle); force it off when the gap or fulfilment-budget
        // checks fail so a stale "yes" can never ride through. gapStr records
        // the per-axis wall gap the internal tool fills. No charge.
        var ttsLeftL = (window.mdLeftoverMm ? window.mdLeftoverMm(inputLength) : 0);
        var ttsLeftW = (window.mdLeftoverMm ? window.mdLeftoverMm(inputWidth) : 0);
        // The control must exist (enable_true_to_size section setting on) —
        // with the kill switch off, a stale body attr can never capture TTS.
        var trueToSize = $('#db-true-to-size').length > 0 &&
            $('body').attr('data-true-to-size') === 'yes';
        if (!mdTtsEligibilityForDrawer(inputLength, inputWidth).eligible) {
            trueToSize = false;
        }
        var gapStr = 'L+' + ttsLeftL.toFixed(1) + 'mm W+' + ttsLeftW.toFixed(1) + 'mm';

        // IKEA MAXIMERA selection (beta, gated by the section setting). The
        // wall-adjacent modules are reshaped to the angled IKEA wall; the
        // converted count is the per-module surcharge basis. Mutually exclusive
        // with true-to-size — selecting IKEA forces true-to-size off so the size
        // label, merge key, and capture stay unambiguous.
        var ikeaFeat = (window.MD_FEATURES && window.MD_FEATURES.ikea_maximera) || {};
        var ikeaSelected = !!ikeaFeat.enabled && $('body').attr('data-ikea-maximera') === 'yes';
        if (ikeaSelected) { trueToSize = false; }
        var ikeaCounts = ikeaSelected ? builderContext.countWallAdjacentModules() : { converted: 0, total: 0 };

        // Displayed drawer size for the cart card, _drawer_size, and order note.
        // A STANDARD build is rounded DOWN to whole 29.5mm blocks, so the
        // modules fill the converted footprint (grid × 29.5) — show THAT, not
        // the raw drawer the customer typed, so the cart reflects what's
        // actually made (default). A TRUE-TO-SIZE build shows the manufactured
        // footprint after the designed clearance is applied (the visible
        // "Fit" badge marks it true-to-size). The raw dims are still
        // preserved verbatim in _drawer_layout for the fulfilment tool.
        var fmtMm = function (n) {
            var r = Math.round(n * 10) / 10;
            return (r % 1 === 0) ? String(r) : r.toFixed(1);
        };
        var dispLen = gridLength * GRID_UNIT_MM + (trueToSize ? mdTtsExtensionMm(ttsLeftL) : 0);
        var dispWid = gridWidth * GRID_UNIT_MM + (trueToSize ? mdTtsExtensionMm(ttsLeftW) : 0);
        var drawerSizeLabel = `L ${fmtMm(dispLen)} × W ${fmtMm(dispWid)}mm (${gridLength}×${gridWidth} grid)`;

        // Base size note. Finalized below (with module count) once items
        // are counted, so the Shopify order carries a single clean
        // human-readable summary that matches the cart card + _drawer_size.
        var orderNote = `Custom Drawer — ${drawerSizeLabel}`;

        log("=== COMPREHENSIVE DRAWER BUILDER ADD TO CART ===");
        log("Input Length:", inputLength);
        log("Input Width:", inputWidth);
        log("Grid Length:", gridLength);
        log("Grid Width:", gridWidth);
        log("Order Note:", orderNote);

        // Check if drawer has items
        var drawerItems = $('.droppable-area1 .list-view-item');
        log("Items found in drawer:", drawerItems.length);
        
        if (drawerItems.length === 0) {
            alert(mdT('modu.builder.add_modules'));
            resetButton();
            return;
        }

        // Every module must be sold as its palette tile says at its own
        // height before anything is sent: drifted attributes are repaired,
        // a module that does not come at its height stops the add.
        var placementCheck = revalidatePlacedItems();
        if (!placementCheck.ok) {
            resetButton();
            return;
        }
        if (placementCheck.repaired) {
            warn('Repaired the height placement of', placementCheck.repaired, 'module(s) before cart add');
        }

        // Collect variant IDs from drawer items with comprehensive validation
        // The line buys the checkout variant (a height band variant, else the
        // module's own variant) and one variant can be made at several
        // heights, so the commerce identity is checkout variant + height.
        var lineGroups = {};
        var itemsWithoutVariantId = 0;

        log("=== DETAILED ITEM ANALYSIS ===");
        drawerItems.each(function(index) {
            var $item = $(this);
            log(`Item ${index + 1}:`, this);
            log(`  - data-id: ${$item.attr('data-id')}`);
            log(`  - data-checkout-id: ${$item.attr('data-checkout-id')}`);
            log(`  - data-variant-id: ${$item.attr('data-variant-id')}`);
            log(`  - variant-id: ${$item.attr('variant-id')}`);
            log(`  - data('id'): ${$item.data('id')}`);
            log(`  - data('variant-id'): ${$item.data('variant-id')}`);
            log(`  - product-id: ${$item.attr('product-id')}`);
            log(`  - All attributes:`, this.attributes);

            var variantId = $item.attr('data-id') ||
                           $item.attr('data-variant-id') ||
                           $item.attr('variant-id') ||
                           $item.data('id') ||
                           $item.data('variant-id');

            if (!variantId) {
                warn(`Item ${index + 1} without variant id:`, this);
                itemsWithoutVariantId++;
                return;
            }

            // Ensure variant ID is a number
            var numericVariantId = parseInt(variantId, 10);
            var numericCheckoutId = parseInt($item.attr('data-checkout-id') || variantId, 10);
            if (isNaN(numericVariantId) || isNaN(numericCheckoutId)) {
                warn(`Item ${index + 1} invalid variant ID (not a number):`, variantId);
                itemsWithoutVariantId++;
                return;
            }

            var actualHeightMm = Number($item.attr('data-height-mm')) || STANDARD_MODULE_HEIGHT_MM;
            var banded = $item.attr('data-height-pricing-policy') === HEIGHT_BAND_PRICING_POLICY;
            var heightBasis = $item.attr('data-height-basis') || 'authored';
            var heightContract = $item.attr('data-height-contract') || '';
            var lineKey = numericCheckoutId + '@' + actualHeightMm + '@' + heightBasis + '@' + heightContract;
            if (!lineGroups[lineKey]) {
              lineGroups[lineKey] = {
                variantId: numericCheckoutId,
                sourceId: numericVariantId,
                heightMm: actualHeightMm,
                heightBasis: heightBasis,
                heightContract: heightContract,
                banded: banded,
                bandMm: banded ? Number($item.attr('data-height-band-mm')) : null,
                quantity: 0
              };
            }
            lineGroups[lineKey].quantity += 1;
            log(`  ✓ Added variant ${numericCheckoutId}@${actualHeightMm} (count: ${lineGroups[lineKey].quantity})`);
        });

        log("Variant/height lines collected:", Object.keys(lineGroups));
        log("Items without valid variant ID:", itemsWithoutVariantId);

        if (Object.keys(lineGroups).length === 0) {
            alert(mdT('modu.builder.invalid_product_data'));
            resetButton();
                return;
            }

        // Build line item properties carrying the drawer build context.
        // Both keys are single-underscore-prefixed so they are hidden from
        // the customer in cart/checkout/order rendering (Shopify Admin still
        // shows them to merchants). The cart/order UI groups the module
        // lines into one "Custom Drawer" card keyed by _build_id and
        // surfaces _drawer_size once on that card's header.
        // - "_build_id": groups this click's module lines into one bundle
        // - "_drawer_size": human-readable size, shown once on the header
        // The full canvas hash is NOT a per-line property: it is identical
        // across every module line, nothing reads it back per-line, and it
        // bloats the Admin order. Instead it rides once on the cart as a
        // PRIVATE cart attribute (double-underscore) keyed by build id —
        // see the cart/update.js call below. Double underscore is required:
        // single-underscore cart attributes are PUBLIC (exposed via the
        // Ajax API / order status page), unlike single-underscore line
        // properties which are private. Private cart attributes are hidden
        // from the storefront yet still shown on the Admin Order details
        // page, so the build stays fully recoverable from the order alone.
        // Refresh the URL hash synchronously so the address-bar / share-link
        // is fresh (createURL is normally debounced 300ms on canvas changes).
        // This is purely for the share feature; we compute the layout hash
        // ourselves below from confirmed state.
        try { builderContext.createConfirmedURL(); } catch (e) { warn('createURL failed before cart add:', e); }

        // Reuse the same confirmed snapshot as Share/Save so the cart's
        // reconstruction hash and the browser URL cannot disagree.
        var confirmedLayoutState = builderContext.getConfirmedLayoutState();
        if (!confirmedLayoutState) {
            alert(mdT('modu.builder.apply_layout'));
            resetButton();
            return;
        }
        var dimsStr = confirmedLayoutState.dimensionsString;
        var layoutSegs = confirmedLayoutState.segments.slice();
        // Commerce is canonical; share/save links keep their existing order.
        var layoutHash = canonicalBuilderCartHash(confirmedLayoutState);

        // _build_id is Shopify's line-merge key (lines merge only when
        // variant_id + ALL properties match). A Date.now()+random id made
        // every click unique, so identical drawers never merged. Derive it
        // from a canonical (sorted, order-independent) digest of the build
        // so re-adding the same drawer consolidates, while any layout
        // difference still produces a distinct id.
        // Fold the true-to-size flag into the merge-key digest so a
        // true-to-size build never consolidates with a standard build of the
        // same layout (they ship different STLs).
        var moduleHeightMm = selectedModuleHeightMm();
        var canonical = dimsStr + (layoutSegs.length ? `&${layoutSegs.slice().sort().join('&')}` : '') + '&mh=' + moduleHeightMm + (trueToSize ? '&tts=' + TTS_SPEC : '') + (ikeaSelected ? '&ikea=1' : '');
        var buildId = builderCartBuildId(canonical);
        var drawerSize = drawerSizeLabel;
        var buildProperties = {
            '_build_id': buildId,
            '_drawer_size': drawerSize,
            '_drawer_target_height_mm': String(moduleHeightMm),
            'Selected tray height': moduleHeightMm + ' mm'
        };
        // The layout hash rides on the cart (not the line items) as a private
        // attribute. Key it by build id so a multi-drawer order keeps each
        // build's layout distinct instead of one key clobbering another.
        var layoutAttrKey = '__drawer_layout_' + buildId;
        // The build's record identity: the saved build this session was
        // opened from (?bid=), else a fresh mint for this ordered build.
        // Re-adding the same layout overwrites the attribute (same key) —
        // last write wins, matching __drawer_layout_* semantics.
        var orderBuildUuid = builderContext.getOrderBuildUuid();
        var layoutChoiceContext = captureLayoutChoiceContext(window.mdLayoutChoices);
        var layoutChoiceAttribute = encodeLayoutChoiceAttribute(layoutChoiceContext && layoutChoiceContext.choiceRef);

        // True-to-size capture props. Two underscore keys (merchant/tooling
        // only) record the choice + the per-axis wall gap the internal tool
        // fills; the visible (non-underscore) "Fit" line confirms the choice
        // to the customer in cart and checkout. (The order-confirmation email
        // templates do NOT render line properties — customising them is a
        // Shopify-admin task, tracked in docs/true-to-size-deep-dive.md.)
        // No fee line is pushed — true-to-size is free of charge.
        buildProperties['_true_to_size'] = trueToSize ? 'yes' : 'no';
        buildProperties['_true_to_size_gap'] = trueToSize ? gapStr : '';
        buildProperties['Fit'] = ikeaSelected ? 'Angled-wall' : 'Standard';
        buildProperties['Finished size'] = 'L ' + fmtMm(dispLen) + ' × W ' + fmtMm(dispWid) + ' mm';
        if (trueToSize) {
            buildProperties['_true_to_size_spec'] = TTS_SPEC;
            buildProperties['_true_to_size_clearance_mm'] = String(TTS_CLEARANCE_MM);
            buildProperties['Fit'] = 'True to Size · 1 mm clearance';
        }

        // Choice provenance belongs to the build attribute, not line
        // properties: clicking a control must not split identical cart lines.
        // This describes the latest add for this build, not every copy or
        // legal consent. A missing attribute is treated as unknown in ops.
        var fitChoiceSource = $('body').attr('data-fit-choice-source') || 'default';
        if (ikeaSelected || !$('#db-true-to-size').length || !mdTtsEligibilityForDrawer(inputLength, inputWidth).eligible) {
            fitChoiceSource = 'unavailable';
        }
        var fitChoice = JSON.stringify({
            v: 1,
            fit: trueToSize ? 'true-to-size' : 'standard',
            source: fitChoiceSource,
            lengthMM: inputLength,
            widthMM: inputWidth
        });

        // IKEA MAXIMERA capture. Underscore keys (merchant/tooling) record the
        // choice + converted/total module counts so the fulfilment tool can
        // apply the ikea-maximera side-wall profile to the wall-adjacent
        // modules; the visible "Drawer fit" line confirms the choice to the
        // customer through cart, checkout, and the order email.
        if (ikeaSelected) {
            buildProperties['_ikea_maximera'] = 'yes';
            buildProperties['_ikea_converted_modules'] = String(ikeaCounts.converted);
            buildProperties['_ikea_total_modules'] = String(ikeaCounts.total);
            buildProperties['Drawer fit'] = 'Angled-wall';   // visible, non-underscore
        }

        // Finalize the order note: size + module count, matching the
        // cart card and the per-line _drawer_size property. Shopify shows
        // the note and the (underscore) properties to the merchant in the
        // Admin order even though they are hidden from the customer, so
        // the build is fully recoverable from the order alone.
        var totalModules = 0;
        Object.keys(lineGroups).forEach(function (k) { totalModules += lineGroups[k].quantity; });
        orderNote = `${drawerSize} — ${totalModules} ${totalModules === 1 ? 'module' : 'modules'}`;
        orderNote = 'Custom Drawer — ' + orderNote + ` — ${moduleHeightMm} mm high`;
        if (trueToSize) {
            orderNote += ` — True to Size ${TTS_SPEC}, ${TTS_CLEARANCE_MM} mm clearance (${gapStr})`;
        }
        if (ikeaSelected) {
            orderNote += ` — Angled-wall (${ikeaCounts.converted}/${ikeaCounts.total} modules adjusted)`;
        }
        log('Order note (final):', orderNote);

        // --- Analytics: surface the drawer build config to the dataLayer ---
        // GTM reads these as Data Layer Variables and attaches them to the GA4
        // `custom_drawer` event (event-scoped custom dimensions registered in
        // GA4: drawer_length / drawer_width / drawer_modules / drawer_config_id).
        // Pushed WITHOUT an `event` key so it only merges into the dataLayer
        // model (no GTM tag fires here); the values are then live when the
        // theme's add_to_cart event fires from the /cart/add fetch interceptor
        // (snippets/ultimate-datalayer.liquid) immediately after. Additive and
        // wrapped in try/catch so analytics can never block or break cart add.
        try {
            // Modules are reported by their source variant (the one in the
            // layout hash), never by a height band variant: the height rides
            // in the compact form below and on the cart line.
            var moduleIdList = [];
            Object.keys(lineGroups).forEach(function (lineKey) {
                var group = lineGroups[lineKey];
                for (var mc = 0; mc < group.quantity; mc++) { moduleIdList.push(group.sourceId); }
            });
            var drawerModulesStr = moduleIdList.join(',');
            // GA4 caps event-param string values at 100 chars; if the expanded
            // id list is too long, fall back to a compact id:qty summary.
            if (drawerModulesStr.length > 100) {
                drawerModulesStr = Object.keys(lineGroups).map(function (lineKey) {
                    var group = lineGroups[lineKey];
                    return group.sourceId + '@' + group.heightMm + ':' + group.quantity;
                }).join(',').slice(0, 100);
            }
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                drawer_length: inputLength,
                drawer_width: inputWidth,
                drawer_modules: drawerModulesStr,
                drawer_modules_count: totalModules,
                drawer_config_id: buildId,
                drawer_target_height_mm: moduleHeightMm,
                drawer_true_to_size: trueToSize ? 'yes' : 'no',
                drawer_true_to_size_spec: trueToSize ? TTS_SPEC : '(none)',
                drawer_ikea_maximera: ikeaSelected ? 'yes' : 'no'
            });
            log('Drawer build dataLayer pushed:', { drawer_config_id: buildId, drawer_modules_count: totalModules });
        } catch (dlErr) {
            warn('drawer build dataLayer push failed:', dlErr);
        }

        // Build a single theme-native Add request with all items.
        // Shopify groups by variant_id + properties: identical builds merge,
        // any layout difference splits into separate lines so each build's
        // dimensions stay tied to its own modules.
        // No STL provenance claims (_pricing_version, _stl_*) on any line.
        // They were copied from variant metafields that the 2026-09-25
        // flat-rim promotion left stale, and fulfilment blocks a line whose
        // claims disagree with the canonical STL, so every order of a
        // flat-rim tray needed a manual migration. A line without claims is
        // printed from the canonical file.
        // A banded line buys its band variant and carries
        // _height_pricing_policy = volume-band-v1 and _height_band_mm; every
        // line carries _module_height_mm and Module height. Blank properties
        // are left out (moduleLineProperties, md-height-bands).
        // md-builder-cart-items-start
        const items = Object.keys(lineGroups).sort().map(function(lineKey) {
            var group = lineGroups[lineKey];
            return { id: group.variantId, quantity: group.quantity, properties: moduleLineProperties(buildProperties, group) };
        });

        // Guaranteed-delivery fallback for the layout hash. The canonical home
        // for the layout is the private cart attribute set in the /cart/update.js
        // call below — but that is a secondary call with no other delivery path,
        // so a transient failure there would lose the reconstruction data. To
        // backstop it, stamp _drawer_layout on the FIRST line item only (single
        // underscore → hidden from the customer, shown to the merchant). This
        // rides the primary /cart/add.js request, so the build survives even if
        // the attribute write fails. One line, not all — that duplication was
        // the bloat we removed; the key matches the attribute so they never
        // disagree, and the line property vanishes with its line on bundle
        // removal just like before. (internal-tools backfills the layout across
        // the _build_id group at order-read time, so per-line fulfilment logic
        // still sees it on every module line.)
        if (items.length) {
            items[0] = {
                id: items[0].id,
                quantity: items[0].quantity,
                properties: Object.assign({}, items[0].properties, { '_drawer_layout': layoutHash })
            };
        }

        // md-builder-cart-items-end

        // IKEA MAXIMERA surcharge: a per-converted-module fee line tagged with
        // the same _build_id (so it groups + removes with the bundle via
        // cart-bundle.js) and a _fee marker (so the cart bundle excludes it from
        // the module count). Pushed AFTER the layout stamp so the fee line can
        // never become items[0] and absorb the layout hash. Inert unless the
        // option is selected, a fee variant is configured, and at least one
        // module is wall-adjacent.
        var ikeaFeeVariantId = parseInt(ikeaFeat.feeVariantId, 10);
        if (ikeaSelected && Number.isFinite(ikeaFeeVariantId) && ikeaCounts.converted > 0) {
            items.push({
                id: ikeaFeeVariantId,
                quantity: ikeaCounts.converted,
                properties: {
                    '_build_id': buildId,
                    '_fee': 'ikea-maximera',
                    '_ikea_maximera': 'yes'
                }
            });
        }

        // Forage mode (assets/forage-bridge.js): TapForage opened the builder
        // with ?forage_return=… . Hand the build back to that page instead of
        // adding to this store's cart: the same items, properties, cart
        // attributes and note the /cart/add.js + /cart/update.js calls below
        // would send. Forage puts them through this store's Shopify checkout
        // (Storefront API cartCreate), so the order, the webhooks and the
        // print pipeline are unchanged. Visitors without the parameter never
        // enter this block. Contract: docs/forage-bridge.md.
        if (window.MD_FORAGE && window.MD_FORAGE.returnUrl && window.MD_FORAGE_BRIDGE) {
            var forageAttributes = {};
            forageAttributes['__drawer_fit_choice_' + buildId] = fitChoice;
            if (typeof layoutHash === 'string' && layoutHash) {
                forageAttributes[layoutAttrKey] = layoutHash;
            }
            if (typeof orderBuildUuid === 'string' && orderBuildUuid) {
                forageAttributes['__drawer_build_uuid_' + buildId] = orderBuildUuid;
            }
            if (sourceAiRequest) {
                forageAttributes['__drawer_ai_request_' + buildId] = sourceAiRequest;
            }
            if (sourceAiOption) forageAttributes['__drawer_ai_option_' + buildId] = sourceAiOption;
            if (layoutChoiceAttribute) forageAttributes['__drawer_layout_choice_' + buildId] = layoutChoiceAttribute;
            var foragePayload = {
                v: 1,
                function: 'drawer-builder',
                build_id: buildId,
                lines: items.map(function (item) {
                    return {
                        variant_id: Number(item.id),
                        quantity: Number(item.quantity),
                        properties: item.properties || {}
                    };
                }),
                attributes: forageAttributes,
                note: String(orderNote || '')
            };
            mdPushDL({ event: 'forage_handoff', drawer_config_id: buildId, drawer_modules_count: totalModules });
            log('Forage hand-off:', foragePayload);
            addedOk = true;
            $spinner.addClass('hidden');
            $button.addClass('db-atc-success');
            window.mdHaptic && window.mdHaptic(15);
            // The early return below skips the fetch chain's .finally(resetButton).
            setTimeout(resetButton, 1500);
            if (window.MD_FORAGE_BRIDGE.handoff(foragePayload)) {
                return;
            }
            warn('Forage hand-off refused (no return address); adding to the store cart instead.');
        }

        log('Theme-native add items:', items);
        log('Build properties:', buildProperties);

        // Collect sections per theme convention
        var sectionsToBundle = [];
        document.documentElement.dispatchEvent(
            new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );

        const addBody = JSON.stringify({
            items: items,
            sections: sectionsToBundle,
            sections_url: window.location.pathname
        });

        const layoutAttrs = {};
        layoutAttrs[layoutAttrKey] = layoutHash;
        layoutAttrs['__drawer_build_uuid_' + buildId] = orderBuildUuid;
        layoutAttrs['__drawer_fit_choice_' + buildId] = fitChoice;
        if (sourceAiRequest) layoutAttrs['__drawer_ai_request_' + buildId] = sourceAiRequest;
        if (sourceAiOption) layoutAttrs['__drawer_ai_option_' + buildId] = sourceAiOption;
        // An unattributed re-add of an identical build clears an older choice
        // reference instead of assigning that new add to the previous recipe.
        layoutAttrs['__drawer_layout_choice_' + buildId] = layoutChoiceAttribute || '';
        try {
            const hjLink = window.MD_hotjarOrderLink;
            const hjId = hjLink && typeof hjLink.currentId === 'function' ? hjLink.currentId() : '';
            if (hjId) layoutAttrs[hjLink.ATTR_KEY] = hjId;
        } catch (hjErr) { /* analytics only — never block the add */ }
        // The helper writes this attribute payload together with a freshly
        // reconciled note; the raw customer note is never replaced on failure.
        const notePayload = layoutAttrs;
        commitBuilderCart(addBody, notePayload)
            .then(function(result) {
                if (!result.accepted) {
                    var message = result.uncertain
                        ? mdT('modu.builder.cart_add_uncertain')
                        : mdT('modu.builder.add_failed', { error: result.error && result.error.message });
                    window.FoxTheme.cart.showError(message, null, true);
                    openBuilderCart();
                    return;
                }
                addedOk = true;
                emitBuilderCartAdded(result, layoutHash, buildId, orderBuildUuid, trueToSize, ikeaSelected, layoutChoiceContext);
                $spinner.addClass('hidden');
                $button.addClass('db-atc-success');
                window.mdHaptic && window.mdHaptic(15);
                if (result.cart && typeof result.cart.note === 'string') {
                    document.querySelectorAll('textarea[name="note"]').forEach(function(noteField) {
                        noteField.value = result.cart.note;
                    });
                }
                document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: result.added } }));
                if (result.refreshError) window.FoxTheme.cart.showError(mdT('modu.cart.added_refresh'), null, true);
                openBuilderCart();
            })
            .catch(function(error) {
                console.error('Builder cart recovery failed:', error);
                window.FoxTheme.cart.showError(mdT(addedOk ? 'modu.cart.added_refresh' : 'modu.builder.cart_add_uncertain'), null, true);
                openBuilderCart();
            })
            .finally(function() {
                if (addedOk) setTimeout(resetButton, 1000);
                else resetButton();
            });

    } catch (error) {
        console.error("Unexpected error:", error);
        alert(mdT('modu.builder.unexpected_error', { error: error.message }));
        resetButton();
    }
    
    function openBuilderCart() {
        var trigger = document.querySelector('.cart-drawer-button') ||
            document.querySelector('[aria-controls="CartDrawer"]') || document.querySelector('a[href*="cart"]');
        if (trigger) trigger.click();
    }
    function resetButton() {
        builderCartPending = false;
        $button.prop('disabled', false);
        $button.removeClass('db-atc-success');
        $spinner.addClass('hidden');
    }
    
});


  

  
  
//   // Working code 24-3-25 (updated: non-destructive grow, confirm only on clipping shrink)
  $(document).on('keydown', '#changeDimension', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    this.click();
  });
  $(document).on('click', '#changeDimension', function () {

    var builderContext = window.MD_BuilderLegacyContext;
    if (!builderContext) {
      alert(mdT('modu.builder.builder_loading'));
      return;
    }

    var currentLength = parseFloat($('input[name="length"]').attr('data-original')) || 0;
    var currentWidth = parseFloat($('input[name="width"]').attr('data-original')) || 0;
    var newLength = parseFloat($('input[name="length"]').val()) || 0;
    var newWidth = parseFloat($('input[name="width"]').val()) || 0;
    var heightValidation = validateRequestedModuleHeight();
    if (!heightValidation.ok) {
      $('.fs-canvas__space .canvas-wrapper').css('visibility', 'visible');
      return;
    }
    var requestedHeightMm = heightValidation.value;
    var requestedCustomHeight = window.MD_HeightControls && window.MD_HeightControls.customRequested();

    var commitHeightAndNotify = function () {
      var heightResult = commitRequestedModuleHeight(requestedHeightMm);
      if (!heightResult.ok) return false;
      try {
        window.dispatchEvent(new CustomEvent('db:dimensions-applied', {
          detail: {
            drawer_length: newLength,
            drawer_width: newWidth,
            drawer_target_height_mm: requestedHeightMm,
            custom_height: Boolean(requestedCustomHeight)
          }
        }));
      } catch (_) {}
      return true;
    };

    // Invalid-input bail BEFORE any data-original write or grow/shrink
    // branching. The handler persists data-original (the resize
    // baseline) on several branches before updateGridInfo() runs, so a
    // guard placed only inside updateGridInfo() would still corrupt the
    // baseline to 0 on blank/0 input. Bail here using the existing
    // error UI (mirrors the >2000 bail inside updateGridInfo()).
    var lengthInvalid = newLength < 1 || newLength > 2000;
    var widthInvalid = newWidth < 1 || newWidth > 2000;
    if (lengthInvalid || widthInvalid) {
      builderContext.setDimensionErrors(lengthInvalid, widthInvalid);
      $('.fs-canvas__space .canvas-wrapper').css('visibility', 'visible');
      return;
    }
    builderContext.setDimensionErrors(false, false);

    var roundToGrid = function(mm){ return Math.floor(mm / GRID_UNIT_MM) * GRID_UNIT_MM; };

    // Helpers
    var cellSize = parseInt($('.drawerBundle').attr('width')) || 0; // keep current block size
    var currentBlocksLen = Math.floor(currentLength / GRID_UNIT_MM);
    var currentBlocksWid = Math.floor(currentWidth / GRID_UNIT_MM);
    var newBlocksLen = Math.floor(newLength / GRID_UNIT_MM);
    var newBlocksWid = Math.floor(newWidth / GRID_UNIT_MM);

    var growLen = newBlocksLen > currentBlocksLen;
    var growWid = newBlocksWid > currentBlocksWid;
    var shrinkLen = newBlocksLen < currentBlocksLen;
    var shrinkWid = newBlocksWid < currentBlocksWid;

    var $canvasWrapper = $('.fs-canvas__space .canvas-wrapper');
    var $droppable = $('.droppable-area1');
    var $canvasBg = $('.fs-canvas__canvas');

    // Apply-path counterpart of the Clear re-sync done by
    // #db-clear-all-btn. updateGridInfo()'s internal shrink
    // early-return can skip the .droppable-area1 PIXEL box resize on
    // some call shapes, leaving editorWidth/editorHeight (read by
    // addItem + the PR #206 fitWidth/fitHeight clamp) stale-small so
    // only a tiny module places until an item is added. Re-derive the
    // box from values written on EVERY updateGridInfo() path:
    // .drawerBundle[width] (boxSize) x body grid-* block counts. The
    // >0 guards make it a safe no-op before the first render.
    var resyncCanvasBox = function () {
      try {
        var bs  = parseInt($('.drawerBundle').attr('width'), 10) || 0;
        var lnB = parseInt($('body').attr('grid-length'), 10) || 0;
        var wdB = parseInt($('body').attr('grid-width'), 10) || 0;
        if (bs > 0 && lnB > 0 && wdB > 0) {
          $droppable.css({ height: lnB * bs, width: wdB * bs });
        }
      } catch (e) { warn('Apply re-sync warning:', e); }
    };

    var willClipAfterShrink = function(targetWBlocks, targetHBlocks) {
      if (!cellSize) return true;
      var clip = false;
      $droppable.find('.draggable-item').each(function(){
        var $it = $(this);
        var leftBlocks = Math.round((parseFloat($it.css('left')) || 0) / cellSize);
        var topBlocks = Math.round((parseFloat($it.css('top')) || 0) / cellSize);
        var widthBlocks = Math.max(1, Math.round((parseFloat($it.css('width')) || cellSize) / cellSize));
        var heightBlocks = Math.max(1, Math.round((parseFloat($it.css('height')) || cellSize) / cellSize));
        if ((leftBlocks + widthBlocks) > targetWBlocks || (topBlocks + heightBlocks) > targetHBlocks) {
          clip = true;
          return false;
        }
      });
      return clip;
    };

    var rescaleAndRepositionItems = function(oldCell, newCell) {
      // Guard against falsy cell sizes (e.g. oldCell from an unset
      // .drawerBundle[width] before any product / first resize). Mirrors
      // the proven guard in rescaleItemsOnResize. Avoids Math.round(px /
      // 0) = Infinity if the item loop ever runs with a 0 cell.
      if (!oldCell || !newCell) return;
      $droppable.find('.draggable-item').each(function(){
        var $it = $(this);
        var topPx  = parseInt($it.css('top')) || 0;
        var leftPx = parseInt($it.css('left')) || 0;
        var topBlocks  = Math.round(topPx / oldCell);
        var leftBlocks = Math.round(leftPx / oldCell);

        // Preserve the element's current oriented footprint. The catalogue
        // attrs stay canonical for labels and must not be reinterpreted as
        // visual dimensions after a URL restore.
        var itemWidthBlocks = Math.max(1, Math.round((parseFloat($it.css('width')) || oldCell) / oldCell));
        var itemHeightBlocks = Math.max(1, Math.round((parseFloat($it.css('height')) || oldCell) / oldCell));
        var isRot  = $it.hasClass('rotated');

        var newW = itemWidthBlocks * newCell;
        var newH = itemHeightBlocks * newCell;
        var newLeft = leftBlocks * newCell;
        var newTop  = topBlocks * newCell;

        $it.css({ width: newW, height: newH, left: newLeft, top: newTop });
        // Resize inner image div to match the original addItem() rotation logic:
        // - `.rotated` uses CSS rotate(-90deg) on the inner div
        // - therefore the inner div must have swapped dimensions so that AFTER rotation it fits the li
        var $inner = $it.children('div').first();
        if ($inner && $inner.length) {
          var innerW = isRot ? newH : newW;
          var innerH = isRot ? newW : newH;
          $inner.css({
            width: innerW,
            height: innerH,
            // Avoid stretching (100% 100%) which distorts rotated images.
            // Match addItem(): "100%" (== 100% auto) and let CSS `background-size: contain` do the rest.
            'background-size': '100%',
            'background-position': '50%',
            'background-repeat': 'no-repeat'
          });
        }
      });
    };

    // If only growing (no shrinking in either dimension): extend grid non-destructively
    if ((growLen || growWid) && !(shrinkLen || shrinkWid)) {
      var oldCell = cellSize;
      $('input[name="length"]').val(newLength).attr('data-original', newLength);
      $('input[name="width"]').val(newWidth).attr('data-original', newWidth);
      // Recompute grid and cell size via existing logic
      updateGridInfo();
      resyncCanvasBox();
      var newCell = parseInt($('.drawerBundle').attr('width')) || oldCell;
      rescaleAndRepositionItems(oldCell, newCell);
      if (!commitHeightAndNotify()) return;
      $('.gridInfoValue').html(
        roundToGrid(newLength).toFixed(1) + ' x ' + roundToGrid(newWidth).toFixed(1) + ' x ' + requestedHeightMm + 'mm'
      );
      setTimeout(function(){ createURL(); }, 300);
      return;
    }

    // Shrink or mixed change (one grows, one shrinks): warn only if clipping would occur
    if (shrinkLen || shrinkWid) {
      var clip = willClipAfterShrink(newBlocksWid, newBlocksLen);
      if (!clip) {
        // Safe to shrink without clearing: recompute grid and rescale items
        var oldCellS = cellSize;
        $('input[name="length"]').val(newLength).attr('data-original', newLength);
        $('input[name="width"]').val(newWidth).attr('data-original', newWidth);
        updateGridInfo();
        resyncCanvasBox();
        var newCellS = parseInt($('.drawerBundle').attr('width')) || oldCellS;
        rescaleAndRepositionItems(oldCellS, newCellS);
        if (!commitHeightAndNotify()) return;
        $('.gridInfoValue').html(
          roundToGrid(newLength).toFixed(1) + ' x ' + roundToGrid(newWidth).toFixed(1) + ' x ' + requestedHeightMm + 'mm'
        );
        setTimeout(function(){ createURL(); }, 300);
        return;
      }

      // Clipping would happen: show confirmation and clear on confirm
      var $targetContainer = $canvasWrapper;
      $targetContainer.find('.confirmation-message').remove();
      var $confirmationContainer = $(`
          <div class="confirmation-message" style="display: none;">
                <p>Your changes will be removed. Do you want to proceed?</p>
                <button class="confirm-btn">Confirm</button>
                <button class="cancel-btn">Cancel</button>
          </div>
      `);
        $confirmationContainer.css({
          position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
          padding: '10px 35px', backgroundColor: '#FFF', color: '#000', border: '2px solid #252525',
          borderRadius: '10px', fontSize: '16px', boxShadow: '0 0 10px 3px #0000001f', textAlign: 'center', lineHeight: '1.2em'
      });
        $targetContainer.append($confirmationContainer);
      $confirmationContainer.fadeIn(200);

        $confirmationContainer.find('.confirm-btn').on('click', function () {
            $('input[name="length"]').val(newLength).attr('data-original', newLength);
            $('input[name="width"]').val(newWidth).attr('data-original', newWidth);
          // Use existing flow to recompute and clear
          updateGridInfo();
          resyncCanvasBox();
          if (!commitHeightAndNotify()) return;
            $('.drawer-parent-wrapper .canvas-wrapper .list-view-item').remove();
          $confirmationContainer.fadeOut(200, function () { $(this).remove(); });
          setTimeout(function () { createURL(); $('#db-clear-all-btn').trigger('click'); }, 300);
        });

        $confirmationContainer.find('.cancel-btn').on('click', function () {
          // Cancel means the typed dimensions were not applied. Restore the
          // fields as well as leaving the canvas untouched so Share/Save and
          // the next Apply never observe a mixed confirmed/draft state.
          $('input[name="length"]').val(currentLength);
          $('input[name="width"]').val(currentWidth);
          builderContext.setDimensionErrors(false, false);
          updateSizeHint();
          if (window.MD_HeightControls) window.MD_HeightControls.cancel();
          $confirmationContainer.fadeOut(200, function () { $(this).remove(); });
            });
      return;
    }

    // No effective change (equal blocks): persist inputs and refresh labels.
            $('input[name="length"]').val(newLength).attr('data-original', newLength);
            $('input[name="width"]').val(newWidth).attr('data-original', newWidth);
    if (!commitHeightAndNotify()) return;
    $('.gridInfoValue').html(
      roundToGrid(newLength).toFixed(1) + ' x ' + roundToGrid(newWidth).toFixed(1) + ' x ' + requestedHeightMm + 'mm'
    );
    // Same block count is NOT the same leftover: 561→575mm stays 19 blocks but
    // the wall gap goes 0.5→14.5mm. Re-run updateGridInfo() so the true-to-size
    // gate and the converted-size/gap readouts track the new confirmed dims
    // (the grow/shrink branches already do this; canvas math is a no-op here).
    updateGridInfo();
    setTimeout(function(){ createURL(); }, 300);
});
  


  

  // Product Filter logic below
    var menu = $('.product-filter-menu');
    var menu2 = $('.product-filter-menu-2');
    var menu3 = $('.product-filter-menu-3');
    var svgDiv = $('.product-filter');
    var svgDiv2 = $('.product-filter-2');
    var svgDiv3 = $('.product-filter-3');
    // Debug logging (opt-in)
    var MD_DEBUG_BUILDER = window.MD_DEBUG_BUILDER === true;
    function mdLog() {
      if (MD_DEBUG_BUILDER && window.console && typeof window.console.log === 'function') {
        window.console.log.apply(window.console, arguments);
      }
    }

  // === Filter Improvements (Option A) ===
  // Add filter count badges to each filter
  function initFilterBadges() {
    $('#prd-1').append('<span class="filter-count-badge" data-count="0"></span>');
    $('#prd-2').append('<span class="filter-count-badge" data-count="0"></span>');
    $('#prd-3').append('<span class="filter-count-badge" data-count="0"></span>');
  }
  initFilterBadges();

  // Mobile/expanded dropdown reliability:
  // Wrap the raw label text nodes into a span so CSS can consistently size/ellipsis it.
  // This also avoids some mobile rendering quirks where label text nodes can appear "missing".
  function normalizeFilterOptionLabelText() {
    try {
      var menus = document.querySelectorAll(
        '.product-filter-menu, .product-filter-menu-2, .product-filter-menu-3'
      );
      if (!menus || !menus.length) return;

      menus.forEach(function (menuEl) {
        var labels = menuEl.querySelectorAll('label.checkbox-wrapper');
        labels.forEach(function (label) {
          if (!label || label.querySelector('.db-filter-option-label')) return;

          // Gather and remove non-empty text nodes
          var textParts = [];
          var toRemove = [];
          label.childNodes.forEach(function (node) {
            if (node && node.nodeType === 3) {
              var t = (node.textContent || '').replace(/\s+/g, ' ').trim();
              if (t) {
                textParts.push(t);
                toRemove.push(node);
              }
            }
          });
          // Fallback: if Liquid text nodes are missing for any reason, use the checkbox value.
          if (!textParts.length) {
            var inputFallback = label.querySelector('input');
            var v = inputFallback ? (inputFallback.value || '').trim() : '';
            if (v) textParts.push(v);
          }
          if (!textParts.length) return;
          toRemove.forEach(function (n) { try { label.removeChild(n); } catch (_) {} });

          var span = document.createElement('span');
          span.className = 'db-filter-option-label';
          span.textContent = textParts.join(' ');

          var input = label.querySelector('input');
          if (input && input.parentNode === label) {
            if (input.nextSibling) {
              label.insertBefore(span, input.nextSibling);
            } else {
              label.appendChild(span);
            }
          } else {
            label.appendChild(span);
          }
        });
      });
    } catch (_) {
      // best-effort only
    }
  }
  // Run once on load and again whenever a menu is opened (mobile Safari can be finicky with text nodes).
  normalizeFilterOptionLabelText();

  // Prune filter options that have no matching products.
  // Source of truth is the rendered product list items: `.mineProList[data-tags]`.
  // Keep checked options visible (even if somehow not present) so users can clear them.
  var __dbAvailableTagSet = null;
  function pruneEmptyFilterOptions() {
    try {
      var $items = $('.list-view-item.mineProList');
      if (!$items || !$items.length) return;

      var tagSet = __dbAvailableTagSet;
      if (!tagSet) {
        tagSet = new Set();
        $items.each(function () {
          var raw = $(this).attr('data-tags') || $(this).data('tags') || '';
          var parts = raw.toString().split(',');
          for (var i = 0; i < parts.length; i += 1) {
            var t = (parts[i] || '').toString().trim().toLowerCase();
            if (t) tagSet.add(t);
          }
        });
        __dbAvailableTagSet = tagSet;
      }

      function pruneContainer($container) {
        if (!$container || !$container.length) return;
        $container.find('label.checkbox-wrapper').each(function () {
          var $label = $(this);
          var $input = $label.find('input[type="checkbox"]').first();
          if (!$input || !$input.length) return;
          var val = ($input.val() || '').toString().trim().toLowerCase();
          var checked = $input.prop('checked') === true;
          var hasProduct = !!val && tagSet.has(val);
          var isEmpty = !hasProduct && !checked;
          $label.toggleClass('db-filter-empty', isEmpty);
          $label.attr('data-db-empty', isEmpty ? '1' : '0');
          // Respect existing inline show/hide, but ensure empty options are not visible.
          if (isEmpty) {
            $label.hide();
          }
        });
      }

      pruneContainer($('.filter-tags-checkbox-1'));
      pruneContainer($('.filter-tags-checkbox-2'));
      pruneContainer($('.filter-tags-checkbox-3'));
    } catch (_) {
      // best-effort only
    }
  }

  // Expose for other modules / debugging (best-effort).
  window.MD_pruneEmptyFilterOptions = pruneEmptyFilterOptions;

  // When products finish rendering, apply filters + prune empty options.
  window.addEventListener('db:products-rendered', function () {
    try { if (typeof applyFiltersAndPaginate === 'function') applyFiltersAndPaginate(); } catch (_) {}
    // Products were (re)rendered; rebuild the available-tag cache.
    __dbAvailableTagSet = null;
    try { pruneEmptyFilterOptions(); } catch (_) {}
    try {
      window.requestAnimationFrame(function () {
        document.body.classList.remove('db-products-loading');
        document.body.classList.add('db-products-ready');
      });
    } catch (_) {}
  });

  // Update filter count badge
  function updateFilterBadge(filterNum) {
    var selector =
      filterNum === 1 ? '.filter-tags-checkbox-1' :
      filterNum === 2 ? '.filter-tags-checkbox-2' :
      '.filter-tags-checkbox-3';
    var badgeSelector =
      filterNum === 1 ? '#prd-1 .filter-count-badge' :
      filterNum === 2 ? '#prd-2 .filter-count-badge' :
      '#prd-3 .filter-count-badge';
    var count = $(selector + ' input[type="checkbox"]:checked').length;
    $(badgeSelector).text(count > 0 ? count : '').attr('data-count', count);

  }

  // === End Filter Improvements ===


  // Toggle menu on click
$('#prd-1').on('click', function () {
    normalizeFilterOptionLabelText();
    // mdLog: kept for optional debug traces
    if (!menu.is(':visible')) {
        menu.show();
        menu2.hide();
        menu3.hide();
        updateMenuStyles(true);
        updateMenuStyles2(false);
        updateMenuStyles3(false);
        // Re-prune to ensure empty options stay hidden
        if (typeof window.MD_pruneEmptyFilterOptions === 'function') window.MD_pruneEmptyFilterOptions();
    } else {
        menu.hide();
        updateMenuStyles(false);
    }
});

$('#prd-2').on('click', function () {
    normalizeFilterOptionLabelText();
    // mdLog: kept for optional debug traces
    if (!menu2.is(':visible')) {
        menu2.show();
        menu.hide();
        menu3.hide();
        updateMenuStyles2(true);
        updateMenuStyles(false);
        updateMenuStyles3(false);
        // Re-prune to ensure empty options stay hidden
        if (typeof window.MD_pruneEmptyFilterOptions === 'function') window.MD_pruneEmptyFilterOptions();
    } else {
        menu2.hide();
        updateMenuStyles2(false);
    }
});

$('#prd-3').on('click', function () {
    normalizeFilterOptionLabelText();
    // mdLog: kept for optional debug traces
    if (!menu3.is(':visible')) {
        menu3.show();
        menu.hide();
        menu2.hide();
        updateMenuStyles3(true);
        updateMenuStyles(false);
        updateMenuStyles2(false);
        // Re-prune to ensure empty options stay hidden
        if (typeof window.MD_pruneEmptyFilterOptions === 'function') window.MD_pruneEmptyFilterOptions();
    } else {
        menu3.hide();
        updateMenuStyles3(false);
    }
});


    // Keep dropdowns usable while typing:
    // - dropdown stays open while focused/typing (even if query becomes empty)
    // - checked options always remain visible
    function filterCheckboxLabels($labels, query) {
      var q = (query || '').trim().toLowerCase();
      $labels.each(function () {
        var $label = $(this);
        var text = $label.text().trim().toLowerCase();
        var checked = $label.find('input[type="checkbox"]').prop('checked') === true;
        // Never show options we pruned as "empty" (unless checked).
        var isEmpty = $label.attr('data-db-empty') === '1' || $label.hasClass('db-filter-empty');
        if (isEmpty && !checked) {
          $label.hide();
          return;
        }
        var matches = !q || text.includes(q);
        $label.toggle(checked || matches);
      });
    }

    // Prevent wrapper toggle from closing when user clicks inside the input
    $('#searchTagInput, #searchTagInput2, #searchTagInput3').on('click', function (e) {
      e.stopPropagation();
    });

    // Open the correct menu on focus into the input
    $('#searchTagInput').on('focus', function () {
      normalizeFilterOptionLabelText();
      menu.show(); menu2.hide(); menu3.hide();
    });
    $('#searchTagInput2').on('focus', function () {
      normalizeFilterOptionLabelText();
      menu2.show(); menu.hide(); menu3.hide();
    });
    $('#searchTagInput3').on('focus', function () {
      normalizeFilterOptionLabelText();
      menu3.show(); menu.hide(); menu2.hide();
    });

    // Filter Size options as user types (multi-select friendly)
    $('#searchTagInput').on('input', function () {
      var inputVal = $(this).val();
      menu.show(); menu2.hide(); menu3.hide();
      filterCheckboxLabels($('.filter-tags-checkbox-1 label'), inputVal);
    });

    // Filter Utensil options as user types (multi-select friendly)
    $('#searchTagInput2').on('input', function () {
      var inputVal = $(this).val();
      menu2.show(); menu.hide(); menu3.hide();
      filterCheckboxLabels($('.filter-tags-checkbox-2 label'), inputVal);
    });

    // Filter Type options as user types (multi-select friendly)
    $('#searchTagInput3').on('input', function () {
      var inputVal = $(this).val();
      menu3.show(); menu.hide(); menu2.hide();
      filterCheckboxLabels($('.filter-tags-checkbox-3 label'), inputVal);
    });

    // Update style on toggle
    function updateMenuStyles(isVisible) {
          // no-op (kept for backwards compatibility)

    }

      function updateMenuStyles2(isVisible) {
          // no-op (kept for backwards compatibility)
    
    }
      function updateMenuStyles3(isVisible) {
          // no-op (kept for backwards compatibility)
    }


  
  // Function to apply filters (infinite scroll - no pagination)
  // md-fit-sections-start
  // Palette fit sections. When a fit target is active — the tapped free region
  // (window.MD_spaceFit), else the whole drawer while the "Fits drawer" toggle is
  // on — modules whose footprint equals the target are pinned under an "Exact
  // fit" header and everything else that fits follows under "Also fits", largest
  // first. These helpers are pure (no DOM, no jQuery) and are evaluated verbatim by
  // tests/builder-palette-fit-sections.test.js; the DOM work is layoutFitSections().
  var mdFitSections = {
    // Region wins over the drawer; the drawer only counts while fit is ON and both
    // block counts are known. Returns { L, W, kind } or null.
    resolveTarget: function (spaceFit, gridL, gridW, fitOn) {
      if (spaceFit && Number(spaceFit.maxL) > 0 && Number(spaceFit.maxW) > 0) {
        return { L: Number(spaceFit.maxL), W: Number(spaceFit.maxW), kind: 'region' };
      }
      if (fitOn && Number(gridL) > 0 && Number(gridW) > 0) {
        return { L: Number(gridL), W: Number(gridW), kind: 'drawer' };
      }
      return null;
    },
    // 'exact' when the footprint equals the target in either orientation, 'fits'
    // when it fits inside in either orientation (modules rotate), else 'none'.
    classify: function (gl, gw, target) {
      gl = Number(gl); gw = Number(gw);
      if (!target || !(gl > 0 && gw > 0)) return 'none';
      var L = target.L, W = target.W;
      if ((gl === L && gw === W) || (gl === W && gw === L)) return 'exact';
      if ((gl <= L && gw <= W) || (gl <= W && gw <= L)) return 'fits';
      return 'none';
    },
    // Share of the target area the module covers, as a rounded whole percent.
    fillPercent: function (gl, gw, target) {
      if (!target || !(target.L * target.W > 0)) return 0;
      var pct = (Number(gl) * Number(gw)) / (target.L * target.W) * 100;
      return Math.max(0, Math.min(100, Math.round(pct)));
    },
    // Largest footprint first; ties by title, then by the catalogue order.
    sortLargestFirst: function (items) {
      return items.slice().sort(function (a, b) {
        var byArea = (Number(b.gl) * Number(b.gw)) - (Number(a.gl) * Number(a.gw));
        if (byArea !== 0) return byArea;
        var byTitle = String(a.title || '').localeCompare(String(b.title || ''));
        if (byTitle !== 0) return byTitle;
        return (Number(a.order) || 0) - (Number(b.order) || 0);
      });
    },
    // Split items into { exact, rest }, both sorted. Items that do not fit the target
    // at all (a stale layout pass) stay at the end of `rest` so nothing disappears.
    partition: function (items, target) {
      var exact = [], fits = [], none = [];
      items.forEach(function (it) {
        var c = mdFitSections.classify(it.gl, it.gw, target);
        if (c === 'exact') exact.push(it); else if (c === 'fits') fits.push(it); else none.push(it);
      });
      return {
        exact: mdFitSections.sortLargestFirst(exact),
        rest: mdFitSections.sortLargestFirst(fits).concat(mdFitSections.sortLargestFirst(none))
      };
    },
    // Whether to section the palette at all. A tapped region always does (the hint
    // row explains a miss); the whole drawer only does when some module fills it
    // exactly, so big drawers keep today's catalogue order.
    shouldSection: function (target, exactCount) {
      if (!target) return false;
      return target.kind === 'region' || Number(exactCount) > 0;
    },
    // "5×3" — same L×W wording as the fit chip.
    dimensions: function (target) { return target ? (target.L + '×' + target.W) : ''; },
    // Orientation for dropping a module into the selected region: the one that
    // fills it exactly, else the catalogue orientation when it fits, else the
    // rotated one; null when neither fits. L runs down the canvas (grid-length),
    // W across it (grid-width), matching the region's maxL/maxW.
    orientationFor: function (gl, gw, target) {
      gl = Number(gl); gw = Number(gw);
      if (!target || !(gl > 0 && gw > 0)) return null;
      var L = Number(target.L), W = Number(target.W);
      if (gl === L && gw === W) return 'default';
      if (gw === L && gl === W) return 'rotated';
      if (gl <= L && gw <= W) return 'default';
      if (gw <= L && gl <= W) return 'rotated';
      return null;
    }
  };
  // md-fit-sections-end

  // Re-order the palette into the fit sections and decorate the cards. Reads the
  // per-card flags written by applyFiltersAndPaginate() (data-db-filter-match) and
  // by drawer-builder.js's layout filter (data-layout-fits), so it can run after
  // either of them. Idempotent; restores the catalogue order when no target exists
  // or when the target is the whole drawer and nothing fills it exactly.
  function layoutFitSections() {
    var list = document.querySelector('#builder-products ul#product-show') || document.getElementById('product-show');
    if (!list) return;
    var fitOn = !document.body.classList.contains('db-fit-off');
    var target = mdFitSections.resolveTarget(
      window.MD_spaceFit || null,
      parseInt($('body').attr('grid-length'), 10) || 0,
      parseInt($('body').attr('grid-width'), 10) || 0,
      fitOn
    );
    var lis = Array.prototype.slice.call(list.querySelectorAll('li.mineProList'));
    lis.forEach(function (li, i) {
      if (!li.hasAttribute('data-db-order')) li.setAttribute('data-db-order', String(i));
    });
    var oldSections = Array.prototype.slice.call(list.querySelectorAll('li.db-palette-section'));

    // Today's palette: catalogue order, no header rows, no card decorations.
    function restoreCatalogueOrder() {
      if (list.getAttribute('data-db-fit-sorted') === '1') {
        lis.sort(function (a, b) {
          return Number(a.getAttribute('data-db-order')) - Number(b.getAttribute('data-db-order'));
        });
        var restore = document.createDocumentFragment();
        lis.forEach(function (li) { restore.appendChild(li); });
        list.appendChild(restore);
        list.removeAttribute('data-db-fit-sorted');
      }
      oldSections.forEach(function (s) { s.parentNode && s.parentNode.removeChild(s); });
      lis.forEach(function (li) { li.removeAttribute('data-db-fit'); });
    }

    if (!target) {
      restoreCatalogueOrder();
      return;
    }

    var visible = [], hidden = [];
    lis.forEach(function (li) {
      var passes = li.getAttribute('data-db-filter-match') !== '0' &&
        (!fitOn || li.getAttribute('data-layout-fits') !== 'false');
      var item = {
        el: li,
        gl: li.getAttribute('grid-length'),
        gw: li.getAttribute('grid-width'),
        title: li.getAttribute('data-title') || '',
        order: li.getAttribute('data-db-order')
      };
      (passes ? visible : hidden).push(item);
    });
    var parts = mdFitSections.partition(visible, target);
    if (!mdFitSections.shouldSection(target, parts.exact.length)) {
      restoreCatalogueOrder();
      return;
    }
    var dims = mdFitSections.dimensions(target);

    // Header rows keep their element across passes (only their text updates), so
    // an unchanged layout moves nothing: drawer-builder.js re-runs its layout
    // filter on every childList change of this list and answers with
    // drawer:layout-filter-updated, which lands back here.
    function sectionRow(kind, title, meta) {
      var li = null;
      for (var i = 0; i < oldSections.length; i++) {
        if (oldSections[i].getAttribute('data-db-section') === kind) { li = oldSections[i]; break; }
      }
      if (!li) {
        li = document.createElement('li');
        li.className = 'db-palette-section db-palette-section--' + kind;
        li.setAttribute('data-db-section', kind);
      }
      var t = li.querySelector('.db-palette-section__title');
      if (title) {
        if (!t) {
          t = document.createElement('span');
          t.className = 'db-palette-section__title';
          li.insertBefore(t, li.firstChild);
        }
        if (t.textContent !== title) t.textContent = title;
      } else if (t) {
        li.removeChild(t);
      }
      var m = li.querySelector('.db-palette-section__meta');
      if (!m) {
        m = document.createElement('span');
        m.className = 'db-palette-section__meta';
        li.appendChild(m);
      }
      if (m.textContent !== meta) m.textContent = meta;
      return li;
    }
    function decorate(item, kind, pct) {
      item.el.setAttribute('data-db-fit', kind);
      var host = item.el.querySelector('.db-card__image');
      if (!host) return;
      var badge = host.querySelector('.db-fit-badge');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'db-fit-badge';
        host.appendChild(badge);
      }
      badge.textContent = mdT('modu.builder.exact_fit_badge');
      var pctEl = host.querySelector('.db-fit-pct');
      if (!pctEl) {
        pctEl = document.createElement('span');
        pctEl.className = 'db-fit-pct';
        host.appendChild(pctEl);
      }
      pctEl.textContent = mdT('modu.builder.fills_percent', { percent: pct });
    }

    var nodes = [];
    if (parts.exact.length) {
      nodes.push(sectionRow('exact',
        mdT('modu.builder.exact_fit_heading', { dimensions: dims }),
        mdT('modu.builder.exact_fit_count', { count: parts.exact.length })));
      parts.exact.forEach(function (it) { decorate(it, 'exact', 100); nodes.push(it.el); });
      if (parts.rest.length) {
        nodes.push(sectionRow('rest',
          mdT('modu.builder.also_fits_heading'),
          mdT('modu.builder.also_fits_count', { count: parts.rest.length })));
      }
    } else if (parts.rest.length) {
      nodes.push(sectionRow('none', '',
        mdT('modu.builder.no_exact_fit', { dimensions: dims, count: parts.rest.length })));
    }
    parts.rest.forEach(function (it) {
      decorate(it, 'fits', mdFitSections.fillPercent(it.gl, it.gw, target));
      nodes.push(it.el);
    });
    hidden.forEach(function (it) { it.el.removeAttribute('data-db-fit'); nodes.push(it.el); });

    oldSections.forEach(function (s) {
      if (nodes.indexOf(s) === -1 && s.parentNode) s.parentNode.removeChild(s);
    });
    // Re-append only when the order changed. Re-appending an identical order
    // looped with drawer-builder.js's layout filter about 60 times a second while
    // a fit target was active.
    var current = Array.prototype.filter.call(list.children, function (n) {
      return n.classList.contains('mineProList') || n.classList.contains('db-palette-section');
    });
    var sameOrder = current.length === nodes.length;
    for (var k = 0; sameOrder && k < nodes.length; k++) sameOrder = current[k] === nodes[k];
    if (!sameOrder) {
      var frag = document.createDocumentFragment();
      nodes.forEach(function (node) { frag.appendChild(node); });
      list.appendChild(frag);
    }
    list.setAttribute('data-db-fit-sorted', '1');
  }

  // The whole-drawer layout filter (drawer-builder.js) runs after the grid is
  // measured and on every resize; re-lay the sections when it reports. Deferred
  // a tick and coalesced so a burst of reports lays out once, after the rail
  // has finished flipping body.db-fit-off.
  var fitSectionsTimer = 0;
  function scheduleFitSections() {
    if (fitSectionsTimer) return;
    fitSectionsTimer = setTimeout(function () {
      fitSectionsTimer = 0;
      try { layoutFitSections(); } catch (_) {}
    }, 0);
  }
  document.addEventListener('drawer:layout-filter-updated', scheduleFitSections);
  // The rail's "Fits drawer" toggle (drawer-filter-rehaul.js) flips
  // body.db-fit-off itself; watch the class so the sections follow the toggle
  // even when the layout filter has nothing new to report.
  if (window.MutationObserver && document.body) {
    var fitWasOff = document.body.classList.contains('db-fit-off');
    new MutationObserver(function () {
      var off = document.body.classList.contains('db-fit-off');
      if (off === fitWasOff) return;
      fitWasOff = off;
      scheduleFitSections();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function applyFiltersAndPaginate() {

      // Get selected filter values
      const selectedColor = $('.colorsOption span.active').data('id')?.toLowerCase() || '';
    const selectedTag = $('.dropdown-option.active').data('value')?.toString().trim().toLowerCase() || '';

      const selectedCheckboxTags = $('.filter-tags-checkbox input:checked')
          .map(function () {
              return $(this).val().toLowerCase();
          })
          .get();
    const selectedCheckboxTags2 = $('.filter-tags-checkbox-2 input:checked')
          .map(function () {
              return $(this).val().toLowerCase();
          })
          .get();
    const selectedCheckboxTags3 = $('.filter-tags-checkbox-3 input:checked')
          .map(function () {
              return $(this).val().toLowerCase();
          })
          .get();

      // Room pre-filter (set by the onboarding funnel; hidden axis, no chip).
      //
      // Data-model note: the builder grid is the `individual-modules` smart
      // collection, already scoped server-side to product_type "Kitchen", so
      // room is really a product_type / collection concern. This JS filter is a
      // lightweight complement that engages only when modules are *tagged* by
      // room (kitchen/bathroom/office) — matching the store's existing room-tag
      // convention. Robust multi-room support = per-room collections.
      //
      // Strictly fail-open: only narrow the grid when a *different* room is
      // actually present (some product tagged with a room other than the
      // selected one). This keeps it a no-op today and — crucially — prevents
      // partial tagging from hiding modules (e.g. tagging a few Kitchen modules
      // "kitchen" for SEO must NOT hide the untagged Kitchen modules).
      const selectedRoom = (window.MD_BuilderRoom
          || document.body.getAttribute('data-db-active-room') || '')
          .toString().trim().toLowerCase();
      const KNOWN_ROOMS = ['kitchen', 'bathroom', 'office'];
      let otherRoomPresent = false;
      if (selectedRoom) {
          $('.list-view-item.mineProList').each(function () {
              const tags = ($(this).attr('data-tags') || '').toString().toLowerCase()
                  .split(',').map(function (x) { return x.trim(); });
              const taggedSelected = tags.indexOf(selectedRoom) !== -1;
              const taggedOther = KNOWN_ROOMS.some(function (r) {
                  return r !== selectedRoom && tags.indexOf(r) !== -1;
              });
              if (taggedOther && !taggedSelected) { otherRoomPresent = true; return false; }
          });
      }

      // Phase 3 tap-to-fit: free rectangle (in grid blocks) of the tapped
      // empty drawer region; null when not in fit mode.
      const spaceFit = window.MD_spaceFit || null;

      // Filter products based on selected filters
      const filteredProducts = $('.list-view-item.mineProList').filter(function () {
          const productTags = $(this).data('tags') || '';
          const productTagsArray = productTags.toLowerCase().split(',');
  
          const matchesCheckbox = selectedCheckboxTags.length === 0 || selectedCheckboxTags.some(tag => productTagsArray.includes(tag));

          const matchesCheckbox2 = selectedCheckboxTags2.length === 0 || selectedCheckboxTags2.some(tag => productTagsArray.includes(tag));
          const matchesCheckbox3 = selectedCheckboxTags3.length === 0 || selectedCheckboxTags3.some(tag => productTagsArray.includes(tag));
          const matchesTag = !selectedTag || productTagsArray.includes(selectedTag);
          const matchesRoom = !selectedRoom || !otherRoomPresent || productTagsArray.includes(selectedRoom);
          const matchesHeight = tileSupportsHeight($(this), selectedModuleHeightMm(), selectedColor);
          const hasMatchingImage = $(this).find('img.product-img').filter(function () {
              return $(this).attr('class').toLowerCase().includes(selectedColor);
          }).length > 0;

          // Fit check: keep modules whose footprint fits the tapped free
          // rectangle in either orientation (modules can be rotated).
          let matchesFit = true;
          if (spaceFit) {
              const gw = parseFloat($(this).attr('grid-width')) || 0;
              const gl = parseFloat($(this).attr('grid-length')) || 0;
              matchesFit = gw > 0 && gl > 0 && (
                  (gw <= spaceFit.maxW && gl <= spaceFit.maxL) ||
                  (gl <= spaceFit.maxW && gw <= spaceFit.maxL)
              );
          }

          return matchesCheckbox && matchesCheckbox2 && matchesCheckbox3 && matchesTag && matchesRoom && matchesHeight && hasMatchingImage && matchesFit;
      });
    
  

      // Toggle Clear All button visibility
      const hasActiveFilters = selectedCheckboxTags.length > 0 ||
                               selectedCheckboxTags2.length > 0 ||
                               selectedCheckboxTags3.length > 0 ||
                               !!selectedTag ||
                               !!selectedColor ||
                               !!spaceFit;
      
      if (hasActiveFilters) {
          $('#db-clear-all-filters').addClass('is-active');
      } else {
          $('#db-clear-all-filters').removeClass('is-active');
      }

      // Infinite scroll: show all matching items
      $('.list-view-item.mineProList').hide().attr('data-db-filter-match', '0');
      filteredProducts.show().attr('data-db-filter-match', '1');

      // Pin the exact-footprint modules for the active fit target and list the
      // rest largest first (see layoutFitSections above).
      try { layoutFitSections(); } catch (_) {}
  }

  // ============================================================
  // Phase 3: tap-to-fit. Tap an empty area of the drawer canvas to
  // filter the product sheet to modules that fit the free space there,
  // then open the sheet. Reuses applyFiltersAndPaginate() (which reads
  // window.MD_spaceFit). Degrades gracefully: bails when no drawer
  // dimensions are set or the tap can't be resolved to a free cell.
  // ============================================================
  (function initTapToFit() {
    function cellPx() { return parseFloat($('.drawerBundle').attr('width')) || 0; }

    // Mark every grid block covered by a placed module as occupied.
    function buildOccupancy(gridW, gridL, cell) {
      var occ = [];
      for (var i = 0; i < gridL; i++) { occ.push(new Array(gridW).fill(false)); }
      $('.droppable-area1 .draggable-item').each(function () {
        var $it = $(this);
        var pos = $it.position() || { left: 0, top: 0 };
        var left = Math.round((pos.left || 0) / cell);
        var top = Math.round((pos.top || 0) / cell);
        var w = Math.max(1, Math.round(($it.outerWidth() || cell) / cell));
        var h = Math.max(1, Math.round(($it.outerHeight() || cell) / cell));
        for (var r = top; r < top + h && r < gridL; r++) {
          for (var c = left; c < left + w && c < gridW; c++) {
            if (r >= 0 && c >= 0) occ[r][c] = true;
          }
        }
      });
      return occ;
    }

    // Maximal free rectangle anchored at a cell, grown along dx then dy
    // (each +1 or -1), so a drag can select in any quadrant around the anchor.
    // Same greedy shape as the original right/down version: columns first,
    // then whole rows of that width.
    function freeRectDir(occ, gridW, gridL, col, row, dx, dy) {
      var maxW = 0;
      for (var c = col; c >= 0 && c < gridW && !occ[row][c]; c += dx) maxW++;
      if (maxW === 0) return null;
      var maxL = 0;
      for (var r = row; r >= 0 && r < gridL; r += dy) {
        var ok = true;
        for (var i = 0; i < maxW; i++) { if (occ[r][col + i * dx]) { ok = false; break; } }
        if (!ok) break;
        maxL++;
      }
      return { maxW: maxW, maxL: maxL };
    }

    // Maximal free rectangle anchored at the tapped cell, grown right then down.
    function freeRect(occ, gridW, gridL, col, row) {
      return freeRectDir(occ, gridW, gridL, col, row, 1, 1);
    }

    function ensureBanner() {
      var $b = $('#md-space-filter-banner');
      if ($b.length) return $b;
      $b = $(
        '<div id="md-space-filter-banner" class="md-space-filter-banner" hidden>' +
          '<span class="md-space-filter-banner__text"></span>' +
          '<button type="button" class="md-space-filter-banner__clear">&#10005;</button>' +
        '</div>'
      );
      var $host = $('.product-filter-select-wrapper').first();
      if ($host.length) { $host.before($b); } else { $('#builder-products').prepend($b); }
      $b.on('click', '.md-space-filter-banner__clear', clearFit);
      return $b;
    }

    function showBanner(fit) {
      // Compact applied-filter chip "Fits L×W", matching the expanded fit bar's
      // region cell. Length first to match module titles ("10×3 grid" = 10 long
      // × 3 wide), compact × join per the brand sizing format (§7.2).
      var dimensions = fit.maxL + '×' + fit.maxW;
      var $b = ensureBanner();
      $b.find('.md-space-filter-banner__text').text(
        mdT('modu.builder.fits_dimension', { dimensions: dimensions })
      );
      $b.find('.md-space-filter-banner__clear').attr(
        'aria-label', mdT('modu.builder.clear_space_filter', { dimensions: dimensions })
      );
      $b.removeAttr('hidden');
    }

    function clearFit() {
      window.MD_spaceFit = null;
      $('#md-space-filter-banner').attr('hidden', 'hidden');
      try { applyFiltersAndPaginate(); } catch (_) {}
      try { document.dispatchEvent(new CustomEvent('md:spacefit')); } catch (_) {}
    }
    window.MD_clearSpaceFit = clearFit;

    // Drag-to-select the free space, with a live highlight + dimensions (in grid
    // pieces) so the user sees what they're selecting BEFORE the filter applies.
    // A desktop click selects the full free rectangle at that cell. In the
    // sheet band a plain tap only deselects; a deliberate drag applies a fit.
    // Native pointer events share the gesture across mouse, touch and pen.
    var dragState = null;

    function overlayHost() {
      // Host the overlay in `.canvas-wrapper` (position:relative), NOT inside
      // `.droppable-area1`: drawer-builder.js runs a MutationObserver on the
      // canvas (attributeFilter ['style','class']) that re-filters the whole
      // product list on each mutation, so painting the overlay's inline style
      // every pointermove inside the canvas would storm it. The wrapper is the
      // canvas's offsetParent, so we can offset by the canvas's offsetLeft/Top.
      var $wrap = $('.droppable-area1').first().closest('.canvas-wrapper');
      return $wrap.length ? $wrap : $('.droppable-area1').first().parent();
    }

    function selectOverlay() {
      var $host = overlayHost();
      var $ov = $host.children('.md-fit-select-overlay');
      if (!$ov.length) {
        $ov = $('<div class="md-fit-select-overlay" hidden><span class="md-fit-select-overlay__label"></span></div>');
        $host.append($ov);
      }
      return $ov;
    }

    function paintOverlay(ds) {
      var area = $('.droppable-area1').first()[0];
      // Canvas position within the wrapper (it's centered via flex), so the
      // overlay aligns to the grid cells even though it's a sibling.
      var ox = area ? area.offsetLeft : 0;
      var oy = area ? area.offsetTop : 0;
      // The selection grows from the anchor toward the drag direction, so the
      // rect's top-left corner mirrors when dragging up/left of the anchor.
      var col0 = ds.dx === 1 ? ds.anchorCol : ds.anchorCol - (ds.selW - 1);
      var row0 = ds.dy === 1 ? ds.anchorRow : ds.anchorRow - (ds.selL - 1);
      var w = ds.selW * ds.cell;
      var h = ds.selL * ds.cell;
      var top = oy + row0 * ds.cell;
      var $ov = selectOverlay().css({
        left: (ox + col0 * ds.cell) + 'px',
        top: top + 'px',
        width: w + 'px',
        height: h + 'px'
      }).removeAttr('hidden');
      // Length first to match module titles ("10×3 grid" = 10 long × 3 wide).
      var label = $ov.children('.md-fit-select-overlay__label').text(ds.selL + '×' + ds.selW)[0];
      // When the pill can't fit inside the selection (small cells / 1-cell
      // selections), float it above the box tooltip-style so it never buries
      // the highlight or bleeds over neighbouring modules — below the box
      // when the selection touches the top of the grid.
      var out = label && (label.offsetWidth + 8 > w || label.offsetHeight + 8 > h);
      $ov.toggleClass('md-fit-select-overlay--label-out', !!out);
      $ov.toggleClass('md-fit-select-overlay--label-below', !!out && top < 30);
    }

    function cellFromPoint(clientX, clientY) {
      var area = $('.droppable-area1').first()[0];
      var cell = cellPx();
      if (!area || !cell || clientX == null || clientY == null) return null;
      var r = area.getBoundingClientRect();
      return { col: Math.floor((clientX - r.left) / cell), row: Math.floor((clientY - r.top) / cell), cell: cell };
    }

    function applyFit(fit) {
      if (!fit || fit.maxW < 1 || fit.maxL < 1) return;
      window.MD_spaceFit = fit;
      try { applyFiltersAndPaginate(); } catch (_) {}
      showBanner(fit);
      // Stamp the apply so legacy.js's click-outside collapse ignores the
      // click that follows this gesture's pointerup — without it the expand
      // below is undone within the same gesture (the click lands on
      // .grid-wrapper, which is an "outside" target on desktop).
      window.MD_lastFitApplyTime = Date.now();
      if (typeof window.MD_setSheetExpanded === 'function') {
        try { window.MD_setSheetExpanded(true, 'tap-to-fit'); } catch (_) {}
      }
      // Let the filter rehaul mirror the space filter as a rail chip.
      try { document.dispatchEvent(new CustomEvent('md:spacefit')); } catch (_) {}
    }

    document.addEventListener('pointerdown', function (e) {
      // A second contact cancels the marquee so pinch-to-zoom cannot commit it.
      if (e.isPrimary === false) { cancelDrag(); return; }
      if (e.button !== 0 || dragState) return;
      var area = e.target.closest('body.drawer-builder .droppable-area1');
      if (!area) return;
      // Only react on the empty grid background.
      if ($(e.target).closest('.draggable-item, .canvas-hoverd-item-btn-rotate, .canvas-hoverd-item-btn-remove, .canvas-hoverd-item-btn-size').length) return;
      // A press on the empty grid while a module is selected deselects it —
      // desktop's outside-click handler never clears .active, which used to
      // leave drag-select permanently blocked until the module was removed.
      // The gesture still arms below, so dragging marquee-selects right away;
      // a plain click stays a pure deselect (no surprise fit filter — see
      // the wasDeselect check on pointerup).
      var wasDeselect = false;
      if ($('.droppable-area1 .active').length) {
        wasDeselect = true;
        // Canonical deselect pair (same selector as the mobile outside-tap
        // and the remove handler): selecting a canvas module also marks its
        // .mineProList tile in the products sheet, so clear both together.
        $('.drawerBundle .list-view-item, .mineProList').removeClass('active');
        $('.canvas-hoverd-item-btn-rotate, .canvas-hoverd-item-btn-remove, .canvas-hoverd-item-btn-size').remove();
      }

      var gridW = parseInt($('body').attr('grid-width')) || 0;
      var gridL = parseInt($('body').attr('grid-length')) || 0;
      var c = cellFromPoint(e.clientX, e.clientY);
      if (!gridW || !gridL || !c) return; // dimensions not set yet
      if (c.col < 0 || c.row < 0 || c.col >= gridW || c.row >= gridL) return;

      var occ = buildOccupancy(gridW, gridL, c.cell);
      if (occ[c.row][c.col]) return; // started on an occupied cell
      var fit = freeRect(occ, gridW, gridL, c.col, c.row);
      if (!fit || fit.maxW < 1 || fit.maxL < 1) return;
      fit.col = c.col; // grown right and down, so the tapped cell is its top-left
      fit.row = c.row;

      // A press on the empty grid steals focus by default; preventDefault()
      // below suppresses that, so blur any focused field explicitly (the old
      // click path let the browser do this).
      var ae = document.activeElement;
      if (ae && $(ae).is('input, textarea, select')) { try { ae.blur(); } catch (_) {} }

      dragState = {
        pointerId: e.pointerId, area: area,
        isMobile: window.innerWidth <= MOBILE_BREAKPOINT,
        anchorCol: c.col, anchorRow: c.row,
        clickFit: fit, // full right/down free rect, applied on a plain click
        occ: occ, gridW: gridW, gridL: gridL,
        cell: c.cell, dx: 1, dy: 1, selW: 1, selL: 1, moved: false,
        wasDeselect: wasDeselect
      };
      // Nothing is painted until the pointer leaves the anchor cell (see
      // pointermove), so a plain click — jitter included — never flashes a box.
      e.preventDefault(); // avoid starting a text/native drag while sizing
      // Keep receiving the same finger's events when it leaves the grid.
      try { area.setPointerCapture(e.pointerId); } catch (_) {}
    });

    document.addEventListener('pointermove', function (e) {
      if (!dragState || e.pointerId !== dragState.pointerId) return;
      if (e.pointerType === 'mouse' && e.buttons === 0) { cancelDrag(); return; }
      var area = $('.droppable-area1').first()[0];
      if (!area) return;
      var r = area.getBoundingClientRect();
      var rawCol = Math.floor((e.clientX - r.left) / dragState.cell);
      var rawRow = Math.floor((e.clientY - r.top) / dragState.cell);
      // Drag mode arms only once the pointer actually leaves the anchor cell;
      // until then this is a plain click and nothing is painted. Once armed it
      // stays armed, so what's painted is always what pointerup will apply.
      if (rawCol !== dragState.anchorCol || rawRow !== dragState.anchorRow) dragState.moved = true;
      if (!dragState.moved) return;
      var col = Math.min(dragState.gridW - 1, Math.max(0, rawCol));
      var row = Math.min(dragState.gridL - 1, Math.max(0, rawRow));
      var dx = col >= dragState.anchorCol ? 1 : -1;
      var dy = row >= dragState.anchorRow ? 1 : -1;
      // Free rectangle from the anchor toward the drag direction, so the
      // selection grows in any quadrant but never covers a placed module.
      var dirFit = freeRectDir(dragState.occ, dragState.gridW, dragState.gridL, dragState.anchorCol, dragState.anchorRow, dx, dy);
      if (!dirFit) return;
      dragState.dx = dx;
      dragState.dy = dy;
      dragState.selW = Math.min(dirFit.maxW, Math.abs(col - dragState.anchorCol) + 1);
      dragState.selL = Math.min(dirFit.maxL, Math.abs(row - dragState.anchorRow) + 1);
      paintOverlay(dragState);
    });

    document.addEventListener('pointerup', function (e) {
      if (!dragState || e.pointerId !== dragState.pointerId || e.button !== 0) return;
      var ds = dragState;
      dragState = null;
      selectOverlay().attr('hidden', 'hidden');
      releaseCapture(ds);
      // A plain click that deselected a module is a pure deselect — applying
      // the fit filter on top would be two surprises in one click. A real
      // drag after the deselect still applies the painted selection.
      if (!ds.moved && (ds.wasDeselect || ds.isMobile)) return;
      // Dragged → the painted selection (what you see is what filters);
      // plain click → full free rectangle at that cell (old behaviour).
      // col/row keep the region's top-left cell so a palette click can place
      // the chosen module into it.
      applyFit(ds.moved ? {
        maxW: ds.selW,
        maxL: ds.selL,
        col: ds.dx === 1 ? ds.anchorCol : ds.anchorCol - (ds.selW - 1),
        row: ds.dy === 1 ? ds.anchorRow : ds.anchorRow - (ds.selL - 1)
      } : ds.clickFit);
    });

    // Cancel a drag that ends outside the document (release off-window, tab
    // switch, etc.) so the overlay can't get stuck visible and a later re-entry
    // pointermove/pointerup can't apply an unintended fit. Discard, don't apply.
    function releaseCapture(ds) {
      try {
        if (ds.area.hasPointerCapture(ds.pointerId)) ds.area.releasePointerCapture(ds.pointerId);
      } catch (_) {}
    }
    function cancelDrag() {
      if (!dragState) return;
      var ds = dragState;
      dragState = null;
      selectOverlay().attr('hidden', 'hidden');
      releaseCapture(ds);
    }
    function cancelPointer(e) {
      if (dragState && e.pointerId === dragState.pointerId) cancelDrag();
    }
    document.addEventListener('pointercancel', cancelPointer);
    document.addEventListener('lostpointercapture', cancelPointer);
    // mouseleave on document (non-bubbling) fires only when the pointer exits
    // the document boundary; blur covers tab/window switches mid-drag.
    document.addEventListener('mouseleave', cancelDrag);
    window.addEventListener('blur', cancelDrag);
    window.addEventListener('resize', cancelDrag);
  })();

  // Prevent menu from closing when clicking inside .product-filter-menu-3
// Prevent dropdowns from closing when clicked inside
$('.product-filter-menu.product-filter-size-selector,.product-filter-menu-2 , .search-and-filter-2, .product-filter-menu-3').on('click', function (e) {
  e.stopPropagation();
});


  $(document).on('click', function (e) {
  // Close if click is outside both dropdowns
  if (!$(e.target).closest('.search-and-filter').length) {
    $('.product-filter-menu').hide(); // Hides the first dropdown
  }

  if (!$(e.target).closest('.search-and-filter-2').length) {
    $('.product-filter-menu-2').hide(); // Hides the second dropdown
  }
  if (!$(e.target).closest('.search-and-filter-3').length) {
    $('.product-filter-menu-3').hide(); // Hides the second dropdown
  }
});

// NOTE: Removed duplicate toggle handler for `#prd-1/#prd-2/#prd-3`.
// Each trigger already has a dedicated click handler above; a second toggle caused double-open/close glitches.


  
  // Reapply filters when filters change (infinite scroll - no pagination)
  $('.dropdown-option, .filter-tags-checkbox input, .colorsOption span').on('change click', function () {
      // no-op: infinite scroll shows all matching items
  });

  function updateImageView(imageShow) {
    var normalizedImageShow = imageShow.toLowerCase();

    // Updated: Get selected tag from custom dropdown
    var selectedTag = $('.dropdown-option.active').data('value')?.trim().toLowerCase() || '';

    var selectedCheckboxTags = $('.filter-tags-checkbox input:checked').map(function () {
        return $(this).val().toLowerCase();
    }).get();

    $('.list-view-item.mineProList').each(function () {
        var productTags = $(this).data('tags') || '';
        var productTagsArray = productTags.toLowerCase().split(',');

        var matchesCheckbox = selectedCheckboxTags.length === 0 || selectedCheckboxTags.some(tag => productTagsArray.includes(tag));
        var matchesTag = !selectedTag || productTagsArray.includes(selectedTag);

        var hasMatchingImage = $(this).find('img.product-img').filter(function () {
            return $(this).attr('class').toLowerCase().includes(normalizedImageShow);
        }).length > 0;

        if (matchesCheckbox && matchesTag && hasMatchingImage) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });

    var imageText = $('span[data-id="' + imageShow + '"]').attr('data-text');
    $('.colorsName').html(imageText);

    $('.colorsOption span').removeClass('active');
    $('span[data-id="' + imageShow + '"]').addClass('active');

    $('#builder-products .list-view-item img').addClass('hide');
    $('.product-img').filter(function () {
        return $(this).attr('class').toLowerCase().includes(normalizedImageShow);
    }).removeClass('hide');

    if (normalizedImageShow === "white") {
        $('.product-img.crispwhite').removeClass('hide');
    }
    if (normalizedImageShow === "black") {
        $('.product-img.sharpblack').removeClass('hide');
    }

    // Infinite scroll: no pagination update needed
}


  
  // Handle color filter clicks
  $('body').on('click', '.colorsOption span', function () {
      var imageShow = $(this).attr('data-id');
      updateImageView(imageShow);
      applyHeightAvailability(selectedModuleHeightMm());
  });
  
  // Apply filters on 'Apply' button click
  $('.filter-apply').on('click', function () {
      // infinite scroll: no pagination reset needed
      var selectedColor = $('.colorsOption span.active').data('id') || '';
      
      var selectedCheckboxTags = $('.filter-tags-checkbox.filter-tags-checkbox-2 input:checked').map(function () {
          return $(this).val().toLowerCase();
      }).get();
      var selectedCheckboxTags2 = $('.filter-tags-checkbox-2 input:checked').map(function () {
          return $(this).val().toLowerCase();
      }).get();
            
      applyFiltersAndPaginate();
  });
  

 $('.filter-clear-1').on('click', function () {
    $('.filter-tags-checkbox.filter-tags-checkbox-1 input').prop('checked', false);
    // $('.colorsOption span').removeClass('active');
    $('.dropdown-label').text('Select Option');
    $('.dropdown-option').removeClass('active');

    var selectedColor = $('.colorsOption span.active').data('id') || '';
    updateImageView(selectedColor);
    applyFiltersAndPaginate();
    if (typeof window.MD_pruneEmptyFilterOptions === 'function') window.MD_pruneEmptyFilterOptions();
    $('svg.product-filter.product-filter-size').css({
           'background': 'transparent',
                'color': '#000'
        });
    updateFilterBadge(1);
});


$('.filter-clear-2').on('click', function () {
    $('.filter-tags-checkbox-2 input').prop('checked', false);
    $('.dropdown-label').text('Select Option');
    $('.dropdown-option').removeClass('active');

   var selectedColor = $('.colorsOption span.active').data('id') || '';
    updateImageView(selectedColor);
    applyFiltersAndPaginate();
    if (typeof window.MD_pruneEmptyFilterOptions === 'function') window.MD_pruneEmptyFilterOptions();
    $('svg.product-filter-2').css({
           'background': 'transparent',
                'color': '#000'
        });
    updateFilterBadge(2);
});

$('.filter-clear-3').on('click', function () {
    $('.filter-tags-checkbox-3 input').prop('checked', false);
    $('.dropdown-label').text('Select Option');
    $('.dropdown-option').removeClass('active');

    var selectedColor = $('.colorsOption span.active').data('id') || '';
    updateImageView(selectedColor);
    applyFiltersAndPaginate();
    if (typeof window.MD_pruneEmptyFilterOptions === 'function') window.MD_pruneEmptyFilterOptions();
  $('svg.product-filter-3').css({
           'background': 'transparent',
                'color': '#000'
        });
    updateFilterBadge(3);
});



// Clear All Filters button - triggers all individual filter clears
$('#db-clear-all-filters').on('click', function () {
    // Phase 3: also clear any tap-to-fit space filter + banner.
    window.MD_spaceFit = null;
    $('#md-space-filter-banner').attr('hidden', 'hidden');

    // Clear all filter checkboxes
    $('.filter-tags-checkbox input, .filter-tags-checkbox-1 input, .filter-tags-checkbox-2 input, .filter-tags-checkbox-3 input').prop('checked', false);
    
    // Reset dropdown labels
    $('.dropdown-label').text('Select Option');
    $('.dropdown-option').removeClass('active');
    
    // Reset filter icon colors
    $('svg.product-filter, svg.product-filter-2, svg.product-filter-3').css({
        'background': 'transparent',
        'color': '#000'
    });
    
    // Keep the selected color active
    var selectedColor = $('.colorsOption span.active').data('id') || '';
    updateImageView(selectedColor);
    
    // Apply filters and update badges
    applyFiltersAndPaginate();
    if (typeof window.MD_pruneEmptyFilterOptions === 'function') window.MD_pruneEmptyFilterOptions();
    updateFilterBadge(1);
    updateFilterBadge(2);
    updateFilterBadge(3);
});


// Initial check for Clear All button visibility on load
$(document).ready(function() {
    setTimeout(function() {
        var selectedCheckboxTags = $('.filter-tags-checkbox input:checked').length > 0;
        var selectedCheckboxTags2 = $('.filter-tags-checkbox-2 input:checked').length > 0;
        var selectedCheckboxTags3 = $('.filter-tags-checkbox-3 input:checked').length > 0;
        var selectedTag = $('.dropdown-option.active').length > 0;
        
        if (selectedCheckboxTags || selectedCheckboxTags2 || selectedCheckboxTags3 || selectedTag) {
            $('#db-clear-all-filters').addClass('is-active');
        }
    }, 500);
});


 $(document).on('change', '.filter-tags-checkbox input[type="checkbox"]', function () {
    var $checkbox = $(this);
    var $container = $checkbox.closest('.filter-tags-checkbox');
    var $label = $checkbox.closest('.checkbox-wrapper');
    // var $svg = $label.find('svg.product-filter.product-filter-size');

   // SVG is not inside each checkbox, it's up in .search-and-filter-3
        var $wrapper = $checkbox.closest('.search-input-with-icon');
        var $svg = $wrapper.find('svg.product-filter.product-filter-size');
    if ($checkbox.is(':checked')) {
        // Move to top
        $label.prependTo($container);
        $('svg.product-filter.product-filter-size').css({
          background: '#3F3FF8',
          color: '#fff' // This will affect paths that use `currentColor`
        });

    } else {
        // Move to bottom
        $label.appendTo($container);

      // Check if any checkbox is still checked
              var anyChecked = $container.find('input[type="checkbox"]:checked').length > 0;
      
              // Only reset style if NONE are checked
              if (!anyChecked) {
                  $('svg.product-filter.product-filter-size').css({
                      background: 'transparent',
                      color: '#000'
                  });
              }

    }

    // Reset search
    $('#searchTagInput').val('');
    // Show only non-empty labels (respect pruned state)
    $('.filter-tags-checkbox.filter-tags-checkbox-1 label').each(function() {
      var $lbl = $(this);
      var isEmpty = $lbl.attr('data-db-empty') === '1' || $lbl.hasClass('db-filter-empty');
      if (!isEmpty) $lbl.show();
    });
    
    // Update filter badge count
    updateFilterBadge(1);
    if (typeof window.MD_pruneEmptyFilterOptions === 'function') window.MD_pruneEmptyFilterOptions();
});



    $(document).on('change', '.filter-tags-checkbox-2 input[type="checkbox"]', function () {
        var $checkbox = $(this);
        var $container = $checkbox.closest('.filter-tags-checkbox-2');
        var $label = $checkbox.closest('.checkbox-wrapper');
      
        // SVG is not inside each checkbox, it's up in .search-and-filter-3
        var $wrapper = $checkbox.closest('.search-input-with-icon-2');
        var $svg = $wrapper.find('svg.product-filter-2');
      
        if ($checkbox.is(':checked')) {
            // Move the checked item to the top
            $label.prependTo($container);
           // Re-trigger search/filter
           $('svg.product-filter-2').css({
              background: '#3F3FF8',
              color: '#fff' // This will affect paths that use `currentColor`
            });
        } else {
            // Move unchecked to the bottom (optional — can be skipped if you only want to move checked up)
            $label.appendTo($container);           

            // Check if any checkbox is still checked
              var anyChecked = $container.find('input[type="checkbox"]:checked').length > 0;
      
              // Only reset style if NONE are checked
              if (!anyChecked) {
                  $('svg.product-filter-2').css({
                      background: 'transparent',
                      color: '#000'
                  });
              }
          
        }

         // Clear search input
        $('#searchTagInput2').val('');
    
        // Show only non-empty labels (respect pruned state)
        $('.filter-tags-checkbox-2 label').each(function() {
          var $lbl = $(this);
          var isEmpty = $lbl.attr('data-db-empty') === '1' || $lbl.hasClass('db-filter-empty');
          if (!isEmpty) $lbl.show();
        });
   
        // Update filter badge count
        updateFilterBadge(2);
        if (typeof window.MD_pruneEmptyFilterOptions === 'function') window.MD_pruneEmptyFilterOptions();
    });

  

$(document).on('change', '.filter-tags-checkbox-3 input[type="checkbox"]', function () {
    var $checkbox = $(this);
    var $container = $checkbox.closest('.filter-tags-checkbox-3');
    var $label = $checkbox.closest('.checkbox-wrapper');

    // SVG is not inside each checkbox, it's up in .search-and-filter-3
    var $wrapper = $checkbox.closest('.search-and-filter-3');
    var $svg = $wrapper.find('svg.product-filter-3');

    if ($checkbox.is(':checked')) {
        // Move to top
        $label.prependTo($container);

        // Apply active styles
        $svg.css({
            background: '#3F3FF8',
            color: '#fff'
        });

    } else {
        // Move to bottom
        $label.appendTo($container);

        // Check if any checkbox is still checked
        var anyChecked = $container.find('input[type="checkbox"]:checked').length > 0;

        // Only reset style if NONE are checked
        if (!anyChecked) {
            $svg.css({
                background: 'transparent',
                color: '#000'
            });
        }
    }

    // Reset search field & show only non-empty labels (respect pruned state)
    $('#searchTagInput3').val('');
    $('.filter-tags-checkbox-3 label').each(function() {
      var $lbl = $(this);
      var isEmpty = $lbl.attr('data-db-empty') === '1' || $lbl.hasClass('db-filter-empty');
      if (!isEmpty) $lbl.show();
    });
    updateFilterBadge(3);
    if (typeof window.MD_pruneEmptyFilterOptions === 'function') window.MD_pruneEmptyFilterOptions();
});  

  // NOTE: Removed duplicate `.dropdown-option` click handler (already handled earlier).

  
  $(document).ready(function () {
      $('.list-view-item.mineProList').show();
  
      const selectedColor = $('.colorsOption span.active').data('id');
      if (selectedColor) {
          updateImageView(selectedColor);
      }
  
      applyFiltersAndPaginate();
  });

  // ===== PRODUCTS PANEL EXPAND/COLLAPSE =====
  // Moved to `assets/drawer-builder-legacy.js` to avoid duplicated state handlers.
  $(document).ready(function() {
    // Canvas action buttons (Hide Grid, Clear All) - inline functionality
    $(document).on('click', '#db-hide-grid-btn', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      var $items = $('.fs-canvas__canvas.connected-sortable.droppable-area1.fsGrid .list-view-item');
      if (!$items.length) return;
      
      var $btn = $(this);
      if (!$btn.hasClass('active')) {
        // Switch all to hidden (use data-hidden for silhouette)
        $btn.addClass('active');
        $btn.find('span').text(mdT('modu.builder.show'));
        $items.each(function(){
          var hiddenUrl = $(this).attr('data-hidden') || '';
          if (hiddenUrl) { $(this).find('div').css('background-image', 'url('+hiddenUrl+')'); }
        });
      } else {
        // Restore normal images (use data-exist for the actual product image)
        $btn.removeClass('active');
        $btn.find('span').text(mdT('modu.builder.hide'));
        $items.each(function(){
          var showUrl = $(this).attr('data-exist') || '';
          if (showUrl) { $(this).find('div').css('background-image', 'url('+showUrl+')'); }
        });
      }
      log('[DrawerBuilder] Toggle hide/show grid items');
    });
    
    $(document).on('click', '#db-clear-all-btn', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Clear all items from canvas
      $('.fs-canvas__canvas li').remove();
      $('.totalPrice').text(mdFormatMoney(0));
      $('.totalPrice').attr("pricemine", '0');
      $('.mineProList').removeClass('active');
      
      // Reset hide button state
      $('#db-hide-grid-btn').removeClass('active').find('span').text(mdT('modu.builder.hide'));
      
      // Recreate URL
      if (typeof createURL === 'function') createURL();
      log('[DrawerBuilder] Canvas cleared');
    });
  });

  });

  // ---------------------------------------------------------------------
  // Thumbnail render
  //
  // Snapshot the current `.fs-canvas__canvas` to a 320 px-wide JPEG suitable
  // for embedding in the saved-build payload (~20–60 KB). We draw module
  // images via Image objects with crossOrigin="anonymous"; if a CDN response
  // taints the canvas, we fall back to colored rectangles so the thumbnail
  // is always at least recognisable.
  //
  // Returns Promise<string|null> (data URL) — never rejects.
  // ---------------------------------------------------------------------
  window.MD_renderBuildThumbnail = function () {
    return new Promise(function (resolve) {
      try {
        var $items = $('.list-view-item.draggable-item');
        var canvasEl = document.querySelector('.fs-canvas__canvas');
        if (!canvasEl) return resolve(null);
        var srcW = canvasEl.offsetWidth;
        var srcH = canvasEl.offsetHeight;
        if (!srcW || !srcH) return resolve(null);

        var THUMB_W = 320;
        var scale = THUMB_W / srcW;
        var thumbH = Math.max(80, Math.round(srcH * scale));

        var canvas = document.createElement('canvas');
        canvas.width = THUMB_W;
        canvas.height = thumbH;
        var ctx = canvas.getContext('2d');

        function background() {
          ctx.fillStyle = '#f5f4ef';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.strokeStyle = '#cdc7bd';
          ctx.lineWidth = 1;
          ctx.strokeRect(0.5, 0.5, canvas.width - 1, canvas.height - 1);
        }
        background();

        var items = [];
        $items.each(function () {
          var $i = $(this);
          items.push({
            left: parseFloat($i.css('left')) || 0,
            top: parseFloat($i.css('top')) || 0,
            width: parseFloat($i.css('width')) || 0,
            height: parseFloat($i.css('height')) || 0,
            image: $i.attr('data-exist') || null
          });
        });

        function drawRect(it) {
          ctx.fillStyle = '#cfd8e0';
          ctx.fillRect(it.left * scale, it.top * scale, it.width * scale, it.height * scale);
          ctx.strokeStyle = '#7a8a99';
          ctx.lineWidth = 1;
          ctx.strokeRect(it.left * scale, it.top * scale, it.width * scale, it.height * scale);
        }

        function safeToDataURL() {
          try { return canvas.toDataURL('image/jpeg', 0.72); }
          catch (e) { return null; }
        }

        if (!items.length) return resolve(safeToDataURL());

        var pending = items.length;
        var tainted = false;
        var settled = false;

        function done() {
          if (settled) return;
          if (--pending > 0) return;
          settled = true;
          var data = safeToDataURL();
          if (data) return resolve(data);
          // Canvas was tainted — redraw with rectangles only and try again.
          background();
          items.forEach(drawRect);
          resolve(safeToDataURL());
        }

        items.forEach(function (it) {
          if (!it.image) { drawRect(it); done(); return; }
          var img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function () {
            try {
              ctx.drawImage(img, it.left * scale, it.top * scale, it.width * scale, it.height * scale);
            } catch (_) {
              tainted = true;
              drawRect(it);
            }
            done();
          };
          img.onerror = function () { drawRect(it); done(); };
          img.src = it.image;
        });

        // Watchdog: don't block the save flow forever if a CDN hangs.
        setTimeout(function () {
          if (settled) return;
          settled = true;
          resolve(safeToDataURL());
        }, 2500);
      } catch (e) {
        resolve(null);
      }
    });
  };

  // Local reference used by the save handler. Keeping the public name on
  // window for future extensibility (e.g. the order-confirmation hook in
  // Tier 2.6 might also want a snapshot).
  function renderBuildThumbnail() {
    return window.MD_renderBuildThumbnail();
  }

});
